import { institutionBiStringsEn, institutionBiStringsFr } from './i18n-institution-bi';
import { institutionRhCompetenciesStrings } from './i18n-institution-rh-competencies';
import {
  institutionRegisterStringsEn,
  institutionRegisterStringsFr,
} from './i18n-institution-register';

/** Merged into i18n.ts — full strings: fr/en; partial overrides: es/de/it/pt/lb/uk/ru repli i18next sur `fallbackLng` (en). */
export const institutionOverlay: Record<string, Record<string, string>> = {
  fr: {
    ...institutionBiStringsFr,
    ...institutionRegisterStringsFr,
    ...institutionRhCompetenciesStrings.fr,
  "institution.flows.transferOwner": "Affecter à un autre formateur",
  "institution.flows.transferModalTitle": "Réattribuer la formation",
  "institution.flows.transferModalHint": "Le nouveau formateur devient propriétaire (tous les droits). L’ancien perd l’accès propriétaire et collaborateur sur ce parcours.",
  "institution.flows.transferPickUser": "Nouveau formateur",
  "institution.flows.transferSubmit": "Confirmer le transfert",
  "institution.flows.transferLoadingUsers": "Chargement des comptes…",
  "institution.flows.transferNoCandidates": "Aucun autre collaborateur disponible",
  "institution.flows.transferError": "Transfert impossible",
  "institution.flows.transferSuccess": "Formateur mis à jour",
  "institution.tabs.home": "Accueil",
  "institution.tabs.rhDashboard": "Pilotage RH",
  "institution.tabs.infpc": "INFPC (cofinancement)",
  "institution.infpc.title": "Demande de cofinancement INFPC",
  "institution.infpc.subtitle":
    "Téléversez le formulaire Excel officiel (ex. demande-de-cofinancement-2026.xls) et les données JSON : l’outil interroge les parcours Stratelya et remplit les onglets Signalétique, Salariés + et les onglets « Tab.* » par catégorie.",
  "institution.infpc.templateLabel": "Modèle Excel (.xls ou .xlsx)",
  "institution.infpc.templateHint": "Fichier vierge téléchargé sur lifelong-learning.lu, sans modifier la structure.",
  "institution.infpc.companyJson": "company-config (JSON)",
  "institution.infpc.employeesJson": "employees (JSON — tableau)",
  "institution.infpc.employeesHint":
    "Optionnel : une ligne par salarié (lyrraEmail = e-mail apprenant). Vous pouvez mettre [] et compléter les informations personnelles sur chaque fiche apprenant, ou coller un tableau JSON ici.",
  "institution.infpc.trainingsJson": "trainings-config (JSON — tableau)",
  "institution.infpc.allowMissing":
    "Ne pas inclure dans le fichier les apprenants inscrits sans entrée correspondante dans employees (même e-mail)",
  "institution.infpc.skipDraft": "Accepter les parcours encore en brouillon",
  "institution.infpc.generate": "Générer le fichier pré-rempli (.xlsx)",
  "institution.infpc.generating": "Génération…",
  "institution.infpc.success": "Téléchargement lancé.",
  "institution.infpc.error": "Échec de la génération",
  "institution.infpc.docLink": "Voir la spec technique (mapping, calculs, validations)",
  "institution.infpc.flowIdHint":
    "Chaque lyrraFlowId doit être un UUID. Le plus simple : choisissez un parcours ci-dessus puis « Appliquer » — ou copiez l’identifiant dans l’URL du concepteur (segment …/flows/VOTRE_UUID).",
  "institution.infpc.pickFlow": "Parcours de l’établissement",
  "institution.infpc.pickFlowPlaceholder": "— Choisir un parcours —",
  "institution.infpc.applyFlowId": "Appliquer au 1er bloc trainings-config",
  "institution.infpc.flowApplied": "UUID du parcours inséré dans le JSON (première entrée).",
  "institution.infpc.flowsLoading": "Chargement des parcours…",
  "institution.infpc.flowsEmpty": "Aucun parcours trouvé pour cet établissement — créez-en un ou vérifiez le compte.",
  "institution.infpc.mustReplacePlaceholder":
    "Remplacez l’UUID d’exemple par un parcours réel (liste ci-dessus + « Appliquer ») ou attendez le chargement des parcours.",
  "institution.infpc.flowPickerHint":
    "Évite l’erreur « parcours introuvable » : l’API n’accepte que les parcours dont le propriétaire appartient à votre établissement (liste Formations).",
  "institution.tabs.flows": "Formations",
  "institution.tabs.trash": "Corbeille",
  "institution.trash.subtitle": "Formations et podcasts supprimés logiquement — restaurez-les pour les rendre à nouveau visibles.",
  "institution.trash.loading": "Chargement…",
  "institution.trash.empty": "La corbeille est vide.",
  "institution.trash.sectionFlows": "Formations",
  "institution.trash.sectionPodcasts": "Podcasts",
  "institution.trash.restore": "Restaurer",
  "institution.trash.owner": "Formateur",
  "institution.trash.restoredFlow": "Formation restaurée.",
  "institution.trash.restoredPodcast": "Podcast restauré.",
  "institution.trash.restoreError": "Restauration impossible.",
  "institution.trash.loadError": "Impossible de charger la corbeille.",
  "institution.trash.purgeButton": "Vider la corbeille…",
  "institution.trash.purgeModalTitle": "Vider la corbeille définitivement",
  "institution.trash.purgeModalHint": "Les éléments seront supprimés sans possibilité de restauration (formations, podcasts et épisodes orphelins associés).",
  "institution.trash.purgeScopeLabel": "Périmètre",
  "institution.trash.purgeAllLabel": "Tout supprimer",
  "institution.trash.purgeAllDesc": "Retire définitivement tous les éléments actuellement dans la corbeille.",
  "institution.trash.purgeRangeLabel": "Une période",
  "institution.trash.purgeRangeDesc": "Seuls les éléments mis en corbeille entre ces dates (selon la date de suppression) seront retirés définitivement.",
  "institution.trash.purgeDateFrom": "Du",
  "institution.trash.purgeDateTo": "Au",
  "institution.trash.purgeConfirm": "Supprimer définitivement",
  "institution.trash.purgeSuccess": "Corbeille vidée.",
  "institution.trash.purgeRangeMissingDates": "Indiquez une date de début et une date de fin.",
  "institution.trash.purgeRangeOrderError": "La date de début doit être antérieure à la date de fin.",
  "institution.tabs.supports": "Podcasts",
  "institution.tabs.categories": "Catégories",
  "institution.tabs.templates": "Modèles de blocs",
  "institution.tabs.contentPipeline": "Préparation contenu",
  "institution.tabs.webinars": "Webinaires",
  "institution.tabs.webinarsPilotage": "Pilotage webinaires",
  "institution.webinars.pageTitle": "Paramètres webinaires",
  "institution.webinars.settingsIntro":
    "Activez le module et définissez le message d’attente par défaut. La liste des webinaires et les animateurs autorisés se gèrent dans l’onglet « {{tabName}} ».",
  "institution.webinars.enableForInstitution": "Activer les webinaires pour l’établissement",
  "institution.webinars.enabledBadge": "Module activé",
  "institution.webinars.disabledBadge": "Module désactivé",
  "institution.webinars.sectionModule": "Activation",
  "institution.webinars.sectionModuleHint":
    "Permet aux formateurs de l’établissement de créer et animer des sessions en direct.",
  "institution.webinars.sectionWaitingRoom": "Salle d’attente",
  "institution.webinars.waitingHtmlLabel": "HTML de salle d’attente (défaut)",
  "institution.webinars.waitingHtmlPlaceholder": "<p>Votre message d’accueil…</p>",
  "institution.webinars.waitingHtmlHint":
    "HTML simple affiché aux participants avant le début. Les couleurs suivent la charte de cet espace.",
  "institution.webinars.openPilotage": "Ouvrir le pilotage webinaires",
  "institution.webinars.waitingPreviewTitle": "Aperçu — message d’attente",
  "institution.webinars.waitingPreviewHint":
    "Rendu tel que vu par les participants avant le début du webinaire (couleurs de la charte de cet espace).",
  "institution.webinars.loadError": "Impossible de charger les paramètres webinaires.",
  "institution.webinars.saveSuccess": "Paramètres webinaires enregistrés.",
  "institution.webinars.saveError": "Enregistrement impossible.",
  "institution.tabs.scorm": "Import SCORM",
  "institution.tabs.designers": "Collaborateurs",
  "institution.tabs.learners": "Apprenants",
  "institution.tabs.learnerAnalytics": "Analyse apprenants",
  "institution.tabs.biStudio": "Tableaux BI",
  "institution.tabs.groups": "Groupes",
  "institution.tabs.services": "Services",
  "institution.tabs.sirh": "SIRH (API)",
  "institution.tabs.branding": "Personnalisation",
  "institution.tabs.landing": "Page publique",
  "institution.tabs.webhooks": "Webhooks",
  "institution.tabs.ssoOidc": "SSO (OpenID Connect & SAML)",
  "institution.tabs.xapi": "xAPI (LRS)",
  "institution.tabs.mcp": "MCP",
  "institution.tabs.billing": "Facturation",
  "institution.nav.section.general": "Général",
  "institution.nav.section.content": "Contenu & formations",
  "institution.nav.section.people": "Équipes & apprenants",
  "institution.nav.section.portal": "Portail & image",
  "institution.nav.section.integrations": "Intégrations",
  "institution.nav.section.subscription": "Abonnement",
  "institution.nav.section.rhTools": "Formation & RH",
  "institution.rhNav.campaigns": "Campagnes",
  "institution.rhNav.codir": "Tableau CODIR",
  "institution.rhNav.catalog": "Catalogue",
  "institution.rhNav.competencies": "Compétences",
  "institution.rhNav.compliance": "Conformité",
  "institution.rhNav.requests": "Demandes & workflows",
  "institution.sidebar.subtitle": "Établissement",
  "institution.sidebar.subtitleRh": "Espace RH",
  "institution.sidebar.subtitleAdmin": "Administration",
  "institution.sidebar.logout": "Déconnexion",
  "institution.sidebar.collapse": "Réduire le menu",
  "institution.sidebar.expandAria": "Agrandir la barre latérale",
  "institution.sidebar.collapseAria": "Réduire la barre latérale",
  "institution.sidebar.language": "Langue",
  "institution.sidebar.languageAria": "Changer la langue",
  "institution.header.workspace": "Espace établissement",
  "institution.common.cancel": "Annuler",
  "institution.common.save": "Enregistrer",
  "institution.common.saving": "Enregistrement…",
  "institution.common.delete": "Supprimer",
  "institution.common.edit": "Modifier",
  "institution.common.create": "Créer",
  "institution.common.add": "Ajouter",
  "institution.common.retry": "Réessayer",
  "institution.common.refresh": "Actualiser",
  "institution.common.search": "Rechercher…",
  "institution.common.loading": "Chargement…",
  "institution.common.page": "Page",
  "institution.common.of": "sur",
  "institution.common.name": "Nom",
  "institution.common.description": "Description",
  "institution.common.email": "Email",
  "institution.common.member": "Membre",
  "institution.common.members": "Membres",
  "institution.common.back": "Retour",
  "institution.common.view": "Voir",
  "institution.common.duplicate": "Dupliquer",
  "institution.common.toggleStatus": "Activer/Désactiver",
  "institution.common.author": "Auteur",
  "institution.common.title": "Titre",
  "institution.common.status": "Statut",
  "institution.common.type": "Type",
  "institution.common.actions": "Actions",
  "institution.common.createdAt": "Créé le",
  "institution.common.assignedTo": "Assigné à",
  "institution.common.completion": "Complétion",
  "institution.common.learners": "Apprenants",
  "institution.common.empty": "—",
  "institution.status.draft": "Brouillon",
  "institution.status.published": "Publié",
  "institution.status.archived": "Archivé",
  "institution.status.allStatuses": "Tous les statuts",
  "institution.status.allTypes": "Tous les types",
  "institution.dashboard.loading": "Chargement du dashboard…",
  "institution.dashboard.loadError": "Impossible de charger le dashboard.",
  "institution.dashboard.activity.completion": "Terminaison",
  "institution.dashboard.activity.enrollment": "Inscription",
  "institution.dashboard.activity.milestone": "Jalon",
  "institution.dashboard.activity.feedback": "Retour",
  "institution.dashboard.activity.start": "Démarrage",
  "institution.dashboard.activity.1": "Marie Dupont a terminé « UX Fundamentals »",
  "institution.dashboard.activity.2": "12 nouveaux apprenants inscrits à « Design Thinking »",
  "institution.dashboard.activity.3": "Le groupe « Cohorte T3 » a atteint 80 % de complétion",
  "institution.dashboard.activity.4": "L’enquête NPS a reçu 24 nouvelles réponses",
  "institution.dashboard.activity.5": "Jean Martin a démarré « Méthodes agiles »",
  "institution.dashboard.time.5m": "Il y a 5 min",
  "institution.dashboard.time.1h": "Il y a 1 h",
  "institution.dashboard.time.3h": "Il y a 3 h",
  "institution.dashboard.time.5h": "Il y a 5 h",
  "institution.dashboard.time.6h": "Il y a 6 h",
  "institution.dashboard.activity.flowCompleted": "{{name}} a terminé « {{flow}} »",
  "institution.dashboard.activity.participantJoined": "Apprenant enregistré : {{email}}",
  "institution.dashboard.activity.flowStarted": "{{name}} a démarré « {{flow}} »",
  "institution.dashboard.chartTopFlowsEmpty": "Pas encore assez de données. Publiez des formations et invitez des apprenants.",
  "institution.dashboard.activityEmpty": "Aucune activité récente.",
  "institution.dashboard.home.greeting": "Bonjour, {{name}}",
  "institution.dashboard.home.greetingSubtitle": "Vue d’ensemble de votre établissement — formations, apprenants et activité récente.",
  "institution.dashboard.home.defaultName": "équipe",
  "institution.dashboard.home.primaryCta": "Gérer les formations",
  "institution.dashboard.home.secondaryCta": "Voir les apprenants",
  "institution.dashboard.home.completionRate": "Taux de complétion",
  "institution.dashboard.home.quickAccess": "Accès rapides",
  "institution.dashboard.home.viewAllActivity": "Toute l’activité",
  "institution.dashboard.home.calendarKicker": "Activité du mois",
  "institution.dashboard.home.alertNotStarted": "{{count}} inscription(s) non démarrée(s)",
  "institution.dashboard.home.alertStalled": "{{count}} progression(s) en pause",
  "institution.dashboard.home.topFlows": "Formations les plus suivies",
  "institution.dashboard.home.topFlowsHint": "Taux de complétion par parcours sur la période.",
  "institution.dashboard.home.periodLabel": "Période",
  "institution.groups.title": "Gestion des groupes",
  "institution.groups.countShown": "{{count}} groupe(s)",
  "institution.groups.subtitle": "{{count}} groupe(s) dans votre établissement",
  "institution.groups.create": "Créer un groupe",
  "institution.groups.statGroups": "Groupes",
  "institution.groups.statTotalMembers": "Membres total",
  "institution.groups.statEmpty": "Groupes vides",
  "institution.groups.loadError": "Impossible de charger les groupes.",
  "institution.groups.searchPh": "Rechercher un groupe…",
  "institution.groups.colGroup": "Groupe",
  "institution.groups.colCreated": "Créé le",
  "institution.groups.memberCount": "{{count}} membre(s)",
  "institution.groups.emptyNone": "Aucun groupe. Créez votre premier groupe.",
  "institution.groups.emptyFilter": "Aucun groupe ne correspond à la recherche.",
  "institution.groups.backList": "Retour aux groupes",
  "institution.groups.addLearner": "Ajouter un apprenant",
  "institution.groups.dateCreated": "Date de création",
  "institution.groups.colMember": "Membre",
  "institution.groups.colAdded": "Ajouté le",
  "institution.groups.noMembers": "Aucun membre dans ce groupe",
  "institution.groups.loadGroupError": "Impossible de charger le groupe",
  "institution.groups.panelTitle": "Ajouter des apprenants",
  "institution.groups.noLearnersAvailable": "Aucun apprenant disponible",
  "institution.groups.noResults": "Aucun résultat",
  "institution.groups.modalEdit": "Modifier le groupe",
  "institution.groups.modalCreate": "Créer un groupe",
  "institution.groups.groupName": "Nom du groupe",
  "institution.groups.removeFromGroup": "Retirer du groupe",
  "institution.services.title": "Services entreprise",
  "institution.services.subtitle":
    "Référentiel des services (RH, Finance, etc.). Les apprenants y sont affectés depuis la fiche apprenant.",
  "institution.services.create": "Nouveau service",
  "institution.services.loadError": "Impossible de charger les services.",
  "institution.services.empty": "Aucun service. Créez-en pour les proposer à l’affectation des apprenants.",
  "institution.services.modalCreate": "Créer un service",
  "institution.services.modalEdit": "Modifier le service",
  "institution.services.fieldName": "Nom du service",
  "institution.services.deleteConfirm": "Supprimer ce service ? Les comptes apprenants rattachés n’auront plus de service (l’affectation sera retirée).",
  "institution.services.listSubtitle": "{{count}} service(s) dans votre établissement",
  "institution.services.intro":
    "Référentiel des services (RH, Finance, etc.). Les apprenants y sont affectés depuis la fiche apprenant.",
  "institution.services.statTotal": "Services",
  "institution.services.statWithDesc": "Avec description",
  "institution.services.statNoDesc": "Sans description",
  "institution.services.searchPh": "Rechercher un service…",
  "institution.services.colService": "Service",
  "institution.services.colCreated": "Créé le",
  "institution.services.emptyNone": "Aucun service. Créez votre premier service.",
  "institution.services.emptyFilter": "Aucun service ne correspond à la recherche.",
  "institution.services.countShown": "{{count}} service(s)",
  "institution.flows.title": "Formations",
  "institution.flows.subtitle": "Gérez vos formations",
  "institution.flows.statTotal": "Total formations",
  "institution.flows.statPublished": "Publiés",
  "institution.flows.statLearners": "Total apprenants",
  "institution.flows.searchPh": "Rechercher une formation…",
  "institution.flows.colName": "Nom",
  "institution.flows.empty": "Aucune formation trouvée",
  "institution.flows.badgeEnterprise": "Besoin entreprise",
  "institution.flows.deleteEnterpriseTooltip": "Mettre en corbeille (besoin entreprise)",
  "institution.flows.deleteEnterpriseTitle": "Retirer la formation « besoin entreprise » ?",
  "institution.flows.deleteEnterpriseHint": "Le parcours sera mis en corbeille (suppression logique). Les formateurs ne peuvent pas effectuer cette action ; seuls l’administrateur d’établissement, le DRH ou la RH peuvent la restaurer ou la retirer depuis ce tableau.",
  "institution.flows.deleteEnterpriseConfirm": "Mettre en corbeille",
  "institution.flows.deleteEnterpriseSuccess": "Formation mise en corbeille.",
  "institution.flows.deleteEnterpriseError": "Action impossible.",
  "institution.learningPaths.sectionTitle": "Parcours de formation (learning paths)",
  "institution.learningPaths.sectionSubtitle": "Parcours dont le créateur appartient à votre établissement.",
  "institution.learningPaths.searchPh": "Rechercher un parcours…",
  "institution.learningPaths.colItems": "Contenus",
  "institution.learningPaths.colAssignments": "Assignations",
  "institution.learningPaths.transferOwner": "Réattribuer le propriétaire",
  "institution.learningPaths.transferModalTitle": "Changer le propriétaire du parcours",
  "institution.learningPaths.transferModalHint":
    "Le nouveau compte devient propriétaire ; les médias de médiathèque référencés (ex. couverture) suivent lorsque c’est traçable en base.",
  "institution.learningPaths.transferPickUser": "Nouveau propriétaire",
  "institution.learningPaths.transferSubmit": "Confirmer le transfert",
  "institution.learningPaths.transferLoadingUsers": "Chargement des comptes…",
  "institution.learningPaths.transferNoCandidates": "Aucun autre collaborateur disponible",
  "institution.learningPaths.transferError": "Transfert impossible",
  "institution.learningPaths.transferSuccess": "Propriétaire mis à jour",
  "institution.learningPaths.empty": "Aucun parcours trouvé",
  "institution.supports.title": "Podcasts",
  "institution.supports.subtitle": "Podcasts et contenus audio",
  "institution.supports.searchPh": "Rechercher un podcast…",
  "institution.supports.empty": "Aucun podcast trouvé",
  "institution.supports.typeDictation": "Dictée",
  "institution.supports.typeText": "Texte",
  "institution.supports.typeAi": "IA",
  "institution.supports.typePodcast": "Podcast",
  "institution.supports.allProductionStatuses": "Tous les statuts",
  "institution.supports.colKind": "Type",
  "institution.supports.colEpisodes": "Épisodes",
  "institution.supports.colProducer": "Producteur",
  "institution.supports.colCreator": "Créé par",
  "institution.supports.loadError": "Impossible de charger les podcasts.",
  "institution.supports.transferOwner": "Réattribuer le créateur du podcast",
  "institution.supports.transferModalTitle": "Changer le propriétaire du podcast",
  "institution.supports.transferModalHint":
    "Le nouveau compte devient créateur du podcast ; les épisodes et médias de médiathèque référencés suivent lorsque c’est traçable en base.",
  "institution.supports.transferPickUser": "Nouveau créateur",
  "institution.supports.transferSubmit": "Confirmer le transfert",
  "institution.supports.transferLoadingUsers": "Chargement des comptes…",
  "institution.supports.transferNoCandidates": "Aucun autre collaborateur disponible",
  "institution.supports.transferError": "Transfert impossible",
  "institution.supports.transferSuccess": "Créateur mis à jour",
  "institution.supports.previewError": "Impossible d’ouvrir l’aperçu du podcast.",
  "institution.podcastProduction.shell": "Coquille",
  "institution.podcastProduction.assigned": "Assigné",
  "institution.podcastProduction.in_production": "En production",
  "institution.podcastProduction.ready": "Prêt",
  "institution.categories.title": "Catégories",
  "institution.categories.subtitle": "Organisez vos formations par thématique",
  "institution.categories.add": "Ajouter",
  "institution.categories.edit": "Modifier la catégorie",
  "institution.categories.new": "Nouvelle catégorie",
  "institution.categories.usage": "{{count}} formation(s)",
  "institution.categories.pageSubtitle": "Organisez vos contenus par catégorie",
  "institution.categories.namePlaceholder": "Nom de la catégorie",
  "institution.categories.color": "Couleur",
  "institution.categories.descShortPh": "Description courte",
  "institution.categories.usageTimes": "({{count}} utilisations)",
  "institution.templates.title": "Modèles de blocs",
  "institution.templates.subtitle": "Bibliothèque de modèles réutilisables",
  "institution.templates.statTotal": "Modèles",
  "institution.templates.statUsage": "Utilisations totales",
  "institution.templates.mostUsed": "Type le plus utilisé",
  "institution.templates.preview": "Aperçu",
  "institution.templates.searchPh": "Rechercher un modèle…",
  "institution.templates.copySuffix": " (copie)",
  "institution.templates.empty": "Aucun modèle trouvé",
  "institution.templates.loadFormatError": "Impossible de lire les modèles (réponse serveur invalide).",
  "institution.templates.usesShort": "{{count}} utilisations",
  "institution.templates.filterAll": "Tous les types",
  "institution.blockTypes.text": "Texte",
  "institution.blockTypes.quiz": "Quiz",
  "institution.blockTypes.video": "Vidéo",
  "institution.blockTypes.audio": "Audio",
  "institution.blockTypes.image": "Image",
  "institution.blockTypes.document": "Document",
  "institution.blockTypes.code": "Code",
  "institution.blockTypes.discussion": "Discussion",
  "institution.scorm.title": "Import SCORM",
  "institution.scorm.subtitle": "Importez des paquets SCORM 1.2 ou 2004",
  "institution.scorm.dropHere": "Glissez-déposez votre fichier SCORM (.zip) ici",
  "institution.scorm.browseHint": "ou cliquez pour parcourir",
  "institution.scorm.selectedFile": "Fichier sélectionné : {{name}}",
  "institution.scorm.startImport": "Lancer l'import",
  "institution.scorm.importingNamed": "Import en cours : {{name}}",
  "institution.scorm.analyzing": "Analyse des modules… {{pct}}%",
  "institution.scorm.historyTitle": "Historique des imports",
  "institution.scorm.colFile": "Fichier",
  "institution.scorm.colDate": "Date",
  "institution.scorm.colStatus": "Statut",
  "institution.scorm.colModules": "Modules",
  "institution.scorm.colVersion": "Version",
  "institution.scorm.colFlow": "Formation",
  "institution.scorm.empty": "Aucun import pour le moment. Déposez un fichier .zip SCORM ci-dessus.",
  "institution.scorm.openFlow": "Ouvrir",
  "institution.scorm.statusImporting": "Import en cours…",
  "institution.scorm.statusSuccess": "Succès",
  "institution.scorm.statusError": "Erreur",
  "institution.designers.title": "Collaborateurs",
  "institution.designers.subtitle": "Formateurs, DRH, RH et administrateurs de votre établissement (plus d’intitulé « enseignant »).",
  "institution.designers.invite": "Inviter",
  "institution.designers.statTotal": "Total collaborateurs",
  "institution.designers.statActiveMonth": "Actifs ce mois",
  "institution.designers.statFlows": "Formations créées (cumul)",
  "institution.designers.inviteTitle": "Inviter un collaborateur",
  "institution.designers.inviteHelp": "Choisissez le rôle : Formateur (contenus / formations), DRH, RH, ou Admin (administrateur de l’établissement sur Lyrra).",
  "institution.designers.emailPh": "adresse@email.com",
  "institution.designers.sendInvite": "Envoyer l'invitation",
  "institution.designers.loadError": "Impossible de charger les collaborateurs",
  "institution.designers.inviteFail": "Échec de l'invitation",
  "institution.designers.actionFail": "Action impossible",
  "institution.designers.searchPh": "Rechercher par nom ou email…",
  "institution.designers.colName": "Nom",
  "institution.designers.colEmail": "Email",
  "institution.designers.colRole": "Rôle",
  "institution.designers.colProjects": "Projets",
  "institution.designers.colLastActivity": "Dernière activité",
  "institution.designers.colStatus": "Statut",
  "institution.designers.colActions": "Actions",
  "institution.designers.empty": "Aucun collaborateur trouvé",
  "institution.designers.roleAdmin": "Admin",
  "institution.designers.roleTeacher": "Formateur",
  "institution.designers.roleTrainingLead": "Resp. formation",
  "institution.designers.roleCollaborator": "Collaborateur",
  "institution.designers.roleOptFormateur": "Formateur",
  "institution.designers.roleOptDrh": "DRH",
  "institution.designers.roleOptRh": "RH",
  "institution.designers.roleOptAdmin": "Admin",
  "institution.designers.statusActive": "Actif",
  "institution.designers.statusInvited": "Invité",
  "institution.designers.statusSuspended": "Suspendu",
  "institution.designers.menuView": "Voir le profil",
  "institution.designers.menuMakeAdmin": "Rendre admin",
  "institution.designers.menuSuspend": "Suspendre",
  "institution.designers.menuRemove": "Retirer",
  "institution.designers.noLinkedLearner": "Aucun profil apprenant lié trouvé pour cet email.",
  "institution.designers.createLinkedLearner": "Créer la fiche apprenant",
  "institution.designers.creatingLinkedLearner": "Création…",
  "institution.designers.createLinkedLearnerFail": "Impossible de créer la fiche apprenant",
  "institution.billing.title": "Facturation",
  "institution.billing.subtitle": "Abonnement, consommation et factures",
  "institution.billing.planLabel": "Plan actuel",
  "institution.billing.planPro": "Pro",
  "institution.billing.priceExample": "299 €",
  "institution.billing.perMonth": "/ mois",
  "institution.billing.renewalMock": "Renouvellement le 1er février 2025",
  "institution.billing.featureCollaborators": "10 collaborateurs",
  "institution.billing.featureLearners": "500 apprenants",
  "institution.billing.featureStorage": "50 Go stockage",
  "institution.billing.featureSupport": "Support prioritaire",
  "institution.billing.featureApi": "API MCP",
  "institution.billing.changePlan": "Changer de plan",
  "institution.billing.usageCollaborators": "Collaborateurs",
  "institution.billing.usageLearners": "Apprenants",
  "institution.billing.usageStorage": "Stockage",
  "institution.billing.storageUnit": "Go",
  "institution.billing.cardMasked": "Carte Visa •••• 4242",
  "institution.billing.cardExpires": "Expire le {{date}}",
  "institution.billing.invoicesTitle": "Factures",
  "institution.billing.colRef": "Référence",
  "institution.billing.colDate": "Date",
  "institution.billing.colAmount": "Montant",
  "institution.billing.colStatus": "Statut",
  "institution.billing.colPdf": "PDF",
  "institution.billing.invPaid": "Payée",
  "institution.billing.invOpen": "En attente",
  "institution.billing.invDraft": "Brouillon",
  "institution.billing.invVoid": "Annulée",
  "institution.billing.invUncollectible": "Impayée",
  "institution.mcp.title": "MCP — Model Context Protocol",
  "institution.landing.designerTitle": "Designer de page",
  "institution.learners.title": "Apprenants",
  "institution.learners.searchPh": "Rechercher un apprenant…",
  "institution.learners.filterStatus": "Statut",
  "institution.learners.filterPlaceholder": "Filtrer",
  "institution.learners.selectedCount": "{{count}} sélectionné(s)",
  "institution.learners.exportSelection": "Exporter la sélection",
  "institution.learners.exportAll": "Exporter tout",
  "institution.learners.colLearner": "Apprenant",
  "institution.learners.colGroup": "Groupe",
  "institution.learners.colLastActive": "Dernière activité",
  "institution.learners.colStatus": "Statut",
  "institution.learners.empty": "Aucun apprenant trouvé",
  "institution.learners.countList": "{{count}} apprenant(s)",
  "institution.learners.subtitle": "{{count}} apprenant(s) inscrits dans votre établissement",
  "institution.learners.importCsv": "Import CSV",
  "institution.learners.add": "Ajouter",
  "institution.learners.addModalTitle": "Nouvel apprenant",
  "institution.learners.addModalHint":
    "Crée la fiche dans votre établissement. Si l’e-mail n’a pas encore de compte Stratelya, un message permet de définir le mot de passe.",
  "institution.learners.addEmail": "E-mail",
  "institution.learners.addSendInvitation": "Envoyer l’e-mail d’invitation (nouveau compte uniquement)",
  "institution.learners.addSubmit": "Créer",
  "institution.learners.addError": "Impossible de créer l’apprenant",
  "institution.learners.statLearners": "Apprenants",
  "institution.learners.statActive30": "Actifs (30j)",
  "institution.learners.statEnrollments": "Inscriptions",
  "institution.learners.statCompleted": "Formations terminées",
  "institution.learners.statusAll": "Tous les statuts",
  "institution.learners.statusActive": "Actif",
  "institution.learners.statusInactive": "Inactif",
  "institution.learners.statusCompleted": "Terminé",
  "institution.learners.sheetTitle": "Fiche apprenant",
  "institution.learners.openProfileDetail": "Détail du profil",
  "institution.learners.groupsCatalogTitle": "Groupes paramétrés",
  "institution.learners.groupsCatalogSubtitle": "Liste définie dans l’onglet « Groupes » de votre établissement.",
  "institution.learners.replacePhoto": "Remplacer",
  "institution.learners.addPhoto": "Ajouter une photo",
  "institution.learners.removePhoto": "Supprimer",
  "institution.learners.firstName": "Prénom",
  "institution.learners.lastName": "Nom",
  "institution.learners.save": "Enregistrer",
  "institution.learners.deactivate": "Désactiver",
  "institution.learners.reactivate": "Réactiver",
  "institution.learners.lastActivity": "Dernière activité :",
  "institution.learners.paths": "Parcours ({{count}})",
  "institution.learners.noPaths": "Aucun parcours assigné",
  "institution.learners.noFlowsEnrolled": "Aucune formation inscrite",
  "institution.learners.done": "Terminé",
  "institution.learners.inProgress": "En cours",
  "institution.learners.itemsProgress": "{{done}}/{{total}} contenus",
  "institution.learners.flows": "Formations",
  "institution.learners.completedF": "Terminées",
  "institution.learners.totalTime": "Temps total",
  "institution.learners.progress": "Progression",
  "institution.learners.flowDone": "Terminée",
  "institution.learners.blocks": "{{visited}}/{{total}} blocs",
  "institution.learners.score": "Score : {{score}}%",
  "institution.learners.sessions": "{{count}} sessions",
  "institution.learners.started": "Début :",
  "institution.learners.ended": "Fin :",
  "institution.learners.lastAccess": "Dernier accès :",
  "institution.learners.podcasts": "Podcasts",
  "institution.learners.noPodcastListen": "Aucune écoute enregistrée",
  "institution.learners.deleteTitle": "Supprimer cet apprenant ?",
  "institution.learners.deleteDesc": "Êtes-vous sûr de vouloir supprimer définitivement {{name}} ({{email}}) ? Cette action est irréversible et supprimera toutes ses données associées.",
  "institution.learners.deactivateTitle": "Désactiver cet apprenant ?",
  "institution.learners.reactivateTitle": "Réactiver cet apprenant ?",
  "institution.learners.deactivateDesc": "{{name}} ne pourra plus accéder aux formations tant qu’il sera désactivé.",
  "institution.learners.reactivateDesc": "{{name}} retrouvera l’accès à ses formations.",
  "institution.learners.deleteLearner": "Supprimer cet apprenant",
  "institution.learners.photoUploadError": "Erreur lors de l’upload de la photo",
  "institution.learners.photoRemoveError": "Erreur lors de la suppression",
  "institution.learners.service": "Service",
  "institution.learners.serviceHint": "Choisissez une entrée du référentiel (onglet Services). Tapez pour filtrer la liste.",
  "institution.learners.serviceSearch": "Rechercher un service…",
  "institution.learners.serviceNone": "Aucun service",
  "institution.learners.infpc.sectionTitle": "Informations personnelles",
  "institution.learners.infpc.sectionHint":
    "Compléments utiles pour les démarches administratives et les déclarations liées à la formation (champs facultatifs selon les cas).",
  "institution.learners.infpc.gender": "Genre",
  "institution.learners.infpc.genderPlaceholder": "—",
  "institution.learners.infpc.genderM": "Masculin",
  "institution.learners.infpc.genderF": "Féminin",
  "institution.learners.infpc.csp": "Catégorie socioprofessionnelle",
  "institution.learners.infpc.cspPlaceholder": "— Choisir —",
  "institution.learners.infpc.csp.manual_worker": "Ouvrier",
  "institution.learners.infpc.csp.employee": "Employé",
  "institution.learners.infpc.csp.technician": "Technicien",
  "institution.learners.infpc.csp.supervisor": "Agent de maîtrise",
  "institution.learners.infpc.csp.executive": "Cadre",
  "institution.learners.infpc.csp.director": "Dirigeant",
  "institution.learners.infpc.hasDiploma": "Diplôme (niveau requis)",
  "institution.learners.infpc.seniority": "Ancienneté (années)",
  "institution.learners.infpc.age": "Âge",
  "institution.learners.infpc.salariePlus": "Salarié +",
  "institution.learners.infpc.salariePlusType": "Type Salarié +",
  "institution.learners.infpc.salariePlusTypePlaceholder": "—",
  "institution.learners.infpc.salariePlusType1": "Type 1 (jeune / sans diplôme requis)",
  "institution.learners.infpc.salariePlusType2": "Type 2",
  "institution.learners.infpc.hireDate": "Date d’embauche (JJ/MM/AAAA)",
  "institution.learners.infpc.birthDate": "Date de naissance (JJ/MM/AAAA)",
  "institution.learners.infpc.save": "Enregistrer les informations",
  "institution.learners.infpc.saved": "Informations enregistrées.",
  "institution.learners.exportSheetLearners": "Apprenants",
  "institution.learners.exportSheetDetails": "Détails formations",
  "institution.learners.export.firstName": "Prénom",
  "institution.learners.export.lastName": "Nom",
  "institution.learners.export.groupCol": "Groupe",
  "institution.learners.export.enrollments": "Formations inscrites",
  "institution.learners.export.completed": "Formations terminées",
  "institution.learners.export.progressPct": "Progression (%)",
  "institution.learners.export.totalMin": "Temps total (min)",
  "institution.learners.export.lastAct": "Dernière activité",
  "institution.learners.export.statusCol": "Statut",
  "institution.learners.export.learnerCol": "Apprenant",
  "institution.learners.export.typeCol": "Type",
  "institution.learners.export.titleCol": "Titre",
  "institution.learners.export.blocks": "Blocs visités / Total",
  "institution.learners.export.sessionsDone": "Sessions terminées",
  "institution.learners.export.avgScore": "Score moyen (%)",
  "institution.learners.export.timeMin": "Temps passé (min)",
  "institution.learners.export.dateStart": "Date début",
  "institution.learners.export.dateEnd": "Date fin",
  "institution.learners.export.lastAcc": "Dernier accès",
  "institution.learners.export.typeCourse": "Formation",
  "institution.learners.export.typePath": "Parcours",
  "institution.reminders.openPanel": "Rappels e-mail",
  "institution.reminders.panelTitle": "Rappels",
  "institution.reminders.panelSubtitle":
    "Alertes automatiques envoyées aux apprenants concernés. Vérification planifiée chaque heure (heure UTC choisie). Un même rappel n’est envoyé qu’une fois par apprenant et par règle.",
  "institution.reminders.sectionRules": "Règles",
  "institution.reminders.sectionLogs": "Journal d’envoi",
  "institution.reminders.addRule": "Ajouter une alerte",
  "institution.reminders.removeRule": "Supprimer cette alerte",
  "institution.reminders.save": "Enregistrer les règles",
  "institution.reminders.loadError": "Impossible de charger les rappels.",
  "institution.reminders.saveError": "Enregistrement impossible.",
  "institution.reminders.rulesEmpty": "Aucune alerte. Ajoutez une règle, ou enregistrez une liste vide pour désactiver tous les rappels sur ce contenu.",
  "institution.reminders.logsEmpty": "Aucun envoi enregistré pour l’instant.",
  "institution.reminders.utcHint":
    "Choisissez l’heure UTC à laquelle le serveur évalue cette règle (0–23). Ex. 8 UTC ≈ 9h hiver Paris.",
  "institution.reminders.fieldKind": "Type d’alerte",
  "institution.reminders.fieldDays": "Jours après l’événement",
  "institution.reminders.fieldHourUtc": "Heure de contrôle (UTC)",
  "institution.reminders.fieldEnabled": "Activer cette alerte",
  "institution.reminders.fieldLabel": "Libellé interne (optionnel)",
  "institution.reminders.fieldLabelPh": "ex. Relance J+3",
  "institution.reminders.ruleKind.eduflow_not_started_days_after_enroll":
    "Formation : pas commencée X jours après inscription (création participant)",
  "institution.reminders.ruleKind.eduflow_incomplete_days_after_deadline":
    "Formation : non terminée X jours après la date limite du parcours (deadline)",
  "institution.reminders.ruleKind.path_incomplete_days_after_assign":
    "Parcours : non terminé X jours après assignation à l’apprenant",
  "institution.pages.brandingTitle": "Identité visuelle",
  "institution.pages.webhooksTitle": "Webhooks",
  "institution.pages.landingTitle": "Page publique",
  },
  en: {
    ...institutionBiStringsEn,
    ...institutionRegisterStringsEn,
    ...institutionRhCompetenciesStrings.en,
  "institution.flows.transferOwner": "Change trainer",
  "institution.flows.transferModalTitle": "Reassign course",
  "institution.flows.transferModalHint": "The new trainer becomes the owner (full rights). The previous owner loses owner and collaborator access to this course.",
  "institution.flows.transferPickUser": "New trainer",
  "institution.flows.transferSubmit": "Confirm transfer",
  "institution.flows.transferLoadingUsers": "Loading accounts…",
  "institution.flows.transferNoCandidates": "No other collaborator available",
  "institution.flows.transferError": "Transfer failed",
  "institution.flows.transferSuccess": "Trainer updated",
  "institution.tabs.home": "Home",
  "institution.tabs.rhDashboard": "HR overview",
  "institution.tabs.infpc": "INFPC (co-funding)",
  "institution.infpc.title": "INFPC co-funding request",
  "institution.infpc.subtitle":
    "Upload the official Excel template (e.g. demande-de-cofinancement-2026.xls) and JSON data: the tool reads course enrollments from Stratelya and fills Signalétique, Salariés + and category « Tab.* » sheets.",
  "institution.infpc.templateLabel": "Excel template (.xls or .xlsx)",
  "institution.infpc.templateHint": "Blank file from lifelong-learning.lu — do not change the layout.",
  "institution.infpc.companyJson": "company-config (JSON)",
  "institution.infpc.employeesJson": "employees (JSON array)",
  "institution.infpc.employeesHint":
    "Optional: one row per employee (lyrraEmail = learner e-mail). You can use [] and complete personal information on each learner profile, or paste a JSON array here.",
  "institution.infpc.trainingsJson": "trainings-config (JSON array)",
  "institution.infpc.allowMissing":
    "Exclude from the file learners enrolled on the course who have no matching employees entry (same email)",
  "institution.infpc.skipDraft": "Allow courses still in draft status",
  "institution.infpc.generate": "Generate pre-filled file (.xlsx)",
  "institution.infpc.generating": "Generating…",
  "institution.infpc.success": "Download started.",
  "institution.infpc.error": "Generation failed",
  "institution.infpc.docLink": "See technical spec (mapping, formulas, checks)",
  "institution.infpc.flowIdHint":
    "Each lyrraFlowId must be a UUID. Easiest: pick a course below and click Apply — or copy the id from the designer URL (…/flows/YOUR_UUID segment).",
  "institution.infpc.pickFlow": "Institution courses",
  "institution.infpc.pickFlowPlaceholder": "— Select a course —",
  "institution.infpc.applyFlowId": "Apply to first trainings-config entry",
  "institution.infpc.flowApplied": "Course UUID inserted into the JSON (first entry).",
  "institution.infpc.flowsLoading": "Loading courses…",
  "institution.infpc.flowsEmpty": "No courses found for this institution.",
  "institution.infpc.mustReplacePlaceholder":
    "Replace the example UUID with a real course (list above + Apply) or wait for courses to load.",
  "institution.infpc.flowPickerHint":
    "Prevents “course not found” errors: only courses owned by a user in your institution are accepted (same list as the Courses tab).",
  "institution.tabs.flows": "Courses",
  "institution.tabs.trash": "Trash",
  "institution.trash.subtitle": "Soft-deleted courses and podcasts — restore to make them visible again.",
  "institution.trash.loading": "Loading…",
  "institution.trash.empty": "Trash is empty.",
  "institution.trash.sectionFlows": "Courses",
  "institution.trash.sectionPodcasts": "Podcasts",
  "institution.trash.restore": "Restore",
  "institution.trash.owner": "Trainer",
  "institution.trash.restoredFlow": "Course restored.",
  "institution.trash.restoredPodcast": "Podcast restored.",
  "institution.trash.restoreError": "Could not restore.",
  "institution.trash.loadError": "Could not load trash.",
  "institution.trash.purgeButton": "Empty trash…",
  "institution.trash.purgeModalTitle": "Permanently empty trash",
  "institution.trash.purgeModalHint": "Items will be deleted with no way to restore them (courses, podcasts, and linked orphan episodes).",
  "institution.trash.purgeScopeLabel": "Scope",
  "institution.trash.purgeAllLabel": "Delete everything",
  "institution.trash.purgeAllDesc": "Permanently remove all items currently in the trash.",
  "institution.trash.purgeRangeLabel": "Date range",
  "institution.trash.purgeRangeDesc": "Only items moved to trash between these dates (by deletion date) will be permanently removed.",
  "institution.trash.purgeDateFrom": "From",
  "institution.trash.purgeDateTo": "To",
  "institution.trash.purgeConfirm": "Delete permanently",
  "institution.trash.purgeSuccess": "Trash emptied.",
  "institution.trash.purgeRangeMissingDates": "Please set both start and end dates.",
  "institution.trash.purgeRangeOrderError": "Start date must be before end date.",
  "institution.tabs.supports": "Podcasts",
  "institution.tabs.categories": "Categories",
  "institution.tabs.templates": "Block templates",
  "institution.tabs.contentPipeline": "Content prep",
  "institution.tabs.webinars": "Webinars",
  "institution.tabs.webinarsPilotage": "Webinar management",
  "institution.webinars.pageTitle": "Webinar settings",
  "institution.webinars.settingsIntro":
    "Enable the module and set the default waiting-room message. Webinar list and authorized hosts are managed in the « {{tabName}} » tab.",
  "institution.webinars.enableForInstitution": "Enable webinars for this institution",
  "institution.webinars.enabledBadge": "Module enabled",
  "institution.webinars.disabledBadge": "Module disabled",
  "institution.webinars.sectionModule": "Activation",
  "institution.webinars.sectionModuleHint":
    "Allows trainers in your institution to create and host live sessions.",
  "institution.webinars.sectionWaitingRoom": "Waiting room",
  "institution.webinars.waitingHtmlLabel": "Waiting room HTML (default)",
  "institution.webinars.waitingHtmlPlaceholder": "<p>Your welcome message…</p>",
  "institution.webinars.waitingHtmlHint":
    "Simple HTML shown to participants before the session starts. Colors follow this space’s theme.",
  "institution.webinars.openPilotage": "Open webinar management",
  "institution.webinars.waitingPreviewTitle": "Preview — waiting room message",
  "institution.webinars.waitingPreviewHint":
    "As participants see it before the webinar starts (colors follow this space’s theme).",
  "institution.webinars.loadError": "Could not load webinar settings.",
  "institution.webinars.saveSuccess": "Webinar settings saved.",
  "institution.webinars.saveError": "Could not save settings.",
  "institution.tabs.scorm": "SCORM import",
  "institution.tabs.designers": "Collaborators",
  "institution.tabs.learners": "Learners",
  "institution.tabs.learnerAnalytics": "Learner analytics",
  "institution.tabs.biStudio": "BI dashboards",
  "institution.tabs.groups": "Groups",
  "institution.tabs.services": "Services",
  "institution.tabs.sirh": "HRIS (API)",
  "institution.tabs.branding": "Branding",
  "institution.tabs.landing": "Public page",
  "institution.tabs.webhooks": "Webhooks",
  "institution.tabs.ssoOidc": "SSO (OpenID Connect & SAML)",
  "institution.tabs.xapi": "xAPI (LRS)",
  "institution.tabs.mcp": "MCP",
  "institution.tabs.billing": "Billing",
  "institution.nav.section.general": "Overview",
  "institution.nav.section.content": "Content & training",
  "institution.nav.section.people": "Teams & learners",
  "institution.nav.section.portal": "Portal & branding",
  "institution.nav.section.integrations": "Integrations",
  "institution.nav.section.subscription": "Subscription",
  "institution.nav.section.rhTools": "Training & HR",
  "institution.rhNav.campaigns": "Campaigns",
  "institution.rhNav.codir": "Executive (CODIR) dashboard",
  "institution.rhNav.catalog": "Catalog",
  "institution.rhNav.competencies": "Competencies",
  "institution.rhNav.compliance": "Compliance",
  "institution.rhNav.requests": "Requests & workflows",
  "institution.sidebar.subtitle": "Institution",
  "institution.sidebar.subtitleRh": "HR space",
  "institution.sidebar.subtitleAdmin": "Administration",
  "institution.sidebar.logout": "Log out",
  "institution.sidebar.collapse": "Collapse menu",
  "institution.sidebar.expandAria": "Expand sidebar",
  "institution.sidebar.collapseAria": "Collapse sidebar",
  "institution.sidebar.language": "Language",
  "institution.sidebar.languageAria": "Change language",
  "institution.header.workspace": "Institution workspace",
  "institution.common.cancel": "Cancel",
  "institution.common.save": "Save",
  "institution.common.saving": "Saving…",
  "institution.common.delete": "Delete",
  "institution.common.edit": "Edit",
  "institution.common.create": "Create",
  "institution.common.add": "Add",
  "institution.common.retry": "Retry",
  "institution.common.refresh": "Refresh",
  "institution.common.search": "Search…",
  "institution.common.loading": "Loading…",
  "institution.common.page": "Page",
  "institution.common.of": "of",
  "institution.common.name": "Name",
  "institution.common.description": "Description",
  "institution.common.email": "Email",
  "institution.common.member": "Member",
  "institution.common.members": "Members",
  "institution.common.back": "Back",
  "institution.common.view": "View",
  "institution.common.duplicate": "Duplicate",
  "institution.common.toggleStatus": "Enable / disable",
  "institution.common.author": "Author",
  "institution.common.title": "Title",
  "institution.common.status": "Status",
  "institution.common.type": "Type",
  "institution.common.actions": "Actions",
  "institution.common.createdAt": "Created",
  "institution.common.assignedTo": "Assigned to",
  "institution.common.completion": "Completion",
  "institution.common.learners": "Learners",
  "institution.common.empty": "—",
  "institution.status.draft": "Draft",
  "institution.status.published": "Published",
  "institution.status.archived": "Archived",
  "institution.status.allStatuses": "All statuses",
  "institution.status.allTypes": "All types",
  "institution.dashboard.loading": "Loading dashboard…",
  "institution.dashboard.loadError": "Unable to load the dashboard.",
  "institution.dashboard.activity.completion": "Completion",
  "institution.dashboard.activity.enrollment": "Enrollment",
  "institution.dashboard.activity.milestone": "Milestone",
  "institution.dashboard.activity.feedback": "Feedback",
  "institution.dashboard.activity.start": "Start",
  "institution.dashboard.activity.1": "Marie Dupont completed “UX Fundamentals”",
  "institution.dashboard.activity.2": "12 new learners enrolled in “Design Thinking”",
  "institution.dashboard.activity.3": "Group “Cohort Q3” reached 80% completion",
  "institution.dashboard.activity.4": "NPS survey received 24 new responses",
  "institution.dashboard.activity.5": "Jean Martin started “Agile methods”",
  "institution.dashboard.time.5m": "5 min ago",
  "institution.dashboard.time.1h": "1h ago",
  "institution.dashboard.time.3h": "3h ago",
  "institution.dashboard.time.5h": "5h ago",
  "institution.dashboard.time.6h": "6h ago",
  "institution.dashboard.activity.flowCompleted": "{{name}} completed “{{flow}}”",
  "institution.dashboard.activity.participantJoined": "Learner added: {{email}}",
  "institution.dashboard.activity.flowStarted": "{{name}} started “{{flow}}”",
  "institution.dashboard.chartTopFlowsEmpty": "Not enough data yet. Publish courses and invite learners.",
  "institution.dashboard.activityEmpty": "No recent activity.",
  "institution.dashboard.home.greeting": "Hello, {{name}}",
  "institution.dashboard.home.greetingSubtitle": "Your institution at a glance — courses, learners, and recent activity.",
  "institution.dashboard.home.defaultName": "team",
  "institution.dashboard.home.primaryCta": "Manage courses",
  "institution.dashboard.home.secondaryCta": "View learners",
  "institution.dashboard.home.completionRate": "Completion rate",
  "institution.dashboard.home.quickAccess": "Quick access",
  "institution.dashboard.home.viewAllActivity": "All activity",
  "institution.dashboard.home.calendarKicker": "Activity this month",
  "institution.dashboard.home.alertNotStarted": "{{count}} enrollment(s) not started",
  "institution.dashboard.home.alertStalled": "{{count}} stalled progress",
  "institution.dashboard.home.topFlows": "Top courses",
  "institution.dashboard.home.topFlowsHint": "Completion rate per course for the selected period.",
  "institution.dashboard.home.periodLabel": "Period",
  "institution.groups.title": "Group management",
  "institution.groups.countShown": "{{count}} group(s)",
  "institution.groups.subtitle": "{{count}} group(s) in your institution",
  "institution.groups.create": "Create group",
  "institution.groups.statGroups": "Groups",
  "institution.groups.statTotalMembers": "Total members",
  "institution.groups.statEmpty": "Empty groups",
  "institution.groups.loadError": "Unable to load groups.",
  "institution.groups.searchPh": "Search a group…",
  "institution.groups.colGroup": "Group",
  "institution.groups.colCreated": "Created",
  "institution.groups.memberCount": "{{count}} member(s)",
  "institution.groups.emptyNone": "No groups yet. Create your first group.",
  "institution.groups.emptyFilter": "No groups match your search.",
  "institution.groups.backList": "Back to groups",
  "institution.groups.addLearner": "Add learner",
  "institution.groups.dateCreated": "Created on",
  "institution.groups.colMember": "Member",
  "institution.groups.colAdded": "Added on",
  "institution.groups.noMembers": "No members in this group",
  "institution.groups.loadGroupError": "Unable to load the group",
  "institution.groups.panelTitle": "Add learners",
  "institution.groups.noLearnersAvailable": "No learners available",
  "institution.groups.noResults": "No results",
  "institution.groups.modalEdit": "Edit group",
  "institution.groups.modalCreate": "Create group",
  "institution.groups.groupName": "Group name",
  "institution.groups.removeFromGroup": "Remove from group",
  "institution.services.title": "Company services",
  "institution.services.subtitle":
    "Directory of business units (HR, Finance, etc.). Learners are assigned from the learner profile.",
  "institution.services.create": "New service",
  "institution.services.loadError": "Unable to load services.",
  "institution.services.empty": "No services yet. Create one to assign learners.",
  "institution.services.modalCreate": "Create service",
  "institution.services.modalEdit": "Edit service",
  "institution.services.fieldName": "Service name",
  "institution.services.deleteConfirm": "Delete this service? Learners linked to it will no longer have a service assigned.",
  "institution.services.listSubtitle": "{{count}} service(s) in your institution",
  "institution.services.intro":
    "Directory of business units (HR, Finance, etc.). Learners are assigned from the learner profile.",
  "institution.services.statTotal": "Services",
  "institution.services.statWithDesc": "With description",
  "institution.services.statNoDesc": "Without description",
  "institution.services.searchPh": "Search a service…",
  "institution.services.colService": "Service",
  "institution.services.colCreated": "Created",
  "institution.services.emptyNone": "No services yet. Create your first service.",
  "institution.services.emptyFilter": "No services match your search.",
  "institution.services.countShown": "{{count}} service(s)",
  "institution.flows.title": "Courses",
  "institution.flows.subtitle": "Manage your courses",
  "institution.flows.statTotal": "Total courses",
  "institution.flows.statPublished": "Published",
  "institution.flows.statLearners": "Total learners",
  "institution.flows.searchPh": "Search a course…",
  "institution.flows.colName": "Name",
  "institution.flows.empty": "No course found",
  "institution.flows.badgeEnterprise": "Enterprise training need",
  "institution.flows.deleteEnterpriseTooltip": "Move to trash (enterprise need)",
  "institution.flows.deleteEnterpriseTitle": "Remove this enterprise-linked course?",
  "institution.flows.deleteEnterpriseHint": "The course will be soft-deleted. Trainers cannot do this; only institution admin, DRH or HR can restore or remove it from this dashboard.",
  "institution.flows.deleteEnterpriseConfirm": "Move to trash",
  "institution.flows.deleteEnterpriseSuccess": "Course moved to trash.",
  "institution.flows.deleteEnterpriseError": "Action failed.",
  "institution.learningPaths.sectionTitle": "Learning paths",
  "institution.learningPaths.sectionSubtitle": "Paths owned by a member of your institution.",
  "institution.learningPaths.searchPh": "Search a path…",
  "institution.learningPaths.colItems": "Items",
  "institution.learningPaths.colAssignments": "Assignments",
  "institution.learningPaths.transferOwner": "Reassign owner",
  "institution.learningPaths.transferModalTitle": "Change path owner",
  "institution.learningPaths.transferModalHint":
    "The selected account becomes the owner; referenced library media (e.g. cover) moves when traceable in the database.",
  "institution.learningPaths.transferPickUser": "New owner",
  "institution.learningPaths.transferSubmit": "Confirm transfer",
  "institution.learningPaths.transferLoadingUsers": "Loading accounts…",
  "institution.learningPaths.transferNoCandidates": "No other collaborator available",
  "institution.learningPaths.transferError": "Transfer failed",
  "institution.learningPaths.transferSuccess": "Owner updated",
  "institution.learningPaths.empty": "No path found",
  "institution.supports.title": "Podcasts",
  "institution.supports.subtitle": "Podcasts and audio content",
  "institution.supports.searchPh": "Search a podcast…",
  "institution.supports.empty": "No podcast found",
  "institution.supports.typeDictation": "Dictation",
  "institution.supports.typeText": "Text",
  "institution.supports.typeAi": "AI",
  "institution.supports.typePodcast": "Podcast",
  "institution.supports.allProductionStatuses": "All statuses",
  "institution.supports.colKind": "Type",
  "institution.supports.colEpisodes": "Episodes",
  "institution.supports.colProducer": "Producer",
  "institution.supports.colCreator": "Created by",
  "institution.supports.loadError": "Could not load podcasts.",
  "institution.supports.transferOwner": "Reassign podcast creator",
  "institution.supports.transferModalTitle": "Change podcast owner",
  "institution.supports.transferModalHint":
    "The selected account becomes the podcast creator; episodes and referenced library media move when traceable in the database.",
  "institution.supports.transferPickUser": "New creator",
  "institution.supports.transferSubmit": "Confirm transfer",
  "institution.supports.transferLoadingUsers": "Loading accounts…",
  "institution.supports.transferNoCandidates": "No other collaborator available",
  "institution.supports.transferError": "Transfer failed",
  "institution.supports.transferSuccess": "Creator updated",
  "institution.supports.previewError": "Could not open podcast preview.",
  "institution.podcastProduction.shell": "Shell",
  "institution.podcastProduction.assigned": "Assigned",
  "institution.podcastProduction.in_production": "In production",
  "institution.podcastProduction.ready": "Ready",
  "institution.categories.title": "Categories",
  "institution.categories.subtitle": "Organize your courses by topic",
  "institution.categories.add": "Add",
  "institution.categories.edit": "Edit category",
  "institution.categories.new": "New category",
  "institution.categories.usage": "{{count}} course(s)",
  "institution.categories.pageSubtitle": "Organize your content by category",
  "institution.categories.namePlaceholder": "Category name",
  "institution.categories.color": "Color",
  "institution.categories.descShortPh": "Short description",
  "institution.categories.usageTimes": "({{count}} uses)",
  "institution.templates.title": "Block templates",
  "institution.templates.subtitle": "Reusable template library",
  "institution.templates.statTotal": "Templates",
  "institution.templates.statUsage": "Total uses",
  "institution.templates.mostUsed": "Most used type",
  "institution.templates.preview": "Preview",
  "institution.templates.searchPh": "Search a template…",
  "institution.templates.copySuffix": " (copy)",
  "institution.templates.empty": "No templates found",
  "institution.templates.loadFormatError": "Could not load templates (invalid server response).",
  "institution.templates.usesShort": "{{count}} uses",
  "institution.templates.filterAll": "All types",
  "institution.blockTypes.text": "Text",
  "institution.blockTypes.quiz": "Quiz",
  "institution.blockTypes.video": "Video",
  "institution.blockTypes.audio": "Audio",
  "institution.blockTypes.image": "Image",
  "institution.blockTypes.document": "Document",
  "institution.blockTypes.code": "Code",
  "institution.blockTypes.discussion": "Discussion",
  "institution.scorm.title": "SCORM import",
  "institution.scorm.subtitle": "Import SCORM 1.2 or 2004 packages",
  "institution.scorm.dropHere": "Drag and drop your SCORM (.zip) file here",
  "institution.scorm.browseHint": "or click to browse",
  "institution.scorm.selectedFile": "Selected file: {{name}}",
  "institution.scorm.startImport": "Start import",
  "institution.scorm.importingNamed": "Import in progress: {{name}}",
  "institution.scorm.analyzing": "Analyzing modules… {{pct}}%",
  "institution.scorm.historyTitle": "Import history",
  "institution.scorm.colFile": "File",
  "institution.scorm.colDate": "Date",
  "institution.scorm.colStatus": "Status",
  "institution.scorm.colModules": "Modules",
  "institution.scorm.colVersion": "Version",
  "institution.scorm.colFlow": "Course",
  "institution.scorm.empty": "No imports yet. Drop a SCORM .zip file above.",
  "institution.scorm.openFlow": "Open",
  "institution.scorm.statusImporting": "Importing…",
  "institution.scorm.statusSuccess": "Success",
  "institution.scorm.statusError": "Error",
  "institution.designers.title": "Collaborators",
  "institution.designers.subtitle": "Trainers, HR leads, HR staff and administrators for your institution (no more “teacher” wording).",
  "institution.designers.invite": "Invite",
  "institution.designers.statTotal": "Total collaborators",
  "institution.designers.statActiveMonth": "Active this month",
  "institution.designers.statFlows": "Courses created (total)",
  "institution.designers.inviteTitle": "Invite a collaborator",
  "institution.designers.inviteHelp": "Choose a role: Trainer (content / courses), HR lead, HR staff, or Admin (institution administrator on Lyrra).",
  "institution.designers.emailPh": "email@example.com",
  "institution.designers.sendInvite": "Send invitation",
  "institution.designers.loadError": "Unable to load collaborators",
  "institution.designers.inviteFail": "Invitation failed",
  "institution.designers.actionFail": "Action failed",
  "institution.designers.searchPh": "Search by name or email…",
  "institution.designers.colName": "Name",
  "institution.designers.colEmail": "Email",
  "institution.designers.colRole": "Role",
  "institution.designers.colProjects": "Projects",
  "institution.designers.colLastActivity": "Last activity",
  "institution.designers.colStatus": "Status",
  "institution.designers.colActions": "Actions",
  "institution.designers.empty": "No collaborator found",
  "institution.designers.roleAdmin": "Admin",
  "institution.designers.roleTeacher": "Trainer",
  "institution.designers.roleTrainingLead": "Training lead",
  "institution.designers.roleCollaborator": "Collaborator",
  "institution.designers.roleOptFormateur": "Trainer",
  "institution.designers.roleOptDrh": "HR lead",
  "institution.designers.roleOptRh": "HR",
  "institution.designers.roleOptAdmin": "Admin",
  "institution.designers.statusActive": "Active",
  "institution.designers.statusInvited": "Invited",
  "institution.designers.statusSuspended": "Suspended",
  "institution.designers.menuView": "View profile",
  "institution.designers.menuMakeAdmin": "Make admin",
  "institution.designers.menuSuspend": "Suspend",
  "institution.designers.menuRemove": "Remove",
  "institution.designers.noLinkedLearner": "No learner profile is linked to this email.",
  "institution.designers.createLinkedLearner": "Create learner profile",
  "institution.designers.creatingLinkedLearner": "Creating…",
  "institution.designers.createLinkedLearnerFail": "Could not create the learner profile",
  "institution.billing.title": "Billing",
  "institution.billing.subtitle": "Subscription, usage and invoices",
  "institution.billing.planLabel": "Current plan",
  "institution.billing.planPro": "Pro",
  "institution.billing.priceExample": "€299",
  "institution.billing.perMonth": "/ month",
  "institution.billing.renewalMock": "Renews on February 1, 2025",
  "institution.billing.featureCollaborators": "10 collaborators",
  "institution.billing.featureLearners": "500 learners",
  "institution.billing.featureStorage": "50 GB storage",
  "institution.billing.featureSupport": "Priority support",
  "institution.billing.featureApi": "MCP API",
  "institution.billing.changePlan": "Change plan",
  "institution.billing.usageCollaborators": "Collaborators",
  "institution.billing.usageLearners": "Learners",
  "institution.billing.usageStorage": "Storage",
  "institution.billing.storageUnit": "GB",
  "institution.billing.cardMasked": "Visa •••• 4242",
  "institution.billing.cardExpires": "Expires {{date}}",
  "institution.billing.invoicesTitle": "Invoices",
  "institution.billing.colRef": "Reference",
  "institution.billing.colDate": "Date",
  "institution.billing.colAmount": "Amount",
  "institution.billing.colStatus": "Status",
  "institution.billing.colPdf": "PDF",
  "institution.billing.invPaid": "Paid",
  "institution.billing.invOpen": "Pending",
  "institution.billing.invDraft": "Draft",
  "institution.billing.invVoid": "Void",
  "institution.billing.invUncollectible": "Uncollectible",
  "institution.mcp.title": "MCP — Model Context Protocol",
  "institution.landing.designerTitle": "Page designer",
  "institution.learners.title": "Learners",
  "institution.learners.searchPh": "Search a learner…",
  "institution.learners.filterStatus": "Status",
  "institution.learners.filterPlaceholder": "Filter",
  "institution.learners.selectedCount": "{{count}} selected",
  "institution.learners.exportSelection": "Export selection",
  "institution.learners.exportAll": "Export all",
  "institution.learners.colLearner": "Learner",
  "institution.learners.colGroup": "Group",
  "institution.learners.colLastActive": "Last activity",
  "institution.learners.colStatus": "Status",
  "institution.learners.empty": "No learner found",
  "institution.learners.countList": "{{count}} learner(s)",
  "institution.learners.subtitle": "{{count}} learner(s) enrolled in your institution",
  "institution.learners.importCsv": "Import CSV",
  "institution.learners.add": "Add",
  "institution.learners.addModalTitle": "New learner",
  "institution.learners.addModalHint":
    "Creates the record for your institution. If the email has no Stratelya account yet, an email is sent to set the password.",
  "institution.learners.addEmail": "Email",
  "institution.learners.addSendInvitation": "Send invitation email (new accounts only)",
  "institution.learners.addSubmit": "Create",
  "institution.learners.addError": "Could not create the learner",
  "institution.learners.statLearners": "Learners",
  "institution.learners.statActive30": "Active (30d)",
  "institution.learners.statEnrollments": "Enrollments",
  "institution.learners.statCompleted": "Completed courses",
  "institution.learners.statusAll": "All statuses",
  "institution.learners.statusActive": "Active",
  "institution.learners.statusInactive": "Inactive",
  "institution.learners.statusCompleted": "Completed",
  "institution.learners.sheetTitle": "Learner profile",
  "institution.learners.openProfileDetail": "Profile details",
  "institution.learners.groupsCatalogTitle": "Configured groups",
  "institution.learners.groupsCatalogSubtitle": "Defined in your institution’s « Groups » tab.",
  "institution.learners.replacePhoto": "Replace",
  "institution.learners.addPhoto": "Add photo",
  "institution.learners.removePhoto": "Remove",
  "institution.learners.firstName": "First name",
  "institution.learners.lastName": "Last name",
  "institution.learners.save": "Save",
  "institution.learners.deactivate": "Deactivate",
  "institution.learners.reactivate": "Reactivate",
  "institution.learners.lastActivity": "Last activity:",
  "institution.learners.paths": "Paths ({{count}})",
  "institution.learners.noPaths": "No assigned path",
  "institution.learners.noFlowsEnrolled": "No enrolled course",
  "institution.learners.done": "Done",
  "institution.learners.inProgress": "In progress",
  "institution.learners.itemsProgress": "{{done}}/{{total}} items",
  "institution.learners.flows": "Courses",
  "institution.learners.completedF": "Completed",
  "institution.learners.totalTime": "Total time",
  "institution.learners.progress": "Progress",
  "institution.learners.flowDone": "Completed",
  "institution.learners.blocks": "{{visited}}/{{total}} blocks",
  "institution.learners.score": "Score: {{score}}%",
  "institution.learners.sessions": "{{count}} sessions",
  "institution.learners.started": "Started:",
  "institution.learners.ended": "Ended:",
  "institution.learners.lastAccess": "Last access:",
  "institution.learners.podcasts": "Podcasts",
  "institution.learners.noPodcastListen": "No listening recorded",
  "institution.learners.deleteTitle": "Delete this learner?",
  "institution.learners.deleteDesc": "Are you sure you want to permanently delete {{name}} ({{email}})? This cannot be undone and will remove all related data.",
  "institution.learners.deactivateTitle": "Deactivate this learner?",
  "institution.learners.reactivateTitle": "Reactivate this learner?",
  "institution.learners.deactivateDesc": "{{name}} will not be able to access courses while deactivated.",
  "institution.learners.reactivateDesc": "{{name}} will regain access to their courses.",
  "institution.learners.deleteLearner": "Delete this learner",
  "institution.learners.photoUploadError": "Error uploading photo",
  "institution.learners.photoRemoveError": "Error removing photo",
  "institution.learners.service": "Service",
  "institution.learners.serviceHint": "Pick an entry from the directory (Services tab). Type to filter the list.",
  "institution.learners.serviceSearch": "Search a service…",
  "institution.learners.serviceNone": "No service",
  "institution.learners.infpc.sectionTitle": "Personal information",
  "institution.learners.infpc.sectionHint":
    "Additional details useful for administrative procedures and training-related declarations (optional fields depending on context).",
  "institution.learners.infpc.gender": "Gender",
  "institution.learners.infpc.genderPlaceholder": "—",
  "institution.learners.infpc.genderM": "Male",
  "institution.learners.infpc.genderF": "Female",
  "institution.learners.infpc.csp": "Occupational category",
  "institution.learners.infpc.cspPlaceholder": "— Select —",
  "institution.learners.infpc.csp.manual_worker": "Manual worker",
  "institution.learners.infpc.csp.employee": "Employee",
  "institution.learners.infpc.csp.technician": "Technician",
  "institution.learners.infpc.csp.supervisor": "Supervisor",
  "institution.learners.infpc.csp.executive": "Executive",
  "institution.learners.infpc.csp.director": "Director",
  "institution.learners.infpc.hasDiploma": "Diploma (required level)",
  "institution.learners.infpc.seniority": "Seniority (years)",
  "institution.learners.infpc.age": "Age",
  "institution.learners.infpc.salariePlus": "Salarié +",
  "institution.learners.infpc.salariePlusType": "Salarié + type",
  "institution.learners.infpc.salariePlusTypePlaceholder": "—",
  "institution.learners.infpc.salariePlusType1": "Type 1 (young / no diploma required)",
  "institution.learners.infpc.salariePlusType2": "Type 2",
  "institution.learners.infpc.hireDate": "Hire date (DD/MM/YYYY)",
  "institution.learners.infpc.birthDate": "Birth date (DD/MM/YYYY)",
  "institution.learners.infpc.save": "Save information",
  "institution.learners.infpc.saved": "Information saved.",
  "institution.learners.exportSheetLearners": "Learners",
  "institution.learners.exportSheetDetails": "Course details",
  "institution.learners.export.firstName": "First name",
  "institution.learners.export.lastName": "Last name",
  "institution.learners.export.groupCol": "Group",
  "institution.learners.export.enrollments": "Enrolled courses",
  "institution.learners.export.completed": "Completed courses",
  "institution.learners.export.progressPct": "Progress (%)",
  "institution.learners.export.totalMin": "Total time (min)",
  "institution.learners.export.lastAct": "Last activity",
  "institution.learners.export.statusCol": "Status",
  "institution.learners.export.learnerCol": "Learner",
  "institution.learners.export.typeCol": "Type",
  "institution.learners.export.titleCol": "Title",
  "institution.learners.export.blocks": "Blocks visited / Total",
  "institution.learners.export.sessionsDone": "Sessions completed",
  "institution.learners.export.avgScore": "Average score (%)",
  "institution.learners.export.timeMin": "Time spent (min)",
  "institution.learners.export.dateStart": "Start date",
  "institution.learners.export.dateEnd": "End date",
  "institution.learners.export.lastAcc": "Last access",
  "institution.learners.export.typeCourse": "Course",
  "institution.learners.export.typePath": "Path",
  "institution.reminders.openPanel": "Email reminders",
  "institution.reminders.panelTitle": "Reminders",
  "institution.reminders.panelSubtitle":
    "Automatic alerts emailed to concerned learners. A server job runs every hour at the chosen UTC hour. Each rule sends at most once per learner.",
  "institution.reminders.sectionRules": "Rules",
  "institution.reminders.sectionLogs": "Send log",
  "institution.reminders.addRule": "Add alert",
  "institution.reminders.removeRule": "Remove this alert",
  "institution.reminders.save": "Save rules",
  "institution.reminders.loadError": "Could not load reminders.",
  "institution.reminders.saveError": "Could not save.",
  "institution.reminders.rulesEmpty": "No alerts yet. Add a rule, or save an empty list to clear all reminders for this item.",
  "institution.reminders.logsEmpty": "No sends recorded yet.",
  "institution.reminders.utcHint": "Pick the UTC hour (0–23) when the server evaluates this rule.",
  "institution.reminders.fieldKind": "Alert type",
  "institution.reminders.fieldDays": "Days after the anchor event",
  "institution.reminders.fieldHourUtc": "Check hour (UTC)",
  "institution.reminders.fieldEnabled": "Enable this alert",
  "institution.reminders.fieldLabel": "Internal label (optional)",
  "institution.reminders.fieldLabelPh": "e.g. Nudge D+3",
  "institution.reminders.ruleKind.eduflow_not_started_days_after_enroll":
    "Course: not started X days after enrollment (participant record)",
  "institution.reminders.ruleKind.eduflow_incomplete_days_after_deadline":
    "Course: still incomplete X days after the flow deadline",
  "institution.reminders.ruleKind.path_incomplete_days_after_assign":
    "Path: incomplete X days after assignment to the learner",
  "institution.pages.brandingTitle": "Visual identity",
  "institution.pages.webhooksTitle": "Webhooks",
  "institution.pages.landingTitle": "Public page",
  },
  es: {
    ...institutionRhCompetenciesStrings.es,
    ...institutionBiStringsEn,
  "institution.tabs.home": "Inicio",
  "institution.tabs.flows": "Formaciones",
  "institution.tabs.supports": "Podcasts",
  "institution.tabs.categories": "Categorías",
  "institution.tabs.templates": "Plantillas de bloques",
  "institution.tabs.scorm": "Importación SCORM",
  "institution.tabs.designers": "Colaboradores",
  "institution.tabs.learners": "Alumnos",
  "institution.tabs.learnerAnalytics": "Análisis de alumnos",
  "institution.tabs.biStudio": "Cuadros BI",
  "institution.tabs.groups": "Grupos",
  "institution.tabs.services": "Servicios",
  "institution.tabs.branding": "Personalización",
  "institution.tabs.landing": "Página pública",
  "institution.tabs.webhooks": "Webhooks",
  "institution.tabs.ssoOidc": "SSO (OpenID Connect & SAML)",
  "institution.tabs.xapi": "xAPI (LRS)",
  "institution.tabs.mcp": "MCP",
  "institution.tabs.billing": "Facturación",
  "institution.nav.section.general": "General",
  "institution.nav.section.content": "Contenido y formación",
  "institution.nav.section.people": "Equipos y alumnos",
  "institution.nav.section.portal": "Portal e imagen",
  "institution.nav.section.integrations": "Integraciones",
  "institution.nav.section.subscription": "Suscripción",
  "institution.sidebar.subtitle": "Institución",
  "institution.sidebar.subtitleRh": "Espacio RH",
  "institution.sidebar.subtitleAdmin": "Administración",
  "institution.sidebar.logout": "Cerrar sesión",
  "institution.sidebar.collapse": "Contraer menú",
  "institution.sidebar.expandAria": "Expandir barra lateral",
  "institution.sidebar.collapseAria": "Contraer barra lateral",
  "institution.sidebar.language": "Language",
  "institution.sidebar.languageAria": "Change language",
  "institution.common.cancel": "Cancelar",
  "institution.common.save": "Guardar",
  "institution.tabs.webinars": "Webinars",
  "institution.tabs.webinarsPilotage": "Gestión de webinars",
  "institution.webinars.pageTitle": "Configuración de webinars",
  "institution.webinars.settingsIntro":
    "Active el módulo y defina el mensaje de espera por defecto. La lista de webinars y los anfitriones autorizados se gestionan en la pestaña « {{tabName}} ».",
  "institution.webinars.enableForInstitution": "Activar webinars para la institución",
  "institution.webinars.enabledBadge": "Módulo activado",
  "institution.webinars.disabledBadge": "Módulo desactivado",
  "institution.webinars.sectionModule": "Activación",
  "institution.webinars.sectionModuleHint": "Permite a los formadores de la institución crear y animar sesiones en directo.",
  "institution.webinars.sectionWaitingRoom": "Sala de espera",
  "institution.webinars.waitingHtmlLabel": "HTML de sala de espera (predeterminado)",
  "institution.webinars.waitingHtmlPlaceholder": "<p>Su mensaje de bienvenida…</p>",
  "institution.webinars.waitingHtmlHint":
    "HTML simple mostrado a los participantes antes del inicio. Los colores siguen la identidad de este espacio.",
  "institution.webinars.openPilotage": "Abrir gestión de webinars",
  "institution.webinars.waitingPreviewTitle": "Vista previa — mensaje de espera",
  "institution.webinars.waitingPreviewHint":
    "Como lo ven los participantes antes de que comience el webinar (colores de la institución).",
  "institution.webinars.loadError": "No se pudieron cargar los ajustes de webinars.",
  "institution.webinars.saveSuccess": "Ajustes de webinars guardados.",
  "institution.webinars.saveError": "No se pudo guardar.",
  "institution.common.saving": "Guardando…",
  "institution.common.delete": "Eliminar",
  "institution.common.edit": "Editar",
  "institution.common.create": "Crear",
  "institution.common.add": "Añadir",
  "institution.common.retry": "Reintentar",
  "institution.common.refresh": "Actualizar",
  "institution.common.search": "Buscar…",
  "institution.common.loading": "Cargando…",
  "institution.common.page": "Página",
  "institution.common.of": "de",
  "institution.common.name": "Name",
  "institution.common.description": "Description",
  "institution.common.email": "Email",
  "institution.common.member": "Miembro",
  "institution.common.members": "Miembros",
  "institution.common.back": "Volver",
  "institution.common.view": "Ver",
  "institution.common.duplicate": "Duplicar",
  "institution.common.toggleStatus": "Activar / desactivar",
  "institution.common.author": "Autor",
  "institution.common.title": "Título",
  "institution.common.status": "Estado",
  "institution.common.type": "Tipo",
  "institution.common.actions": "Acciones",
  "institution.common.createdAt": "Creado el",
  "institution.common.assignedTo": "Asignado a",
  "institution.common.completion": "Finalización",
  "institution.common.learners": "Alumnos",
  "institution.common.empty": "—",
  "institution.status.draft": "Borrador",
  "institution.status.published": "Publicado",
  "institution.status.archived": "Archivado",
  "institution.status.allStatuses": "Todos los estados",
  "institution.status.allTypes": "Todos los tipos",
  "institution.dashboard.loading": "Cargando el panel…",
  "institution.dashboard.loadError": "No se pudo cargar el panel.",
  "institution.dashboard.activity.completion": "Completion",
  "institution.dashboard.activity.enrollment": "Enrollment",
  "institution.dashboard.activity.milestone": "Milestone",
  "institution.dashboard.activity.feedback": "Feedback",
  "institution.dashboard.activity.start": "Start",
  "institution.dashboard.activity.1": "Marie Dupont completed “UX Fundamentals”",
  "institution.dashboard.activity.2": "12 new learners enrolled in “Design Thinking”",
  "institution.dashboard.activity.3": "Group “Cohort Q3” reached 80% completion",
  "institution.dashboard.activity.4": "NPS survey received 24 new responses",
  "institution.dashboard.activity.5": "Jean Martin started “Agile methods”",
  "institution.dashboard.time.5m": "5 min ago",
  "institution.dashboard.time.1h": "1h ago",
  "institution.dashboard.time.3h": "3h ago",
  "institution.dashboard.time.5h": "5h ago",
  "institution.dashboard.time.6h": "6h ago",
  "institution.dashboard.activity.flowCompleted": "{{name}} completed “{{flow}}”",
  "institution.dashboard.activity.participantJoined": "Learner added: {{email}}",
  "institution.dashboard.activity.flowStarted": "{{name}} started “{{flow}}”",
  "institution.dashboard.chartTopFlowsEmpty": "Not enough data yet. Publish courses and invite learners.",
  "institution.dashboard.activityEmpty": "No recent activity.",
  "institution.groups.title": "Gestión de grupos",
  "institution.groups.countShown": "{{count}} group(s)",
  "institution.groups.subtitle": "{{count}} group(s) in your institution",
  "institution.groups.create": "Create group",
  "institution.groups.statGroups": "Groups",
  "institution.groups.statTotalMembers": "Total members",
  "institution.groups.statEmpty": "Empty groups",
  "institution.groups.loadError": "Unable to load groups.",
  "institution.groups.searchPh": "Search a group…",
  "institution.groups.colGroup": "Group",
  "institution.groups.colCreated": "Created",
  "institution.groups.memberCount": "{{count}} member(s)",
  "institution.groups.emptyNone": "No groups yet. Create your first group.",
  "institution.groups.emptyFilter": "No groups match your search.",
  "institution.groups.backList": "Back to groups",
  "institution.groups.addLearner": "Add learner",
  "institution.groups.dateCreated": "Created on",
  "institution.groups.colMember": "Member",
  "institution.groups.colAdded": "Added on",
  "institution.groups.noMembers": "No members in this group",
  "institution.groups.loadGroupError": "Unable to load the group",
  "institution.groups.panelTitle": "Add learners",
  "institution.groups.noLearnersAvailable": "No learners available",
  "institution.groups.noResults": "No results",
  "institution.groups.modalEdit": "Edit group",
  "institution.groups.modalCreate": "Create group",
  "institution.groups.groupName": "Group name",
  "institution.groups.removeFromGroup": "Remove from group",
  "institution.services.title": "Servicios de la empresa",
  "institution.services.subtitle":
    "Catálogo de servicios corporativos (RR. HH., Finanzas, etc.). Asigne alumnos desde su ficha.",
  "institution.services.create": "Nuevo servicio",
  "institution.services.loadError": "No se pudieron cargar los servicios.",
  "institution.services.empty": "Aún no hay servicios. Cree uno para asignarlo a los alumnos.",
  "institution.services.modalCreate": "Crear servicio",
  "institution.services.modalEdit": "Editar servicio",
  "institution.services.fieldName": "Nombre del servicio",
  "institution.services.deleteConfirm":
    "¿Eliminar este servicio? Los alumnos vinculados dejarán de tener un servicio asignado.",
  "institution.services.listSubtitle": "{{count}} servicio(s) en su organización",
  "institution.services.intro":
    "Catálogo de servicios corporativos (RR. HH., Finanzas, etc.). Asigne alumnos desde su ficha.",
  "institution.services.statTotal": "Servicios",
  "institution.services.statWithDesc": "Con descripción",
  "institution.services.statNoDesc": "Sin descripción",
  "institution.services.searchPh": "Buscar un servicio…",
  "institution.services.colService": "Servicio",
  "institution.services.colCreated": "Creado",
  "institution.services.emptyNone": "Aún no hay servicios. Cree el primero.",
  "institution.services.emptyFilter": "Ningún servicio coincide con la búsqueda.",
  "institution.services.countShown": "{{count}} servicio(s)",
  "institution.flows.title": "Formaciones",
  "institution.flows.subtitle": "Gestione sus formaciones",
  "institution.flows.statTotal": "Total courses",
  "institution.flows.statPublished": "Published",
  "institution.flows.statLearners": "Total learners",
  "institution.flows.searchPh": "Search a course…",
  "institution.flows.colName": "Name",
  "institution.flows.empty": "No course found",
  "institution.flows.badgeEnterprise": "Enterprise training need",
  "institution.flows.deleteEnterpriseTooltip": "Move to trash (enterprise need)",
  "institution.flows.deleteEnterpriseTitle": "Remove this enterprise-linked course?",
  "institution.flows.deleteEnterpriseHint": "The course will be soft-deleted. Trainers cannot do this; only institution admin, DRH or HR can restore or remove it from this dashboard.",
  "institution.flows.deleteEnterpriseConfirm": "Move to trash",
  "institution.flows.deleteEnterpriseSuccess": "Course moved to trash.",
  "institution.flows.deleteEnterpriseError": "Action failed.",
  "institution.learningPaths.sectionTitle": "Learning paths",
  "institution.learningPaths.sectionSubtitle": "Paths owned by a member of your institution.",
  "institution.learningPaths.searchPh": "Search a path…",
  "institution.learningPaths.colItems": "Items",
  "institution.learningPaths.colAssignments": "Assignments",
  "institution.learningPaths.transferOwner": "Reassign owner",
  "institution.learningPaths.transferModalTitle": "Change path owner",
  "institution.learningPaths.transferModalHint":
    "The selected account becomes the owner; referenced library media (e.g. cover) moves when traceable in the database.",
  "institution.learningPaths.transferPickUser": "New owner",
  "institution.learningPaths.transferSubmit": "Confirm transfer",
  "institution.learningPaths.transferLoadingUsers": "Loading accounts…",
  "institution.learningPaths.transferNoCandidates": "No other collaborator available",
  "institution.learningPaths.transferError": "Transfer failed",
  "institution.learningPaths.transferSuccess": "Owner updated",
  "institution.learningPaths.empty": "No path found",
  "institution.supports.title": "Podcasts",
  "institution.supports.subtitle": "Podcasts and audio content",
  "institution.supports.searchPh": "Search a podcast…",
  "institution.supports.empty": "No podcast found",
  "institution.supports.typeDictation": "Dictation",
  "institution.supports.typeText": "Text",
  "institution.supports.typeAi": "AI",
  "institution.supports.transferOwner": "Reassign podcast creator",
  "institution.supports.transferModalTitle": "Change podcast owner",
  "institution.supports.transferModalHint":
    "The selected account becomes the podcast creator; episodes and referenced library media move when traceable in the database.",
  "institution.supports.transferPickUser": "New creator",
  "institution.supports.transferSubmit": "Confirm transfer",
  "institution.supports.transferLoadingUsers": "Loading accounts…",
  "institution.supports.transferNoCandidates": "No other collaborator available",
  "institution.supports.transferError": "Transfer failed",
  "institution.supports.transferSuccess": "Creator updated",
  "institution.categories.title": "Categorías",
  "institution.categories.subtitle": "Organize your courses by topic",
  "institution.categories.add": "Add",
  "institution.categories.edit": "Edit category",
  "institution.categories.new": "New category",
  "institution.categories.usage": "{{count}} course(s)",
  "institution.categories.pageSubtitle": "Organize your content by category",
  "institution.categories.namePlaceholder": "Category name",
  "institution.categories.color": "Color",
  "institution.categories.descShortPh": "Short description",
  "institution.categories.usageTimes": "({{count}} uses)",
  "institution.templates.title": "Plantillas de bloques",
  "institution.templates.subtitle": "Reusable template library",
  "institution.templates.statTotal": "Templates",
  "institution.templates.statUsage": "Total uses",
  "institution.templates.mostUsed": "Most used type",
  "institution.templates.preview": "Preview",
  "institution.templates.searchPh": "Search a template…",
  "institution.templates.copySuffix": " (copy)",
  "institution.templates.empty": "No templates found",
  "institution.templates.loadFormatError": "Could not load templates (invalid server response).",
  "institution.templates.usesShort": "{{count}} uses",
  "institution.templates.filterAll": "All types",
  "institution.blockTypes.text": "Text",
  "institution.blockTypes.quiz": "Quiz",
  "institution.blockTypes.video": "Video",
  "institution.blockTypes.audio": "Audio",
  "institution.blockTypes.image": "Image",
  "institution.blockTypes.document": "Document",
  "institution.blockTypes.code": "Code",
  "institution.blockTypes.discussion": "Discussion",
  "institution.scorm.title": "Importación SCORM",
  "institution.scorm.subtitle": "Import SCORM 1.2 or 2004 packages",
  "institution.scorm.dropHere": "Drag and drop your SCORM (.zip) file here",
  "institution.scorm.browseHint": "or click to browse",
  "institution.scorm.selectedFile": "Selected file: {{name}}",
  "institution.scorm.startImport": "Start import",
  "institution.scorm.importingNamed": "Import in progress: {{name}}",
  "institution.scorm.analyzing": "Analyzing modules… {{pct}}%",
  "institution.scorm.historyTitle": "Import history",
  "institution.scorm.colFile": "File",
  "institution.scorm.colDate": "Date",
  "institution.scorm.colStatus": "Status",
  "institution.scorm.colModules": "Modules",
  "institution.scorm.colVersion": "Version",
  "institution.scorm.colFlow": "Course",
  "institution.scorm.empty": "No imports yet. Drop a SCORM .zip file above.",
  "institution.scorm.openFlow": "Open",
  "institution.scorm.statusImporting": "Importing…",
  "institution.scorm.statusSuccess": "Success",
  "institution.scorm.statusError": "Error",
  "institution.designers.title": "Colaboradores",
  "institution.designers.subtitle": "Trainers, HR leads, HR staff and administrators for your institution (no more “teacher” wording).",
  "institution.designers.invite": "Invite",
  "institution.designers.statTotal": "Total collaborators",
  "institution.designers.statActiveMonth": "Active this month",
  "institution.designers.statFlows": "Courses created (total)",
  "institution.designers.inviteTitle": "Invite a collaborator",
  "institution.designers.inviteHelp": "Choose a role: Trainer (content / courses), HR lead, HR staff, or Admin (institution administrator on Lyrra).",
  "institution.designers.emailPh": "email@example.com",
  "institution.designers.sendInvite": "Send invitation",
  "institution.designers.loadError": "Unable to load collaborators",
  "institution.designers.inviteFail": "Invitation failed",
  "institution.designers.actionFail": "Action failed",
  "institution.designers.searchPh": "Search by name or email…",
  "institution.designers.colName": "Name",
  "institution.designers.colEmail": "Email",
  "institution.designers.colRole": "Role",
  "institution.designers.colProjects": "Projects",
  "institution.designers.colLastActivity": "Last activity",
  "institution.designers.colStatus": "Status",
  "institution.designers.colActions": "Actions",
  "institution.designers.empty": "No collaborator found",
  "institution.designers.roleAdmin": "Admin",
  "institution.designers.roleTeacher": "Trainer",
  "institution.designers.roleTrainingLead": "Training lead",
  "institution.designers.roleCollaborator": "Collaborator",
  "institution.designers.roleOptFormateur": "Trainer",
  "institution.designers.roleOptDrh": "HR lead",
  "institution.designers.roleOptRh": "HR",
  "institution.designers.roleOptAdmin": "Admin",
  "institution.designers.statusActive": "Active",
  "institution.designers.statusInvited": "Invited",
  "institution.designers.statusSuspended": "Suspended",
  "institution.designers.menuView": "View profile",
  "institution.designers.menuMakeAdmin": "Make admin",
  "institution.designers.menuSuspend": "Suspend",
  "institution.designers.menuRemove": "Remove",
  "institution.billing.title": "Facturación",
  "institution.billing.subtitle": "Subscription, usage and invoices",
  "institution.billing.planLabel": "Current plan",
  "institution.billing.planPro": "Pro",
  "institution.billing.priceExample": "€299",
  "institution.billing.perMonth": "/ month",
  "institution.billing.renewalMock": "Renews on February 1, 2025",
  "institution.billing.featureCollaborators": "10 collaborators",
  "institution.billing.featureLearners": "500 learners",
  "institution.billing.featureStorage": "50 GB storage",
  "institution.billing.featureSupport": "Priority support",
  "institution.billing.featureApi": "MCP API",
  "institution.billing.changePlan": "Change plan",
  "institution.billing.usageCollaborators": "Collaborators",
  "institution.billing.usageLearners": "Learners",
  "institution.billing.usageStorage": "Storage",
  "institution.billing.storageUnit": "GB",
  "institution.billing.cardMasked": "Visa •••• 4242",
  "institution.billing.cardExpires": "Expires {{date}}",
  "institution.billing.invoicesTitle": "Invoices",
  "institution.billing.colRef": "Reference",
  "institution.billing.colDate": "Date",
  "institution.billing.colAmount": "Amount",
  "institution.billing.colStatus": "Status",
  "institution.billing.colPdf": "PDF",
  "institution.billing.invPaid": "Paid",
  "institution.billing.invOpen": "Pending",
  "institution.billing.invDraft": "Draft",
  "institution.billing.invVoid": "Void",
  "institution.billing.invUncollectible": "Uncollectible",
  "institution.mcp.title": "MCP — Model Context Protocol",
  "institution.landing.designerTitle": "Page designer",
  "institution.learners.title": "Alumnos",
  "institution.learners.searchPh": "Search a learner…",
  "institution.learners.filterStatus": "Status",
  "institution.learners.filterPlaceholder": "Filter",
  "institution.learners.selectedCount": "{{count}} selected",
  "institution.learners.exportSelection": "Export selection",
  "institution.learners.exportAll": "Export all",
  "institution.learners.colLearner": "Learner",
  "institution.learners.colGroup": "Group",
  "institution.learners.colLastActive": "Last activity",
  "institution.learners.colStatus": "Status",
  "institution.learners.empty": "No learner found",
  "institution.learners.countList": "{{count}} learner(s)",
  "institution.learners.subtitle": "{{count}} learner(s) enrolled in your institution",
  "institution.learners.importCsv": "Import CSV",
  "institution.learners.add": "Add",
  "institution.learners.statLearners": "Learners",
  "institution.learners.statActive30": "Active (30d)",
  "institution.learners.statEnrollments": "Enrollments",
  "institution.learners.statCompleted": "Completed courses",
  "institution.learners.statusAll": "All statuses",
  "institution.learners.statusActive": "Active",
  "institution.learners.statusInactive": "Inactive",
  "institution.learners.statusCompleted": "Completed",
  "institution.learners.sheetTitle": "Learner profile",
  "institution.learners.openProfileDetail": "Detalle del perfil",
  "institution.learners.groupsCatalogTitle": "Grupos configurados",
  "institution.learners.groupsCatalogSubtitle": "Definidos en la pestaña « Grupos » de su centro.",
  "institution.learners.replacePhoto": "Replace",
  "institution.learners.addPhoto": "Add photo",
  "institution.learners.removePhoto": "Remove",
  "institution.learners.firstName": "First name",
  "institution.learners.lastName": "Last name",
  "institution.learners.save": "Save",
  "institution.learners.deactivate": "Deactivate",
  "institution.learners.reactivate": "Reactivate",
  "institution.learners.lastActivity": "Last activity:",
  "institution.learners.paths": "Paths ({{count}})",
  "institution.learners.noPaths": "No assigned path",
  "institution.learners.noFlowsEnrolled": "No enrolled course",
  "institution.learners.done": "Done",
  "institution.learners.inProgress": "In progress",
  "institution.learners.itemsProgress": "{{done}}/{{total}} items",
  "institution.learners.flows": "Courses",
  "institution.learners.completedF": "Completed",
  "institution.learners.totalTime": "Total time",
  "institution.learners.progress": "Progress",
  "institution.learners.flowDone": "Completed",
  "institution.learners.blocks": "{{visited}}/{{total}} blocks",
  "institution.learners.score": "Score: {{score}}%",
  "institution.learners.sessions": "{{count}} sessions",
  "institution.learners.started": "Started:",
  "institution.learners.ended": "Ended:",
  "institution.learners.lastAccess": "Last access:",
  "institution.learners.podcasts": "Podcasts",
  "institution.learners.noPodcastListen": "No listening recorded",
  "institution.learners.deleteTitle": "Delete this learner?",
  "institution.learners.deleteDesc": "Are you sure you want to permanently delete {{name}} ({{email}})? This cannot be undone and will remove all related data.",
  "institution.learners.deactivateTitle": "Deactivate this learner?",
  "institution.learners.reactivateTitle": "Reactivate this learner?",
  "institution.learners.deactivateDesc": "{{name}} will not be able to access courses while deactivated.",
  "institution.learners.reactivateDesc": "{{name}} will regain access to their courses.",
  "institution.learners.deleteLearner": "Delete this learner",
  "institution.learners.photoUploadError": "Error uploading photo",
  "institution.learners.photoRemoveError": "Error removing photo",
  "institution.learners.service": "Servicio",
  "institution.learners.serviceHint":
    "Elija una entrada del catálogo (pestaña Servicios). Escriba para filtrar la lista.",
  "institution.learners.serviceSearch": "Buscar un servicio…",
  "institution.learners.serviceNone": "Sin servicio",
  "institution.learners.exportSheetLearners": "Learners",
  "institution.learners.exportSheetDetails": "Course details",
  "institution.learners.export.firstName": "First name",
  "institution.learners.export.lastName": "Last name",
  "institution.learners.export.groupCol": "Group",
  "institution.learners.export.enrollments": "Enrolled courses",
  "institution.learners.export.completed": "Completed courses",
  "institution.learners.export.progressPct": "Progress (%)",
  "institution.learners.export.totalMin": "Total time (min)",
  "institution.learners.export.lastAct": "Last activity",
  "institution.learners.export.statusCol": "Status",
  "institution.learners.export.learnerCol": "Learner",
  "institution.learners.export.typeCol": "Type",
  "institution.learners.export.titleCol": "Title",
  "institution.learners.export.blocks": "Blocks visited / Total",
  "institution.learners.export.sessionsDone": "Sessions completed",
  "institution.learners.export.avgScore": "Average score (%)",
  "institution.learners.export.timeMin": "Time spent (min)",
  "institution.learners.export.dateStart": "Start date",
  "institution.learners.export.dateEnd": "End date",
  "institution.learners.export.lastAcc": "Last access",
  "institution.learners.export.typeCourse": "Course",
  "institution.learners.export.typePath": "Path",
  "institution.reminders.openPanel": "Recordatorios por correo",
  "institution.reminders.panelTitle": "Recordatorios",
  "institution.reminders.panelSubtitle":
    "Alertas automáticas enviadas por correo a los alumnos afectados. Comprobación cada hora a la hora UTC elegida. Cada alumno recibe cada recordatorio solo una vez por regla.",
  "institution.reminders.sectionRules": "Reglas",
  "institution.reminders.sectionLogs": "Registro de envíos",
  "institution.reminders.addRule": "Añadir alerta",
  "institution.reminders.removeRule": "Eliminar esta alerta",
  "institution.reminders.save": "Guardar reglas",
  "institution.reminders.loadError": "No se pudieron cargar los recordatorios.",
  "institution.reminders.saveError": "No se pudo guardar.",
  "institution.reminders.rulesEmpty":
    "Ninguna alerta. Añada una regla o guarde una lista vacía para desactivar todos los recordatorios de este contenido.",
  "institution.reminders.logsEmpty": "Aún no hay envíos registrados.",
  "institution.reminders.utcHint":
    "Elija la hora UTC (0–23) en la que el servidor evalúa esta regla. P. ej. 8 UTC ≈ 9 h en invierno en París.",
  "institution.reminders.fieldKind": "Tipo de alerta",
  "institution.reminders.fieldDays": "Días tras el evento de referencia",
  "institution.reminders.fieldHourUtc": "Hora de comprobación (UTC)",
  "institution.reminders.fieldEnabled": "Activar esta alerta",
  "institution.reminders.fieldLabel": "Etiqueta interna (opcional)",
  "institution.reminders.fieldLabelPh": "p. ej. Recordatorio D+3",
  "institution.reminders.ruleKind.eduflow_not_started_days_after_enroll":
    "Curso: no iniciado X días después de la inscripción (ficha de participante)",
  "institution.reminders.ruleKind.eduflow_incomplete_days_after_deadline":
    "Curso: no terminado X días después de la fecha límite del flujo",
  "institution.reminders.ruleKind.path_incomplete_days_after_assign":
    "Itinerario: no terminado X días después de la asignación al alumno",
  "institution.pages.brandingTitle": "Identidad visual",
  "institution.pages.webhooksTitle": "Webhooks",
  "institution.pages.landingTitle": "Página pública",
  },
  de: {
    ...institutionRhCompetenciesStrings.de,
    ...institutionBiStringsEn,
  "institution.tabs.home": "Start",
  "institution.tabs.flows": "Schulungen",
  "institution.tabs.supports": "Podcasts",
  "institution.tabs.categories": "Kategorien",
  "institution.tabs.templates": "Blockvorlagen",
  "institution.tabs.scorm": "SCORM-Import",
  "institution.tabs.designers": "Mitarbeitende",
  "institution.tabs.learners": "Lernende",
  "institution.tabs.learnerAnalytics": "Lernenden-Analyse",
  "institution.tabs.biStudio": "BI-Dashboards",
  "institution.tabs.groups": "Gruppen",
  "institution.tabs.services": "Dienste",
  "institution.tabs.branding": "Branding",
  "institution.tabs.landing": "Öffentliche Seite",
  "institution.tabs.webhooks": "Webhooks",
  "institution.tabs.ssoOidc": "SSO (OpenID Connect & SAML)",
  "institution.tabs.xapi": "xAPI (LRS)",
  "institution.tabs.mcp": "MCP",
  "institution.tabs.billing": "Abrechnung",
  "institution.nav.section.general": "Übersicht",
  "institution.nav.section.content": "Inhalte & Schulungen",
  "institution.nav.section.people": "Teams & Lernende",
  "institution.nav.section.portal": "Portal & Auftritt",
  "institution.nav.section.integrations": "Integrationen",
  "institution.nav.section.subscription": "Abonnement",
  "institution.sidebar.subtitle": "Einrichtung",
  "institution.sidebar.subtitleRh": "HR-Bereich",
  "institution.sidebar.subtitleAdmin": "Verwaltung",
  "institution.sidebar.logout": "Abmelden",
  "institution.sidebar.collapse": "Menü einklappen",
  "institution.sidebar.expandAria": "Seitenleiste erweitern",
  "institution.sidebar.collapseAria": "Seitenleiste einklappen",
  "institution.sidebar.language": "Language",
  "institution.sidebar.languageAria": "Change language",
  "institution.common.cancel": "Abbrechen",
  "institution.common.save": "Speichern",
  "institution.tabs.webinars": "Webinare",
  "institution.tabs.webinarsPilotage": "Webinar-Steuerung",
  "institution.webinars.pageTitle": "Webinar-Einstellungen",
  "institution.webinars.settingsIntro":
    "Aktivieren Sie das Modul und legen Sie die Standard-Warteraum-Nachricht fest. Webinarliste und berechtigte Moderatoren verwalten Sie im Tab « {{tabName}} ».",
  "institution.webinars.enableForInstitution": "Webinare für die Institution aktivieren",
  "institution.webinars.enabledBadge": "Modul aktiviert",
  "institution.webinars.disabledBadge": "Modul deaktiviert",
  "institution.webinars.sectionModule": "Aktivierung",
  "institution.webinars.sectionModuleHint":
    "Ermöglicht Trainern Ihrer Institution, Live-Sitzungen zu erstellen und zu leiten.",
  "institution.webinars.sectionWaitingRoom": "Warteraum",
  "institution.webinars.waitingHtmlLabel": "Warteraum-HTML (Standard)",
  "institution.webinars.waitingHtmlPlaceholder": "<p>Ihre Willkommensnachricht…</p>",
  "institution.webinars.waitingHtmlHint":
    "Einfaches HTML vor Beginn der Sitzung. Farben folgen dem Erscheinungsbild dieses Bereichs.",
  "institution.webinars.openPilotage": "Webinar-Steuerung öffnen",
  "institution.webinars.waitingPreviewTitle": "Vorschau — Warteraum-Nachricht",
  "institution.webinars.waitingPreviewHint": "So sehen Teilnehmende die Nachricht vor Webinarbeginn (Farben der Institution).",
  "institution.webinars.loadError": "Webinar-Einstellungen konnten nicht geladen werden.",
  "institution.webinars.saveSuccess": "Webinar-Einstellungen gespeichert.",
  "institution.webinars.saveError": "Speichern fehlgeschlagen.",
  "institution.common.saving": "Speichern…",
  "institution.common.delete": "Löschen",
  "institution.common.edit": "Bearbeiten",
  "institution.common.create": "Erstellen",
  "institution.common.add": "Hinzufügen",
  "institution.common.retry": "Erneut versuchen",
  "institution.common.refresh": "Aktualisieren",
  "institution.common.search": "Suchen…",
  "institution.common.loading": "Laden…",
  "institution.common.page": "Seite",
  "institution.common.of": "von",
  "institution.common.name": "Name",
  "institution.common.description": "Description",
  "institution.common.email": "Email",
  "institution.common.member": "Mitglied",
  "institution.common.members": "Mitglieder",
  "institution.common.back": "Zurück",
  "institution.common.view": "Ansehen",
  "institution.common.duplicate": "Duplizieren",
  "institution.common.toggleStatus": "Aktivieren / deaktivieren",
  "institution.common.author": "Autor",
  "institution.common.title": "Titel",
  "institution.common.status": "Status",
  "institution.common.type": "Typ",
  "institution.common.actions": "Aktionen",
  "institution.common.createdAt": "Erstellt am",
  "institution.common.assignedTo": "Zugewiesen an",
  "institution.common.completion": "Abschluss",
  "institution.common.learners": "Lernende",
  "institution.common.empty": "—",
  "institution.status.draft": "Entwurf",
  "institution.status.published": "Veröffentlicht",
  "institution.status.archived": "Archiviert",
  "institution.status.allStatuses": "Alle Status",
  "institution.status.allTypes": "Alle Typen",
  "institution.dashboard.loading": "Dashboard wird geladen…",
  "institution.dashboard.loadError": "Dashboard konnte nicht geladen werden.",
  "institution.dashboard.activity.completion": "Completion",
  "institution.dashboard.activity.enrollment": "Enrollment",
  "institution.dashboard.activity.milestone": "Milestone",
  "institution.dashboard.activity.feedback": "Feedback",
  "institution.dashboard.activity.start": "Start",
  "institution.dashboard.activity.1": "Marie Dupont completed “UX Fundamentals”",
  "institution.dashboard.activity.2": "12 new learners enrolled in “Design Thinking”",
  "institution.dashboard.activity.3": "Group “Cohort Q3” reached 80% completion",
  "institution.dashboard.activity.4": "NPS survey received 24 new responses",
  "institution.dashboard.activity.5": "Jean Martin started “Agile methods”",
  "institution.dashboard.time.5m": "5 min ago",
  "institution.dashboard.time.1h": "1h ago",
  "institution.dashboard.time.3h": "3h ago",
  "institution.dashboard.time.5h": "5h ago",
  "institution.dashboard.time.6h": "6h ago",
  "institution.dashboard.activity.flowCompleted": "{{name}} completed “{{flow}}”",
  "institution.dashboard.activity.participantJoined": "Learner added: {{email}}",
  "institution.dashboard.activity.flowStarted": "{{name}} started “{{flow}}”",
  "institution.dashboard.chartTopFlowsEmpty": "Not enough data yet. Publish courses and invite learners.",
  "institution.dashboard.activityEmpty": "No recent activity.",
  "institution.groups.title": "Gruppenverwaltung",
  "institution.groups.countShown": "{{count}} group(s)",
  "institution.groups.subtitle": "{{count}} group(s) in your institution",
  "institution.groups.create": "Create group",
  "institution.groups.statGroups": "Groups",
  "institution.groups.statTotalMembers": "Total members",
  "institution.groups.statEmpty": "Empty groups",
  "institution.groups.loadError": "Unable to load groups.",
  "institution.groups.searchPh": "Search a group…",
  "institution.groups.colGroup": "Group",
  "institution.groups.colCreated": "Created",
  "institution.groups.memberCount": "{{count}} member(s)",
  "institution.groups.emptyNone": "No groups yet. Create your first group.",
  "institution.groups.emptyFilter": "No groups match your search.",
  "institution.groups.backList": "Back to groups",
  "institution.groups.addLearner": "Add learner",
  "institution.groups.dateCreated": "Created on",
  "institution.groups.colMember": "Member",
  "institution.groups.colAdded": "Added on",
  "institution.groups.noMembers": "No members in this group",
  "institution.groups.loadGroupError": "Unable to load the group",
  "institution.groups.panelTitle": "Add learners",
  "institution.groups.noLearnersAvailable": "No learners available",
  "institution.groups.noResults": "No results",
  "institution.groups.modalEdit": "Edit group",
  "institution.groups.modalCreate": "Create group",
  "institution.groups.groupName": "Group name",
  "institution.groups.removeFromGroup": "Remove from group",
  "institution.services.title": "Unternehmensservices",
  "institution.services.subtitle":
    "Verzeichnis der Geschäftsbereiche (Personal, Finanzen usw.). Lernende ordnen Sie im Lernendenprofil zu.",
  "institution.services.create": "Neuer Bereich",
  "institution.services.loadError": "Dienste konnten nicht geladen werden.",
  "institution.services.empty": "Noch keine Einträge. Legen Sie einen Dienst an, um Lernende zuzuordnen.",
  "institution.services.modalCreate": "Dienst anlegen",
  "institution.services.modalEdit": "Dienst bearbeiten",
  "institution.services.fieldName": "Name des Dienstes",
  "institution.services.deleteConfirm":
    "Diesen Dienst löschen? Die Zuordnung betroffener Lernenden wird entfernt.",
  "institution.services.listSubtitle": "{{count}} Dienst(e) in Ihrer Einrichtung",
  "institution.services.intro":
    "Verzeichnis der Geschäftsbereiche (Personal, Finanzen usw.). Lernende ordnen Sie im Lernendenprofil zu.",
  "institution.services.statTotal": "Dienste",
  "institution.services.statWithDesc": "Mit Beschreibung",
  "institution.services.statNoDesc": "Ohne Beschreibung",
  "institution.services.searchPh": "Dienst suchen…",
  "institution.services.colService": "Dienst",
  "institution.services.colCreated": "Erstellt",
  "institution.services.emptyNone": "Noch keine Dienste. Legen Sie den ersten an.",
  "institution.services.emptyFilter": "Kein Dienst entspricht der Suche.",
  "institution.services.countShown": "{{count}} Dienst(e)",
  "institution.flows.title": "Schulungen",
  "institution.flows.subtitle": "Schulungen verwalten",
  "institution.flows.statTotal": "Total courses",
  "institution.flows.statPublished": "Published",
  "institution.flows.statLearners": "Total learners",
  "institution.flows.searchPh": "Search a course…",
  "institution.flows.colName": "Name",
  "institution.flows.empty": "No course found",
  "institution.flows.badgeEnterprise": "Enterprise training need",
  "institution.flows.deleteEnterpriseTooltip": "Move to trash (enterprise need)",
  "institution.flows.deleteEnterpriseTitle": "Remove this enterprise-linked course?",
  "institution.flows.deleteEnterpriseHint": "The course will be soft-deleted. Trainers cannot do this; only institution admin, DRH or HR can restore or remove it from this dashboard.",
  "institution.flows.deleteEnterpriseConfirm": "Move to trash",
  "institution.flows.deleteEnterpriseSuccess": "Course moved to trash.",
  "institution.flows.deleteEnterpriseError": "Action failed.",
  "institution.learningPaths.sectionTitle": "Learning paths",
  "institution.learningPaths.sectionSubtitle": "Paths owned by a member of your institution.",
  "institution.learningPaths.searchPh": "Search a path…",
  "institution.learningPaths.colItems": "Items",
  "institution.learningPaths.colAssignments": "Assignments",
  "institution.learningPaths.transferOwner": "Reassign owner",
  "institution.learningPaths.transferModalTitle": "Change path owner",
  "institution.learningPaths.transferModalHint":
    "The selected account becomes the owner; referenced library media (e.g. cover) moves when traceable in the database.",
  "institution.learningPaths.transferPickUser": "New owner",
  "institution.learningPaths.transferSubmit": "Confirm transfer",
  "institution.learningPaths.transferLoadingUsers": "Loading accounts…",
  "institution.learningPaths.transferNoCandidates": "No other collaborator available",
  "institution.learningPaths.transferError": "Transfer failed",
  "institution.learningPaths.transferSuccess": "Owner updated",
  "institution.learningPaths.empty": "No path found",
  "institution.supports.title": "Podcasts",
  "institution.supports.subtitle": "Podcasts and audio content",
  "institution.supports.searchPh": "Search a podcast…",
  "institution.supports.empty": "No podcast found",
  "institution.supports.typeDictation": "Dictation",
  "institution.supports.typeText": "Text",
  "institution.supports.typeAi": "AI",
  "institution.supports.transferOwner": "Reassign podcast creator",
  "institution.supports.transferModalTitle": "Change podcast owner",
  "institution.supports.transferModalHint":
    "The selected account becomes the podcast creator; episodes and referenced library media move when traceable in the database.",
  "institution.supports.transferPickUser": "New creator",
  "institution.supports.transferSubmit": "Confirm transfer",
  "institution.supports.transferLoadingUsers": "Loading accounts…",
  "institution.supports.transferNoCandidates": "No other collaborator available",
  "institution.supports.transferError": "Transfer failed",
  "institution.supports.transferSuccess": "Creator updated",
  "institution.categories.title": "Kategorien",
  "institution.categories.subtitle": "Organize your courses by topic",
  "institution.categories.add": "Add",
  "institution.categories.edit": "Edit category",
  "institution.categories.new": "New category",
  "institution.categories.usage": "{{count}} course(s)",
  "institution.categories.pageSubtitle": "Organize your content by category",
  "institution.categories.namePlaceholder": "Category name",
  "institution.categories.color": "Color",
  "institution.categories.descShortPh": "Short description",
  "institution.categories.usageTimes": "({{count}} uses)",
  "institution.templates.title": "Blockvorlagen",
  "institution.templates.subtitle": "Reusable template library",
  "institution.templates.statTotal": "Templates",
  "institution.templates.statUsage": "Total uses",
  "institution.templates.mostUsed": "Most used type",
  "institution.templates.preview": "Preview",
  "institution.templates.searchPh": "Search a template…",
  "institution.templates.copySuffix": " (copy)",
  "institution.templates.empty": "No templates found",
  "institution.templates.loadFormatError": "Could not load templates (invalid server response).",
  "institution.templates.usesShort": "{{count}} uses",
  "institution.templates.filterAll": "All types",
  "institution.blockTypes.text": "Text",
  "institution.blockTypes.quiz": "Quiz",
  "institution.blockTypes.video": "Video",
  "institution.blockTypes.audio": "Audio",
  "institution.blockTypes.image": "Image",
  "institution.blockTypes.document": "Document",
  "institution.blockTypes.code": "Code",
  "institution.blockTypes.discussion": "Discussion",
  "institution.scorm.title": "SCORM-Import",
  "institution.scorm.subtitle": "Import SCORM 1.2 or 2004 packages",
  "institution.scorm.dropHere": "Drag and drop your SCORM (.zip) file here",
  "institution.scorm.browseHint": "or click to browse",
  "institution.scorm.selectedFile": "Selected file: {{name}}",
  "institution.scorm.startImport": "Start import",
  "institution.scorm.importingNamed": "Import in progress: {{name}}",
  "institution.scorm.analyzing": "Analyzing modules… {{pct}}%",
  "institution.scorm.historyTitle": "Import history",
  "institution.scorm.colFile": "File",
  "institution.scorm.colDate": "Date",
  "institution.scorm.colStatus": "Status",
  "institution.scorm.colModules": "Modules",
  "institution.scorm.colVersion": "Version",
  "institution.scorm.colFlow": "Course",
  "institution.scorm.empty": "No imports yet. Drop a SCORM .zip file above.",
  "institution.scorm.openFlow": "Open",
  "institution.scorm.statusImporting": "Importing…",
  "institution.scorm.statusSuccess": "Success",
  "institution.scorm.statusError": "Error",
  "institution.designers.title": "Mitarbeitende",
  "institution.designers.subtitle": "Trainers, HR leads, HR staff and administrators for your institution (no more “teacher” wording).",
  "institution.designers.invite": "Invite",
  "institution.designers.statTotal": "Total collaborators",
  "institution.designers.statActiveMonth": "Active this month",
  "institution.designers.statFlows": "Courses created (total)",
  "institution.designers.inviteTitle": "Invite a collaborator",
  "institution.designers.inviteHelp": "Choose a role: Trainer (content / courses), HR lead, HR staff, or Admin (institution administrator on Lyrra).",
  "institution.designers.emailPh": "email@example.com",
  "institution.designers.sendInvite": "Send invitation",
  "institution.designers.loadError": "Unable to load collaborators",
  "institution.designers.inviteFail": "Invitation failed",
  "institution.designers.actionFail": "Action failed",
  "institution.designers.searchPh": "Search by name or email…",
  "institution.designers.colName": "Name",
  "institution.designers.colEmail": "Email",
  "institution.designers.colRole": "Role",
  "institution.designers.colProjects": "Projects",
  "institution.designers.colLastActivity": "Last activity",
  "institution.designers.colStatus": "Status",
  "institution.designers.colActions": "Actions",
  "institution.designers.empty": "No collaborator found",
  "institution.designers.roleAdmin": "Admin",
  "institution.designers.roleTeacher": "Trainer",
  "institution.designers.roleTrainingLead": "Training lead",
  "institution.designers.roleCollaborator": "Collaborator",
  "institution.designers.roleOptFormateur": "Trainer",
  "institution.designers.roleOptDrh": "HR lead",
  "institution.designers.roleOptRh": "HR",
  "institution.designers.roleOptAdmin": "Admin",
  "institution.designers.statusActive": "Active",
  "institution.designers.statusInvited": "Invited",
  "institution.designers.statusSuspended": "Suspended",
  "institution.designers.menuView": "View profile",
  "institution.designers.menuMakeAdmin": "Make admin",
  "institution.designers.menuSuspend": "Suspend",
  "institution.designers.menuRemove": "Remove",
  "institution.billing.title": "Abrechnung",
  "institution.billing.subtitle": "Subscription, usage and invoices",
  "institution.billing.planLabel": "Current plan",
  "institution.billing.planPro": "Pro",
  "institution.billing.priceExample": "€299",
  "institution.billing.perMonth": "/ month",
  "institution.billing.renewalMock": "Renews on February 1, 2025",
  "institution.billing.featureCollaborators": "10 collaborators",
  "institution.billing.featureLearners": "500 learners",
  "institution.billing.featureStorage": "50 GB storage",
  "institution.billing.featureSupport": "Priority support",
  "institution.billing.featureApi": "MCP API",
  "institution.billing.changePlan": "Change plan",
  "institution.billing.usageCollaborators": "Collaborators",
  "institution.billing.usageLearners": "Learners",
  "institution.billing.usageStorage": "Storage",
  "institution.billing.storageUnit": "GB",
  "institution.billing.cardMasked": "Visa •••• 4242",
  "institution.billing.cardExpires": "Expires {{date}}",
  "institution.billing.invoicesTitle": "Invoices",
  "institution.billing.colRef": "Reference",
  "institution.billing.colDate": "Date",
  "institution.billing.colAmount": "Amount",
  "institution.billing.colStatus": "Status",
  "institution.billing.colPdf": "PDF",
  "institution.billing.invPaid": "Paid",
  "institution.billing.invOpen": "Pending",
  "institution.billing.invDraft": "Draft",
  "institution.billing.invVoid": "Void",
  "institution.billing.invUncollectible": "Uncollectible",
  "institution.mcp.title": "MCP — Model Context Protocol",
  "institution.landing.designerTitle": "Page designer",
  "institution.learners.title": "Lernende",
  "institution.learners.searchPh": "Search a learner…",
  "institution.learners.filterStatus": "Status",
  "institution.learners.filterPlaceholder": "Filter",
  "institution.learners.selectedCount": "{{count}} selected",
  "institution.learners.exportSelection": "Export selection",
  "institution.learners.exportAll": "Export all",
  "institution.learners.colLearner": "Learner",
  "institution.learners.colGroup": "Group",
  "institution.learners.colLastActive": "Last activity",
  "institution.learners.colStatus": "Status",
  "institution.learners.empty": "No learner found",
  "institution.learners.countList": "{{count}} learner(s)",
  "institution.learners.subtitle": "{{count}} learner(s) enrolled in your institution",
  "institution.learners.importCsv": "Import CSV",
  "institution.learners.add": "Add",
  "institution.learners.statLearners": "Learners",
  "institution.learners.statActive30": "Active (30d)",
  "institution.learners.statEnrollments": "Enrollments",
  "institution.learners.statCompleted": "Completed courses",
  "institution.learners.statusAll": "All statuses",
  "institution.learners.statusActive": "Active",
  "institution.learners.statusInactive": "Inactive",
  "institution.learners.statusCompleted": "Completed",
  "institution.learners.sheetTitle": "Learner profile",
  "institution.learners.openProfileDetail": "Profildetails",
  "institution.learners.groupsCatalogTitle": "Konfigurierte Gruppen",
  "institution.learners.groupsCatalogSubtitle": "Definiert im Tab « Gruppen » Ihrer Einrichtung.",
  "institution.learners.replacePhoto": "Replace",
  "institution.learners.addPhoto": "Add photo",
  "institution.learners.removePhoto": "Remove",
  "institution.learners.firstName": "First name",
  "institution.learners.lastName": "Last name",
  "institution.learners.save": "Save",
  "institution.learners.deactivate": "Deactivate",
  "institution.learners.reactivate": "Reactivate",
  "institution.learners.lastActivity": "Last activity:",
  "institution.learners.paths": "Paths ({{count}})",
  "institution.learners.noPaths": "No assigned path",
  "institution.learners.noFlowsEnrolled": "No enrolled course",
  "institution.learners.done": "Done",
  "institution.learners.inProgress": "In progress",
  "institution.learners.itemsProgress": "{{done}}/{{total}} items",
  "institution.learners.flows": "Courses",
  "institution.learners.completedF": "Completed",
  "institution.learners.totalTime": "Total time",
  "institution.learners.progress": "Progress",
  "institution.learners.flowDone": "Completed",
  "institution.learners.blocks": "{{visited}}/{{total}} blocks",
  "institution.learners.score": "Score: {{score}}%",
  "institution.learners.sessions": "{{count}} sessions",
  "institution.learners.started": "Started:",
  "institution.learners.ended": "Ended:",
  "institution.learners.lastAccess": "Last access:",
  "institution.learners.podcasts": "Podcasts",
  "institution.learners.noPodcastListen": "No listening recorded",
  "institution.learners.deleteTitle": "Delete this learner?",
  "institution.learners.deleteDesc": "Are you sure you want to permanently delete {{name}} ({{email}})? This cannot be undone and will remove all related data.",
  "institution.learners.deactivateTitle": "Deactivate this learner?",
  "institution.learners.reactivateTitle": "Reactivate this learner?",
  "institution.learners.deactivateDesc": "{{name}} will not be able to access courses while deactivated.",
  "institution.learners.reactivateDesc": "{{name}} will regain access to their courses.",
  "institution.learners.deleteLearner": "Delete this learner",
  "institution.learners.photoUploadError": "Error uploading photo",
  "institution.learners.photoRemoveError": "Error removing photo",
  "institution.learners.service": "Organisationseinheit",
  "institution.learners.serviceHint":
    "Wählen Sie einen Eintrag aus dem Verzeichnis (Registerkarte „Dienste”). Tippen zum Filtern der Liste.",
  "institution.learners.serviceSearch": "Dienst suchen…",
  "institution.learners.serviceNone": "Keine Organisationseinheit",
  "institution.learners.exportSheetLearners": "Learners",
  "institution.learners.exportSheetDetails": "Course details",
  "institution.learners.export.firstName": "First name",
  "institution.learners.export.lastName": "Last name",
  "institution.learners.export.groupCol": "Group",
  "institution.learners.export.enrollments": "Enrolled courses",
  "institution.learners.export.completed": "Completed courses",
  "institution.learners.export.progressPct": "Progress (%)",
  "institution.learners.export.totalMin": "Total time (min)",
  "institution.learners.export.lastAct": "Last activity",
  "institution.learners.export.statusCol": "Status",
  "institution.learners.export.learnerCol": "Learner",
  "institution.learners.export.typeCol": "Type",
  "institution.learners.export.titleCol": "Title",
  "institution.learners.export.blocks": "Blocks visited / Total",
  "institution.learners.export.sessionsDone": "Sessions completed",
  "institution.learners.export.avgScore": "Average score (%)",
  "institution.learners.export.timeMin": "Time spent (min)",
  "institution.learners.export.dateStart": "Start date",
  "institution.learners.export.dateEnd": "End date",
  "institution.learners.export.lastAcc": "Last access",
  "institution.learners.export.typeCourse": "Course",
  "institution.learners.export.typePath": "Path",
  "institution.reminders.openPanel": "E-Mail-Erinnerungen",
  "institution.reminders.panelTitle": "Erinnerungen",
  "institution.reminders.panelSubtitle":
    "Automatische Benachrichtigungen per E-Mail an betroffene Lernende. Stündliche Prüfung zur gewählten UTC-Zeit. Jede Regel wird pro Lernendem höchstens einmal ausgelöst.",
  "institution.reminders.sectionRules": "Regeln",
  "institution.reminders.sectionLogs": "Versandprotokoll",
  "institution.reminders.addRule": "Warnung hinzufügen",
  "institution.reminders.removeRule": "Diese Warnung entfernen",
  "institution.reminders.save": "Regeln speichern",
  "institution.reminders.loadError": "Erinnerungen konnten nicht geladen werden.",
  "institution.reminders.saveError": "Speichern fehlgeschlagen.",
  "institution.reminders.rulesEmpty":
    "Keine Warnung. Fügen Sie eine Regel hinzu oder speichern Sie eine leere Liste, um alle Erinnerungen für diesen Inhalt zu deaktivieren.",
  "institution.reminders.logsEmpty": "Noch keine Versände protokolliert.",
  "institution.reminders.utcHint":
    "UTC-Stunde (0–23), zu der der Server diese Regel prüft. Z. B. 8 UTC ≈ 9 Uhr MEZ in Paris.",
  "institution.reminders.fieldKind": "Warnungstyp",
  "institution.reminders.fieldDays": "Tage nach dem Bezugsereignis",
  "institution.reminders.fieldHourUtc": "Prüfzeit (UTC)",
  "institution.reminders.fieldEnabled": "Diese Warnung aktivieren",
  "institution.reminders.fieldLabel": "Interne Bezeichnung (optional)",
  "institution.reminders.fieldLabelPh": "z. B. Erinnerung T+3",
  "institution.reminders.ruleKind.eduflow_not_started_days_after_enroll":
    "Kurs: nicht begonnen X Tage nach Einschreibung (Teilnehmerdatensatz)",
  "institution.reminders.ruleKind.eduflow_incomplete_days_after_deadline":
    "Kurs: nicht abgeschlossen X Tage nach Ablauffrist des Flows",
  "institution.reminders.ruleKind.path_incomplete_days_after_assign":
    "Lernpfad: nicht abgeschlossen X Tage nach Zuweisung an den Lernenden",
  "institution.pages.brandingTitle": "Visuelle Identität",
  "institution.pages.webhooksTitle": "Webhooks",
  "institution.pages.landingTitle": "Öffentliche Seite",
  },
  it: {
    ...institutionRhCompetenciesStrings.it,
    ...institutionBiStringsEn,
  "institution.tabs.home": "Home",
  "institution.tabs.flows": "Corsi",
  "institution.tabs.supports": "Podcasts",
  "institution.tabs.categories": "Categorie",
  "institution.tabs.templates": "Modelli di blocchi",
  "institution.tabs.scorm": "Importazione SCORM",
  "institution.tabs.designers": "Collaboratori",
  "institution.tabs.learners": "Allievi",
  "institution.tabs.learnerAnalytics": "Analisi allievi",
  "institution.tabs.biStudio": "Dashboard BI",
  "institution.tabs.groups": "Gruppi",
  "institution.tabs.services": "Servizi",
  "institution.tabs.branding": "Personalizzazione",
  "institution.tabs.landing": "Pagina pubblica",
  "institution.tabs.webhooks": "Webhooks",
  "institution.tabs.ssoOidc": "SSO (OpenID Connect & SAML)",
  "institution.tabs.xapi": "xAPI (LRS)",
  "institution.tabs.mcp": "MCP",
  "institution.tabs.billing": "Fatturazione",
  "institution.nav.section.general": "Panoramica",
  "institution.nav.section.content": "Contenuti e formazione",
  "institution.nav.section.people": "Team e discenti",
  "institution.nav.section.portal": "Portale e immagine",
  "institution.nav.section.integrations": "Integrazioni",
  "institution.nav.section.subscription": "Abbonamento",
  "institution.sidebar.subtitle": "Istituto",
  "institution.sidebar.subtitleRh": "Spazio HR",
  "institution.sidebar.subtitleAdmin": "Amministrazione",
  "institution.sidebar.logout": "Esci",
  "institution.sidebar.collapse": "Comprimi menu",
  "institution.sidebar.expandAria": "Espandi barra laterale",
  "institution.sidebar.collapseAria": "Comprimi barra laterale",
  "institution.sidebar.language": "Language",
  "institution.sidebar.languageAria": "Change language",
  "institution.common.cancel": "Annulla",
  "institution.common.save": "Salva",
  "institution.tabs.webinars": "Webinar",
  "institution.tabs.webinarsPilotage": "Gestione webinar",
  "institution.webinars.pageTitle": "Impostazioni webinar",
  "institution.webinars.settingsIntro":
    "Attiva il modulo e imposta il messaggio predefinito della sala d’attesa. Elenco webinar e relatori autorizzati si gestiscono nella scheda « {{tabName}} ».",
  "institution.webinars.enableForInstitution": "Attiva i webinar per l’istituto",
  "institution.webinars.enabledBadge": "Modulo attivo",
  "institution.webinars.disabledBadge": "Modulo disattivo",
  "institution.webinars.sectionModule": "Attivazione",
  "institution.webinars.sectionModuleHint": "Consente ai formatori dell’istituto di creare e condurre sessioni live.",
  "institution.webinars.sectionWaitingRoom": "Sala d’attesa",
  "institution.webinars.waitingHtmlLabel": "HTML sala d’attesa (predefinito)",
  "institution.webinars.waitingHtmlPlaceholder": "<p>Il tuo messaggio di benvenuto…</p>",
  "institution.webinars.waitingHtmlHint":
    "HTML semplice mostrato ai partecipanti prima dell’inizio. I colori seguono il tema di questo spazio.",
  "institution.webinars.openPilotage": "Apri gestione webinar",
  "institution.webinars.waitingPreviewTitle": "Anteprima — messaggio d’attesa",
  "institution.webinars.waitingPreviewHint": "Come lo vedono i partecipanti prima dell’inizio del webinar.",
  "institution.webinars.loadError": "Impossibile caricare le impostazioni webinar.",
  "institution.webinars.saveSuccess": "Impostazioni webinar salvate.",
  "institution.webinars.saveError": "Salvataggio non riuscito.",
  "institution.common.saving": "Salvataggio…",
  "institution.common.delete": "Elimina",
  "institution.common.edit": "Modifica",
  "institution.common.create": "Create",
  "institution.common.add": "Add",
  "institution.common.retry": "Retry",
  "institution.common.refresh": "Refresh",
  "institution.common.search": "Search…",
  "institution.common.loading": "Loading…",
  "institution.common.page": "Pagina",
  "institution.common.of": "di",
  "institution.common.name": "Name",
  "institution.common.description": "Description",
  "institution.common.email": "Email",
  "institution.common.member": "Member",
  "institution.common.members": "Members",
  "institution.common.back": "Back",
  "institution.common.view": "View",
  "institution.common.duplicate": "Duplicate",
  "institution.common.toggleStatus": "Enable / disable",
  "institution.common.author": "Author",
  "institution.common.title": "Title",
  "institution.common.status": "Status",
  "institution.common.type": "Type",
  "institution.common.actions": "Actions",
  "institution.common.createdAt": "Created",
  "institution.common.assignedTo": "Assigned to",
  "institution.common.completion": "Completion",
  "institution.common.learners": "Learners",
  "institution.common.empty": "—",
  "institution.status.draft": "Bozza",
  "institution.status.published": "Pubblicato",
  "institution.status.archived": "Archiviato",
  "institution.status.allStatuses": "All statuses",
  "institution.status.allTypes": "All types",
  "institution.dashboard.loading": "Caricamento dashboard…",
  "institution.dashboard.loadError": "Impossibile caricare la dashboard.",
  "institution.dashboard.activity.completion": "Completion",
  "institution.dashboard.activity.enrollment": "Enrollment",
  "institution.dashboard.activity.milestone": "Milestone",
  "institution.dashboard.activity.feedback": "Feedback",
  "institution.dashboard.activity.start": "Start",
  "institution.dashboard.activity.1": "Marie Dupont completed “UX Fundamentals”",
  "institution.dashboard.activity.2": "12 new learners enrolled in “Design Thinking”",
  "institution.dashboard.activity.3": "Group “Cohort Q3” reached 80% completion",
  "institution.dashboard.activity.4": "NPS survey received 24 new responses",
  "institution.dashboard.activity.5": "Jean Martin started “Agile methods”",
  "institution.dashboard.time.5m": "5 min ago",
  "institution.dashboard.time.1h": "1h ago",
  "institution.dashboard.time.3h": "3h ago",
  "institution.dashboard.time.5h": "5h ago",
  "institution.dashboard.time.6h": "6h ago",
  "institution.dashboard.activity.flowCompleted": "{{name}} completed “{{flow}}”",
  "institution.dashboard.activity.participantJoined": "Learner added: {{email}}",
  "institution.dashboard.activity.flowStarted": "{{name}} started “{{flow}}”",
  "institution.dashboard.chartTopFlowsEmpty": "Not enough data yet. Publish courses and invite learners.",
  "institution.dashboard.activityEmpty": "No recent activity.",
  "institution.groups.title": "Gestione gruppi",
  "institution.groups.countShown": "{{count}} group(s)",
  "institution.groups.subtitle": "{{count}} group(s) in your institution",
  "institution.groups.create": "Create group",
  "institution.groups.statGroups": "Groups",
  "institution.groups.statTotalMembers": "Total members",
  "institution.groups.statEmpty": "Empty groups",
  "institution.groups.loadError": "Unable to load groups.",
  "institution.groups.searchPh": "Search a group…",
  "institution.groups.colGroup": "Group",
  "institution.groups.colCreated": "Created",
  "institution.groups.memberCount": "{{count}} member(s)",
  "institution.groups.emptyNone": "No groups yet. Create your first group.",
  "institution.groups.emptyFilter": "No groups match your search.",
  "institution.groups.backList": "Back to groups",
  "institution.groups.addLearner": "Add learner",
  "institution.groups.dateCreated": "Created on",
  "institution.groups.colMember": "Member",
  "institution.groups.colAdded": "Added on",
  "institution.groups.noMembers": "No members in this group",
  "institution.groups.loadGroupError": "Unable to load the group",
  "institution.groups.panelTitle": "Add learners",
  "institution.groups.noLearnersAvailable": "No learners available",
  "institution.groups.noResults": "No results",
  "institution.groups.modalEdit": "Edit group",
  "institution.groups.modalCreate": "Create group",
  "institution.groups.groupName": "Group name",
  "institution.groups.removeFromGroup": "Remove from group",
  "institution.services.title": "Servizi aziendali",
  "institution.services.subtitle":
    "Elenco delle funzioni aziendali (HR, finanza, ecc.). Assegna i partecipanti dalla scheda partecipante.",
  "institution.services.create": "Nuovo servizio",
  "institution.services.loadError": "Impossibile caricare i servizi.",
  "institution.services.empty": "Non ci sono ancora servizi. Creane uno per assegnare i partecipanti.",
  "institution.services.modalCreate": "Crea servizio",
  "institution.services.modalEdit": "Modifica servizio",
  "institution.services.fieldName": "Nome del servizio",
  "institution.services.deleteConfirm":
    "Eliminare questo servizio? I partecipanti collegati non avranno più un servizio assegnato.",
  "institution.services.listSubtitle": "{{count}} servizio/i nella tua organizzazione",
  "institution.services.intro":
    "Elenco delle funzioni aziendali (HR, finanza, ecc.). Assegna i partecipanti dalla scheda partecipante.",
  "institution.services.statTotal": "Servizi",
  "institution.services.statWithDesc": "Con descrizione",
  "institution.services.statNoDesc": "Senza descrizione",
  "institution.services.searchPh": "Cerca un servizio…",
  "institution.services.colService": "Servizio",
  "institution.services.colCreated": "Creato",
  "institution.services.emptyNone": "Nessun servizio. Creane uno.",
  "institution.services.emptyFilter": "Nessun servizio corrisponde alla ricerca.",
  "institution.services.countShown": "{{count}} servizio/i",
  "institution.flows.title": "Corsi",
  "institution.flows.subtitle": "Manage your courses",
  "institution.flows.statTotal": "Total courses",
  "institution.flows.statPublished": "Published",
  "institution.flows.statLearners": "Total learners",
  "institution.flows.searchPh": "Search a course…",
  "institution.flows.colName": "Name",
  "institution.flows.empty": "No course found",
  "institution.flows.badgeEnterprise": "Enterprise training need",
  "institution.flows.deleteEnterpriseTooltip": "Move to trash (enterprise need)",
  "institution.flows.deleteEnterpriseTitle": "Remove this enterprise-linked course?",
  "institution.flows.deleteEnterpriseHint": "The course will be soft-deleted. Trainers cannot do this; only institution admin, DRH or HR can restore or remove it from this dashboard.",
  "institution.flows.deleteEnterpriseConfirm": "Move to trash",
  "institution.flows.deleteEnterpriseSuccess": "Course moved to trash.",
  "institution.flows.deleteEnterpriseError": "Action failed.",
  "institution.learningPaths.sectionTitle": "Learning paths",
  "institution.learningPaths.sectionSubtitle": "Paths owned by a member of your institution.",
  "institution.learningPaths.searchPh": "Search a path…",
  "institution.learningPaths.colItems": "Items",
  "institution.learningPaths.colAssignments": "Assignments",
  "institution.learningPaths.transferOwner": "Reassign owner",
  "institution.learningPaths.transferModalTitle": "Change path owner",
  "institution.learningPaths.transferModalHint":
    "The selected account becomes the owner; referenced library media (e.g. cover) moves when traceable in the database.",
  "institution.learningPaths.transferPickUser": "New owner",
  "institution.learningPaths.transferSubmit": "Confirm transfer",
  "institution.learningPaths.transferLoadingUsers": "Loading accounts…",
  "institution.learningPaths.transferNoCandidates": "No other collaborator available",
  "institution.learningPaths.transferError": "Transfer failed",
  "institution.learningPaths.transferSuccess": "Owner updated",
  "institution.learningPaths.empty": "No path found",
  "institution.supports.title": "Podcasts",
  "institution.supports.subtitle": "Podcasts and audio content",
  "institution.supports.searchPh": "Search a podcast…",
  "institution.supports.empty": "No podcast found",
  "institution.supports.typeDictation": "Dictation",
  "institution.supports.typeText": "Text",
  "institution.supports.typeAi": "AI",
  "institution.supports.transferOwner": "Reassign podcast creator",
  "institution.supports.transferModalTitle": "Change podcast owner",
  "institution.supports.transferModalHint":
    "The selected account becomes the podcast creator; episodes and referenced library media move when traceable in the database.",
  "institution.supports.transferPickUser": "New creator",
  "institution.supports.transferSubmit": "Confirm transfer",
  "institution.supports.transferLoadingUsers": "Loading accounts…",
  "institution.supports.transferNoCandidates": "No other collaborator available",
  "institution.supports.transferError": "Transfer failed",
  "institution.supports.transferSuccess": "Creator updated",
  "institution.categories.title": "Categorie",
  "institution.categories.subtitle": "Organize your courses by topic",
  "institution.categories.add": "Add",
  "institution.categories.edit": "Edit category",
  "institution.categories.new": "New category",
  "institution.categories.usage": "{{count}} course(s)",
  "institution.categories.pageSubtitle": "Organize your content by category",
  "institution.categories.namePlaceholder": "Category name",
  "institution.categories.color": "Color",
  "institution.categories.descShortPh": "Short description",
  "institution.categories.usageTimes": "({{count}} uses)",
  "institution.templates.title": "Modelli di blocchi",
  "institution.templates.subtitle": "Reusable template library",
  "institution.templates.statTotal": "Templates",
  "institution.templates.statUsage": "Total uses",
  "institution.templates.mostUsed": "Most used type",
  "institution.templates.preview": "Preview",
  "institution.templates.searchPh": "Search a template…",
  "institution.templates.copySuffix": " (copy)",
  "institution.templates.empty": "No templates found",
  "institution.templates.loadFormatError": "Could not load templates (invalid server response).",
  "institution.templates.usesShort": "{{count}} uses",
  "institution.templates.filterAll": "All types",
  "institution.blockTypes.text": "Text",
  "institution.blockTypes.quiz": "Quiz",
  "institution.blockTypes.video": "Video",
  "institution.blockTypes.audio": "Audio",
  "institution.blockTypes.image": "Image",
  "institution.blockTypes.document": "Document",
  "institution.blockTypes.code": "Code",
  "institution.blockTypes.discussion": "Discussion",
  "institution.scorm.title": "Importazione SCORM",
  "institution.scorm.subtitle": "Import SCORM 1.2 or 2004 packages",
  "institution.scorm.dropHere": "Drag and drop your SCORM (.zip) file here",
  "institution.scorm.browseHint": "or click to browse",
  "institution.scorm.selectedFile": "Selected file: {{name}}",
  "institution.scorm.startImport": "Start import",
  "institution.scorm.importingNamed": "Import in progress: {{name}}",
  "institution.scorm.analyzing": "Analyzing modules… {{pct}}%",
  "institution.scorm.historyTitle": "Import history",
  "institution.scorm.colFile": "File",
  "institution.scorm.colDate": "Date",
  "institution.scorm.colStatus": "Status",
  "institution.scorm.colModules": "Modules",
  "institution.scorm.colVersion": "Version",
  "institution.scorm.colFlow": "Course",
  "institution.scorm.empty": "No imports yet. Drop a SCORM .zip file above.",
  "institution.scorm.openFlow": "Open",
  "institution.scorm.statusImporting": "Importing…",
  "institution.scorm.statusSuccess": "Success",
  "institution.scorm.statusError": "Error",
  "institution.designers.title": "Collaboratori",
  "institution.designers.subtitle": "Trainers, HR leads, HR staff and administrators for your institution (no more “teacher” wording).",
  "institution.designers.invite": "Invite",
  "institution.designers.statTotal": "Total collaborators",
  "institution.designers.statActiveMonth": "Active this month",
  "institution.designers.statFlows": "Courses created (total)",
  "institution.designers.inviteTitle": "Invite a collaborator",
  "institution.designers.inviteHelp": "Choose a role: Trainer (content / courses), HR lead, HR staff, or Admin (institution administrator on Lyrra).",
  "institution.designers.emailPh": "email@example.com",
  "institution.designers.sendInvite": "Send invitation",
  "institution.designers.loadError": "Unable to load collaborators",
  "institution.designers.inviteFail": "Invitation failed",
  "institution.designers.actionFail": "Action failed",
  "institution.designers.searchPh": "Search by name or email…",
  "institution.designers.colName": "Name",
  "institution.designers.colEmail": "Email",
  "institution.designers.colRole": "Role",
  "institution.designers.colProjects": "Projects",
  "institution.designers.colLastActivity": "Last activity",
  "institution.designers.colStatus": "Status",
  "institution.designers.colActions": "Actions",
  "institution.designers.empty": "No collaborator found",
  "institution.designers.roleAdmin": "Admin",
  "institution.designers.roleTeacher": "Trainer",
  "institution.designers.roleTrainingLead": "Training lead",
  "institution.designers.roleCollaborator": "Collaborator",
  "institution.designers.roleOptFormateur": "Trainer",
  "institution.designers.roleOptDrh": "HR lead",
  "institution.designers.roleOptRh": "HR",
  "institution.designers.roleOptAdmin": "Admin",
  "institution.designers.statusActive": "Active",
  "institution.designers.statusInvited": "Invited",
  "institution.designers.statusSuspended": "Suspended",
  "institution.designers.menuView": "View profile",
  "institution.designers.menuMakeAdmin": "Make admin",
  "institution.designers.menuSuspend": "Suspend",
  "institution.designers.menuRemove": "Remove",
  "institution.billing.title": "Fatturazione",
  "institution.billing.subtitle": "Subscription, usage and invoices",
  "institution.billing.planLabel": "Current plan",
  "institution.billing.planPro": "Pro",
  "institution.billing.priceExample": "€299",
  "institution.billing.perMonth": "/ month",
  "institution.billing.renewalMock": "Renews on February 1, 2025",
  "institution.billing.featureCollaborators": "10 collaborators",
  "institution.billing.featureLearners": "500 learners",
  "institution.billing.featureStorage": "50 GB storage",
  "institution.billing.featureSupport": "Priority support",
  "institution.billing.featureApi": "MCP API",
  "institution.billing.changePlan": "Change plan",
  "institution.billing.usageCollaborators": "Collaborators",
  "institution.billing.usageLearners": "Learners",
  "institution.billing.usageStorage": "Storage",
  "institution.billing.storageUnit": "GB",
  "institution.billing.cardMasked": "Visa •••• 4242",
  "institution.billing.cardExpires": "Expires {{date}}",
  "institution.billing.invoicesTitle": "Invoices",
  "institution.billing.colRef": "Reference",
  "institution.billing.colDate": "Date",
  "institution.billing.colAmount": "Amount",
  "institution.billing.colStatus": "Status",
  "institution.billing.colPdf": "PDF",
  "institution.billing.invPaid": "Paid",
  "institution.billing.invOpen": "Pending",
  "institution.billing.invDraft": "Draft",
  "institution.billing.invVoid": "Void",
  "institution.billing.invUncollectible": "Uncollectible",
  "institution.mcp.title": "MCP — Model Context Protocol",
  "institution.landing.designerTitle": "Page designer",
  "institution.learners.title": "Allievi",
  "institution.learners.searchPh": "Search a learner…",
  "institution.learners.filterStatus": "Status",
  "institution.learners.filterPlaceholder": "Filter",
  "institution.learners.selectedCount": "{{count}} selected",
  "institution.learners.exportSelection": "Export selection",
  "institution.learners.exportAll": "Export all",
  "institution.learners.colLearner": "Learner",
  "institution.learners.colGroup": "Group",
  "institution.learners.colLastActive": "Last activity",
  "institution.learners.colStatus": "Status",
  "institution.learners.empty": "No learner found",
  "institution.learners.countList": "{{count}} learner(s)",
  "institution.learners.subtitle": "{{count}} learner(s) enrolled in your institution",
  "institution.learners.importCsv": "Import CSV",
  "institution.learners.add": "Add",
  "institution.learners.statLearners": "Learners",
  "institution.learners.statActive30": "Active (30d)",
  "institution.learners.statEnrollments": "Enrollments",
  "institution.learners.statCompleted": "Completed courses",
  "institution.learners.statusAll": "All statuses",
  "institution.learners.statusActive": "Active",
  "institution.learners.statusInactive": "Inactive",
  "institution.learners.statusCompleted": "Completed",
  "institution.learners.sheetTitle": "Learner profile",
  "institution.learners.openProfileDetail": "Dettaglio del profilo",
  "institution.learners.groupsCatalogTitle": "Gruppi configurati",
  "institution.learners.groupsCatalogSubtitle": "Elenco definito nella scheda « Gruppi » del vostro istituto.",
  "institution.learners.replacePhoto": "Replace",
  "institution.learners.addPhoto": "Add photo",
  "institution.learners.removePhoto": "Remove",
  "institution.learners.firstName": "First name",
  "institution.learners.lastName": "Last name",
  "institution.learners.save": "Save",
  "institution.learners.deactivate": "Deactivate",
  "institution.learners.reactivate": "Reactivate",
  "institution.learners.lastActivity": "Last activity:",
  "institution.learners.paths": "Paths ({{count}})",
  "institution.learners.noPaths": "No assigned path",
  "institution.learners.noFlowsEnrolled": "No enrolled course",
  "institution.learners.done": "Done",
  "institution.learners.inProgress": "In progress",
  "institution.learners.itemsProgress": "{{done}}/{{total}} items",
  "institution.learners.flows": "Courses",
  "institution.learners.completedF": "Completed",
  "institution.learners.totalTime": "Total time",
  "institution.learners.progress": "Progress",
  "institution.learners.flowDone": "Completed",
  "institution.learners.blocks": "{{visited}}/{{total}} blocks",
  "institution.learners.score": "Score: {{score}}%",
  "institution.learners.sessions": "{{count}} sessions",
  "institution.learners.started": "Started:",
  "institution.learners.ended": "Ended:",
  "institution.learners.lastAccess": "Last access:",
  "institution.learners.podcasts": "Podcasts",
  "institution.learners.noPodcastListen": "No listening recorded",
  "institution.learners.deleteTitle": "Delete this learner?",
  "institution.learners.deleteDesc": "Are you sure you want to permanently delete {{name}} ({{email}})? This cannot be undone and will remove all related data.",
  "institution.learners.deactivateTitle": "Deactivate this learner?",
  "institution.learners.reactivateTitle": "Reactivate this learner?",
  "institution.learners.deactivateDesc": "{{name}} will not be able to access courses while deactivated.",
  "institution.learners.reactivateDesc": "{{name}} will regain access to their courses.",
  "institution.learners.deleteLearner": "Delete this learner",
  "institution.learners.photoUploadError": "Error uploading photo",
  "institution.learners.photoRemoveError": "Error removing photo",
  "institution.learners.service": "Servizio",
  "institution.learners.serviceHint":
    "Scegli una voce dell'elenco (scheda Servizi). Digita per filtrare l'elenco.",
  "institution.learners.serviceSearch": "Cerca un servizio…",
  "institution.learners.serviceNone": "Nessun servizio",
  "institution.learners.exportSheetLearners": "Learners",
  "institution.learners.exportSheetDetails": "Course details",
  "institution.learners.export.firstName": "First name",
  "institution.learners.export.lastName": "Last name",
  "institution.learners.export.groupCol": "Group",
  "institution.learners.export.enrollments": "Enrolled courses",
  "institution.learners.export.completed": "Completed courses",
  "institution.learners.export.progressPct": "Progress (%)",
  "institution.learners.export.totalMin": "Total time (min)",
  "institution.learners.export.lastAct": "Last activity",
  "institution.learners.export.statusCol": "Status",
  "institution.learners.export.learnerCol": "Learner",
  "institution.learners.export.typeCol": "Type",
  "institution.learners.export.titleCol": "Title",
  "institution.learners.export.blocks": "Blocks visited / Total",
  "institution.learners.export.sessionsDone": "Sessions completed",
  "institution.learners.export.avgScore": "Average score (%)",
  "institution.learners.export.timeMin": "Time spent (min)",
  "institution.learners.export.dateStart": "Start date",
  "institution.learners.export.dateEnd": "End date",
  "institution.learners.export.lastAcc": "Last access",
  "institution.learners.export.typeCourse": "Course",
  "institution.learners.export.typePath": "Path",
  "institution.reminders.openPanel": "Promemoria e-mail",
  "institution.reminders.panelTitle": "Promemoria",
  "institution.reminders.panelSubtitle":
    "Avvisi automatici inviati per e-mail agli apprendenti interessati. Verifica ogni ora all’ora UTC scelta. Ogni regola viene inviata al massimo una volta per apprendente.",
  "institution.reminders.sectionRules": "Regole",
  "institution.reminders.sectionLogs": "Registro invii",
  "institution.reminders.addRule": "Aggiungi avviso",
  "institution.reminders.removeRule": "Rimuovi questo avviso",
  "institution.reminders.save": "Salva regole",
  "institution.reminders.loadError": "Impossibile caricare i promemoria.",
  "institution.reminders.saveError": "Impossibile salvare.",
  "institution.reminders.rulesEmpty":
    "Nessun avviso. Aggiungi una regola oppure salva un elenco vuoto per disattivare tutti i promemoria per questo contenuto.",
  "institution.reminders.logsEmpty": "Nessun invio registrato per ora.",
  "institution.reminders.utcHint":
    "Ora UTC (0–23) in cui il server valuta questa regola. Es. 8 UTC ≈ 9 invernale a Parigi.",
  "institution.reminders.fieldKind": "Tipo di avviso",
  "institution.reminders.fieldDays": "Giorni dopo l’evento di riferimento",
  "institution.reminders.fieldHourUtc": "Ora di verifica (UTC)",
  "institution.reminders.fieldEnabled": "Attiva questo avviso",
  "institution.reminders.fieldLabel": "Etichetta interna (opzionale)",
  "institution.reminders.fieldLabelPh": "es. Sollecito G+3",
  "institution.reminders.ruleKind.eduflow_not_started_days_after_enroll":
    "Corso: non iniziato X giorni dopo l’iscrizione (scheda partecipante)",
  "institution.reminders.ruleKind.eduflow_incomplete_days_after_deadline":
    "Corso: non completato X giorni dopo la scadenza del percorso",
  "institution.reminders.ruleKind.path_incomplete_days_after_assign":
    "Percorso: non completato X giorni dopo l’assegnazione all’apprendente",
  "institution.pages.brandingTitle": "Identità visiva",
  "institution.pages.webhooksTitle": "Webhooks",
  "institution.pages.landingTitle": "Pagina pubblica",
  },
  pt: {
    ...institutionRhCompetenciesStrings.pt,
    ...institutionBiStringsEn,
  "institution.tabs.home": "Início",
  "institution.tabs.flows": "Formações",
  "institution.tabs.supports": "Podcasts",
  "institution.tabs.categories": "Categorias",
  "institution.tabs.templates": "Modelos de blocos",
  "institution.tabs.scorm": "Importação SCORM",
  "institution.tabs.designers": "Colaboradores",
  "institution.tabs.learners": "Aprendizes",
  "institution.tabs.learnerAnalytics": "Análise de aprendizes",
  "institution.tabs.biStudio": "Painéis BI",
  "institution.tabs.groups": "Grupos",
  "institution.tabs.services": "Serviços",
  "institution.tabs.branding": "Personalização",
  "institution.tabs.landing": "Página pública",
  "institution.tabs.webhooks": "Webhooks",
  "institution.tabs.ssoOidc": "SSO (OpenID Connect & SAML)",
  "institution.tabs.xapi": "xAPI (LRS)",
  "institution.tabs.mcp": "MCP",
  "institution.tabs.billing": "Faturação",
  "institution.nav.section.general": "Visão geral",
  "institution.nav.section.content": "Conteúdo e formação",
  "institution.nav.section.people": "Equipas e formandos",
  "institution.nav.section.portal": "Portal e imagem",
  "institution.nav.section.integrations": "Integrações",
  "institution.nav.section.subscription": "Subscrição",
  "institution.sidebar.subtitle": "Instituição",
  "institution.sidebar.subtitleRh": "Espaço RH",
  "institution.sidebar.subtitleAdmin": "Administração",
  "institution.sidebar.logout": "Terminar sessão",
  "institution.sidebar.collapse": "Recolher menu",
  "institution.sidebar.expandAria": "Expandir barra lateral",
  "institution.sidebar.collapseAria": "Recolher barra lateral",
  "institution.sidebar.language": "Language",
  "institution.sidebar.languageAria": "Change language",
  "institution.common.cancel": "Cancelar",
  "institution.common.save": "Guardar",
  "institution.tabs.webinars": "Webinars",
  "institution.tabs.webinarsPilotage": "Gestão de webinars",
  "institution.webinars.pageTitle": "Definições de webinars",
  "institution.webinars.settingsIntro":
    "Ative o módulo e defina a mensagem padrão da sala de espera. A lista de webinars e os anfitriões autorizados são geridos no separador « {{tabName}} ».",
  "institution.webinars.enableForInstitution": "Ativar webinars para a instituição",
  "institution.webinars.enabledBadge": "Módulo ativo",
  "institution.webinars.disabledBadge": "Módulo inativo",
  "institution.webinars.sectionModule": "Ativação",
  "institution.webinars.sectionModuleHint": "Permite aos formadores da instituição criar e animar sessões ao vivo.",
  "institution.webinars.sectionWaitingRoom": "Sala de espera",
  "institution.webinars.waitingHtmlLabel": "HTML da sala de espera (predefinição)",
  "institution.webinars.waitingHtmlPlaceholder": "<p>A sua mensagem de boas-vindas…</p>",
  "institution.webinars.waitingHtmlHint":
    "HTML simples mostrado aos participantes antes do início. As cores seguem a identidade deste espaço.",
  "institution.webinars.openPilotage": "Abrir gestão de webinars",
  "institution.webinars.waitingPreviewTitle": "Pré-visualização — mensagem de espera",
  "institution.webinars.waitingPreviewHint": "Como os participantes veem antes do início do webinar.",
  "institution.webinars.loadError": "Não foi possível carregar as definições de webinars.",
  "institution.webinars.saveSuccess": "Definições de webinars guardadas.",
  "institution.webinars.saveError": "Não foi possível guardar.",
  "institution.common.saving": "A guardar…",
  "institution.common.delete": "Delete",
  "institution.common.edit": "Edit",
  "institution.common.create": "Create",
  "institution.common.add": "Add",
  "institution.common.retry": "Retry",
  "institution.common.refresh": "Refresh",
  "institution.common.search": "Search…",
  "institution.common.loading": "Loading…",
  "institution.common.page": "Página",
  "institution.common.of": "de",
  "institution.common.name": "Name",
  "institution.common.description": "Description",
  "institution.common.email": "Email",
  "institution.common.member": "Member",
  "institution.common.members": "Members",
  "institution.common.back": "Back",
  "institution.common.view": "View",
  "institution.common.duplicate": "Duplicate",
  "institution.common.toggleStatus": "Enable / disable",
  "institution.common.author": "Author",
  "institution.common.title": "Title",
  "institution.common.status": "Status",
  "institution.common.type": "Type",
  "institution.common.actions": "Actions",
  "institution.common.createdAt": "Created",
  "institution.common.assignedTo": "Assigned to",
  "institution.common.completion": "Completion",
  "institution.common.learners": "Learners",
  "institution.common.empty": "—",
  "institution.status.draft": "Rascunho",
  "institution.status.published": "Publicado",
  "institution.status.archived": "Archived",
  "institution.status.allStatuses": "All statuses",
  "institution.status.allTypes": "All types",
  "institution.dashboard.loading": "A carregar o painel…",
  "institution.dashboard.loadError": "Não foi possível carregar o painel.",
  "institution.dashboard.activity.completion": "Completion",
  "institution.dashboard.activity.enrollment": "Enrollment",
  "institution.dashboard.activity.milestone": "Milestone",
  "institution.dashboard.activity.feedback": "Feedback",
  "institution.dashboard.activity.start": "Start",
  "institution.dashboard.activity.1": "Marie Dupont completed “UX Fundamentals”",
  "institution.dashboard.activity.2": "12 new learners enrolled in “Design Thinking”",
  "institution.dashboard.activity.3": "Group “Cohort Q3” reached 80% completion",
  "institution.dashboard.activity.4": "NPS survey received 24 new responses",
  "institution.dashboard.activity.5": "Jean Martin started “Agile methods”",
  "institution.dashboard.time.5m": "5 min ago",
  "institution.dashboard.time.1h": "1h ago",
  "institution.dashboard.time.3h": "3h ago",
  "institution.dashboard.time.5h": "5h ago",
  "institution.dashboard.time.6h": "6h ago",
  "institution.dashboard.activity.flowCompleted": "{{name}} completed “{{flow}}”",
  "institution.dashboard.activity.participantJoined": "Learner added: {{email}}",
  "institution.dashboard.activity.flowStarted": "{{name}} started “{{flow}}”",
  "institution.dashboard.chartTopFlowsEmpty": "Not enough data yet. Publish courses and invite learners.",
  "institution.dashboard.activityEmpty": "No recent activity.",
  "institution.groups.title": "Gestão de grupos",
  "institution.groups.countShown": "{{count}} group(s)",
  "institution.groups.subtitle": "{{count}} group(s) in your institution",
  "institution.groups.create": "Create group",
  "institution.groups.statGroups": "Groups",
  "institution.groups.statTotalMembers": "Total members",
  "institution.groups.statEmpty": "Empty groups",
  "institution.groups.loadError": "Unable to load groups.",
  "institution.groups.searchPh": "Search a group…",
  "institution.groups.colGroup": "Group",
  "institution.groups.colCreated": "Created",
  "institution.groups.memberCount": "{{count}} member(s)",
  "institution.groups.emptyNone": "No groups yet. Create your first group.",
  "institution.groups.emptyFilter": "No groups match your search.",
  "institution.groups.backList": "Back to groups",
  "institution.groups.addLearner": "Add learner",
  "institution.groups.dateCreated": "Created on",
  "institution.groups.colMember": "Member",
  "institution.groups.colAdded": "Added on",
  "institution.groups.noMembers": "No members in this group",
  "institution.groups.loadGroupError": "Unable to load the group",
  "institution.groups.panelTitle": "Add learners",
  "institution.groups.noLearnersAvailable": "No learners available",
  "institution.groups.noResults": "No results",
  "institution.groups.modalEdit": "Edit group",
  "institution.groups.modalCreate": "Create group",
  "institution.groups.groupName": "Group name",
  "institution.groups.removeFromGroup": "Remove from group",
  "institution.services.title": "Serviços da empresa",
  "institution.services.subtitle":
    "Catálogo de funções empresariais (RH, finanças, etc.). Atribua formandos na ficha do formando.",
  "institution.services.create": "Novo serviço",
  "institution.services.loadError": "Não foi possível carregar os serviços.",
  "institution.services.empty": "Ainda não há serviços. Crie um para poder atribuir formandos.",
  "institution.services.modalCreate": "Criar serviço",
  "institution.services.modalEdit": "Editar serviço",
  "institution.services.fieldName": "Nome do serviço",
  "institution.services.deleteConfirm":
    "Eliminar este serviço? Os formandos associados deixarão de ter serviço atribuído.",
  "institution.services.listSubtitle": "{{count}} serviço(s) na sua organização",
  "institution.services.intro":
    "Catálogo de funções empresariais (RH, finanças, etc.). Atribua formandos na ficha do formando.",
  "institution.services.statTotal": "Serviços",
  "institution.services.statWithDesc": "Com descrição",
  "institution.services.statNoDesc": "Sem descrição",
  "institution.services.searchPh": "Pesquisar um serviço…",
  "institution.services.colService": "Serviço",
  "institution.services.colCreated": "Criado",
  "institution.services.emptyNone": "Ainda não há serviços. Crie o primeiro.",
  "institution.services.emptyFilter": "Nenhum serviço corresponde à pesquisa.",
  "institution.services.countShown": "{{count}} serviço(s)",
  "institution.flows.title": "Formações",
  "institution.flows.subtitle": "Manage your courses",
  "institution.flows.statTotal": "Total courses",
  "institution.flows.statPublished": "Published",
  "institution.flows.statLearners": "Total learners",
  "institution.flows.searchPh": "Search a course…",
  "institution.flows.colName": "Name",
  "institution.flows.empty": "No course found",
  "institution.flows.badgeEnterprise": "Enterprise training need",
  "institution.flows.deleteEnterpriseTooltip": "Move to trash (enterprise need)",
  "institution.flows.deleteEnterpriseTitle": "Remove this enterprise-linked course?",
  "institution.flows.deleteEnterpriseHint": "The course will be soft-deleted. Trainers cannot do this; only institution admin, DRH or HR can restore or remove it from this dashboard.",
  "institution.flows.deleteEnterpriseConfirm": "Move to trash",
  "institution.flows.deleteEnterpriseSuccess": "Course moved to trash.",
  "institution.flows.deleteEnterpriseError": "Action failed.",
  "institution.learningPaths.sectionTitle": "Learning paths",
  "institution.learningPaths.sectionSubtitle": "Paths owned by a member of your institution.",
  "institution.learningPaths.searchPh": "Search a path…",
  "institution.learningPaths.colItems": "Items",
  "institution.learningPaths.colAssignments": "Assignments",
  "institution.learningPaths.transferOwner": "Reassign owner",
  "institution.learningPaths.transferModalTitle": "Change path owner",
  "institution.learningPaths.transferModalHint":
    "The selected account becomes the owner; referenced library media (e.g. cover) moves when traceable in the database.",
  "institution.learningPaths.transferPickUser": "New owner",
  "institution.learningPaths.transferSubmit": "Confirm transfer",
  "institution.learningPaths.transferLoadingUsers": "Loading accounts…",
  "institution.learningPaths.transferNoCandidates": "No other collaborator available",
  "institution.learningPaths.transferError": "Transfer failed",
  "institution.learningPaths.transferSuccess": "Owner updated",
  "institution.learningPaths.empty": "No path found",
  "institution.supports.title": "Podcasts",
  "institution.supports.subtitle": "Podcasts and audio content",
  "institution.supports.searchPh": "Search a podcast…",
  "institution.supports.empty": "No podcast found",
  "institution.supports.typeDictation": "Dictation",
  "institution.supports.typeText": "Text",
  "institution.supports.typeAi": "AI",
  "institution.supports.transferOwner": "Reassign podcast creator",
  "institution.supports.transferModalTitle": "Change podcast owner",
  "institution.supports.transferModalHint":
    "The selected account becomes the podcast creator; episodes and referenced library media move when traceable in the database.",
  "institution.supports.transferPickUser": "New creator",
  "institution.supports.transferSubmit": "Confirm transfer",
  "institution.supports.transferLoadingUsers": "Loading accounts…",
  "institution.supports.transferNoCandidates": "No other collaborator available",
  "institution.supports.transferError": "Transfer failed",
  "institution.supports.transferSuccess": "Creator updated",
  "institution.categories.title": "Categorias",
  "institution.categories.subtitle": "Organize your courses by topic",
  "institution.categories.add": "Add",
  "institution.categories.edit": "Edit category",
  "institution.categories.new": "New category",
  "institution.categories.usage": "{{count}} course(s)",
  "institution.categories.pageSubtitle": "Organize your content by category",
  "institution.categories.namePlaceholder": "Category name",
  "institution.categories.color": "Color",
  "institution.categories.descShortPh": "Short description",
  "institution.categories.usageTimes": "({{count}} uses)",
  "institution.templates.title": "Modelos de blocos",
  "institution.templates.subtitle": "Reusable template library",
  "institution.templates.statTotal": "Templates",
  "institution.templates.statUsage": "Total uses",
  "institution.templates.mostUsed": "Most used type",
  "institution.templates.preview": "Preview",
  "institution.templates.searchPh": "Search a template…",
  "institution.templates.copySuffix": " (copy)",
  "institution.templates.empty": "No templates found",
  "institution.templates.loadFormatError": "Could not load templates (invalid server response).",
  "institution.templates.usesShort": "{{count}} uses",
  "institution.templates.filterAll": "All types",
  "institution.blockTypes.text": "Text",
  "institution.blockTypes.quiz": "Quiz",
  "institution.blockTypes.video": "Video",
  "institution.blockTypes.audio": "Audio",
  "institution.blockTypes.image": "Image",
  "institution.blockTypes.document": "Document",
  "institution.blockTypes.code": "Code",
  "institution.blockTypes.discussion": "Discussion",
  "institution.scorm.title": "Importação SCORM",
  "institution.scorm.subtitle": "Import SCORM 1.2 or 2004 packages",
  "institution.scorm.dropHere": "Drag and drop your SCORM (.zip) file here",
  "institution.scorm.browseHint": "or click to browse",
  "institution.scorm.selectedFile": "Selected file: {{name}}",
  "institution.scorm.startImport": "Start import",
  "institution.scorm.importingNamed": "Import in progress: {{name}}",
  "institution.scorm.analyzing": "Analyzing modules… {{pct}}%",
  "institution.scorm.historyTitle": "Import history",
  "institution.scorm.colFile": "File",
  "institution.scorm.colDate": "Date",
  "institution.scorm.colStatus": "Status",
  "institution.scorm.colModules": "Modules",
  "institution.scorm.colVersion": "Version",
  "institution.scorm.colFlow": "Course",
  "institution.scorm.empty": "No imports yet. Drop a SCORM .zip file above.",
  "institution.scorm.openFlow": "Open",
  "institution.scorm.statusImporting": "Importing…",
  "institution.scorm.statusSuccess": "Success",
  "institution.scorm.statusError": "Error",
  "institution.designers.title": "Colaboradores",
  "institution.designers.subtitle": "Trainers, HR leads, HR staff and administrators for your institution (no more “teacher” wording).",
  "institution.designers.invite": "Invite",
  "institution.designers.statTotal": "Total collaborators",
  "institution.designers.statActiveMonth": "Active this month",
  "institution.designers.statFlows": "Courses created (total)",
  "institution.designers.inviteTitle": "Invite a collaborator",
  "institution.designers.inviteHelp": "Choose a role: Trainer (content / courses), HR lead, HR staff, or Admin (institution administrator on Lyrra).",
  "institution.designers.emailPh": "email@example.com",
  "institution.designers.sendInvite": "Send invitation",
  "institution.designers.loadError": "Unable to load collaborators",
  "institution.designers.inviteFail": "Invitation failed",
  "institution.designers.actionFail": "Action failed",
  "institution.designers.searchPh": "Search by name or email…",
  "institution.designers.colName": "Name",
  "institution.designers.colEmail": "Email",
  "institution.designers.colRole": "Role",
  "institution.designers.colProjects": "Projects",
  "institution.designers.colLastActivity": "Last activity",
  "institution.designers.colStatus": "Status",
  "institution.designers.colActions": "Actions",
  "institution.designers.empty": "No collaborator found",
  "institution.designers.roleAdmin": "Admin",
  "institution.designers.roleTeacher": "Trainer",
  "institution.designers.roleTrainingLead": "Training lead",
  "institution.designers.roleCollaborator": "Collaborator",
  "institution.designers.roleOptFormateur": "Trainer",
  "institution.designers.roleOptDrh": "HR lead",
  "institution.designers.roleOptRh": "HR",
  "institution.designers.roleOptAdmin": "Admin",
  "institution.designers.statusActive": "Active",
  "institution.designers.statusInvited": "Invited",
  "institution.designers.statusSuspended": "Suspended",
  "institution.designers.menuView": "View profile",
  "institution.designers.menuMakeAdmin": "Make admin",
  "institution.designers.menuSuspend": "Suspend",
  "institution.designers.menuRemove": "Remove",
  "institution.billing.title": "Faturação",
  "institution.billing.subtitle": "Subscription, usage and invoices",
  "institution.billing.planLabel": "Current plan",
  "institution.billing.planPro": "Pro",
  "institution.billing.priceExample": "€299",
  "institution.billing.perMonth": "/ month",
  "institution.billing.renewalMock": "Renews on February 1, 2025",
  "institution.billing.featureCollaborators": "10 collaborators",
  "institution.billing.featureLearners": "500 learners",
  "institution.billing.featureStorage": "50 GB storage",
  "institution.billing.featureSupport": "Priority support",
  "institution.billing.featureApi": "MCP API",
  "institution.billing.changePlan": "Change plan",
  "institution.billing.usageCollaborators": "Collaborators",
  "institution.billing.usageLearners": "Learners",
  "institution.billing.usageStorage": "Storage",
  "institution.billing.storageUnit": "GB",
  "institution.billing.cardMasked": "Visa •••• 4242",
  "institution.billing.cardExpires": "Expires {{date}}",
  "institution.billing.invoicesTitle": "Invoices",
  "institution.billing.colRef": "Reference",
  "institution.billing.colDate": "Date",
  "institution.billing.colAmount": "Amount",
  "institution.billing.colStatus": "Status",
  "institution.billing.colPdf": "PDF",
  "institution.billing.invPaid": "Paid",
  "institution.billing.invOpen": "Pending",
  "institution.billing.invDraft": "Draft",
  "institution.billing.invVoid": "Void",
  "institution.billing.invUncollectible": "Uncollectible",
  "institution.mcp.title": "MCP — Model Context Protocol",
  "institution.landing.designerTitle": "Page designer",
  "institution.learners.title": "Aprendizes",
  "institution.learners.searchPh": "Search a learner…",
  "institution.learners.filterStatus": "Status",
  "institution.learners.filterPlaceholder": "Filter",
  "institution.learners.selectedCount": "{{count}} selected",
  "institution.learners.exportSelection": "Export selection",
  "institution.learners.exportAll": "Export all",
  "institution.learners.colLearner": "Learner",
  "institution.learners.colGroup": "Group",
  "institution.learners.colLastActive": "Last activity",
  "institution.learners.colStatus": "Status",
  "institution.learners.empty": "No learner found",
  "institution.learners.countList": "{{count}} learner(s)",
  "institution.learners.subtitle": "{{count}} learner(s) enrolled in your institution",
  "institution.learners.importCsv": "Import CSV",
  "institution.learners.add": "Add",
  "institution.learners.statLearners": "Learners",
  "institution.learners.statActive30": "Active (30d)",
  "institution.learners.statEnrollments": "Enrollments",
  "institution.learners.statCompleted": "Completed courses",
  "institution.learners.statusAll": "All statuses",
  "institution.learners.statusActive": "Active",
  "institution.learners.statusInactive": "Inactive",
  "institution.learners.statusCompleted": "Completed",
  "institution.learners.sheetTitle": "Learner profile",
  "institution.learners.openProfileDetail": "Detalhe do perfil",
  "institution.learners.groupsCatalogTitle": "Grupos configurados",
  "institution.learners.groupsCatalogSubtitle": "Lista definida no separador « Grupos » da sua instituição.",
  "institution.learners.replacePhoto": "Replace",
  "institution.learners.addPhoto": "Add photo",
  "institution.learners.removePhoto": "Remove",
  "institution.learners.firstName": "First name",
  "institution.learners.lastName": "Last name",
  "institution.learners.save": "Save",
  "institution.learners.deactivate": "Deactivate",
  "institution.learners.reactivate": "Reactivate",
  "institution.learners.lastActivity": "Last activity:",
  "institution.learners.paths": "Paths ({{count}})",
  "institution.learners.noPaths": "No assigned path",
  "institution.learners.noFlowsEnrolled": "No enrolled course",
  "institution.learners.done": "Done",
  "institution.learners.inProgress": "In progress",
  "institution.learners.itemsProgress": "{{done}}/{{total}} items",
  "institution.learners.flows": "Courses",
  "institution.learners.completedF": "Completed",
  "institution.learners.totalTime": "Total time",
  "institution.learners.progress": "Progress",
  "institution.learners.flowDone": "Completed",
  "institution.learners.blocks": "{{visited}}/{{total}} blocks",
  "institution.learners.score": "Score: {{score}}%",
  "institution.learners.sessions": "{{count}} sessions",
  "institution.learners.started": "Started:",
  "institution.learners.ended": "Ended:",
  "institution.learners.lastAccess": "Last access:",
  "institution.learners.podcasts": "Podcasts",
  "institution.learners.noPodcastListen": "No listening recorded",
  "institution.learners.deleteTitle": "Delete this learner?",
  "institution.learners.deleteDesc": "Are you sure you want to permanently delete {{name}} ({{email}})? This cannot be undone and will remove all related data.",
  "institution.learners.deactivateTitle": "Deactivate this learner?",
  "institution.learners.reactivateTitle": "Reactivate this learner?",
  "institution.learners.deactivateDesc": "{{name}} will not be able to access courses while deactivated.",
  "institution.learners.reactivateDesc": "{{name}} will regain access to their courses.",
  "institution.learners.deleteLearner": "Delete this learner",
  "institution.learners.photoUploadError": "Error uploading photo",
  "institution.learners.photoRemoveError": "Error removing photo",
  "institution.learners.service": "Serviço",
  "institution.learners.serviceHint":
    "Escolha uma entrada do catálogo (separador Serviços). Escreva para filtrar a lista.",
  "institution.learners.serviceSearch": "Pesquisar um serviço…",
  "institution.learners.serviceNone": "Sem serviço",
  "institution.learners.exportSheetLearners": "Learners",
  "institution.learners.exportSheetDetails": "Course details",
  "institution.learners.export.firstName": "First name",
  "institution.learners.export.lastName": "Last name",
  "institution.learners.export.groupCol": "Group",
  "institution.learners.export.enrollments": "Enrolled courses",
  "institution.learners.export.completed": "Completed courses",
  "institution.learners.export.progressPct": "Progress (%)",
  "institution.learners.export.totalMin": "Total time (min)",
  "institution.learners.export.lastAct": "Last activity",
  "institution.learners.export.statusCol": "Status",
  "institution.learners.export.learnerCol": "Learner",
  "institution.learners.export.typeCol": "Type",
  "institution.learners.export.titleCol": "Title",
  "institution.learners.export.blocks": "Blocks visited / Total",
  "institution.learners.export.sessionsDone": "Sessions completed",
  "institution.learners.export.avgScore": "Average score (%)",
  "institution.learners.export.timeMin": "Time spent (min)",
  "institution.learners.export.dateStart": "Start date",
  "institution.learners.export.dateEnd": "End date",
  "institution.learners.export.lastAcc": "Last access",
  "institution.learners.export.typeCourse": "Course",
  "institution.learners.export.typePath": "Path",
  "institution.reminders.openPanel": "Lembretes por e-mail",
  "institution.reminders.panelTitle": "Lembretes",
  "institution.reminders.panelSubtitle":
    "Alertas automáticas enviadas por e-mail aos participantes. Verificação a cada hora no horário UTC escolhido. Cada regra é disparada no máximo uma vez por participante.",
  "institution.reminders.sectionRules": "Regras",
  "institution.reminders.sectionLogs": "Registo de envios",
  "institution.reminders.addRule": "Adicionar alerta",
  "institution.reminders.removeRule": "Remover este alerta",
  "institution.reminders.save": "Guardar regras",
  "institution.reminders.loadError": "Não foi possível carregar os lembretes.",
  "institution.reminders.saveError": "Não foi possível guardar.",
  "institution.reminders.rulesEmpty":
    "Nenhum alerta. Adicione uma regra ou guarde uma lista vazia para desativar todos os lembretes deste conteúdo.",
  "institution.reminders.logsEmpty": "Ainda não há envios registados.",
  "institution.reminders.utcHint":
    "Escolha a hora UTC (0–23) em que o servidor avalia esta regra. Ex.: 8 UTC ≈ 9 h no inverno em Paris.",
  "institution.reminders.fieldKind": "Tipo de alerta",
  "institution.reminders.fieldDays": "Dias após o evento de referência",
  "institution.reminders.fieldHourUtc": "Hora de verificação (UTC)",
  "institution.reminders.fieldEnabled": "Ativar este alerta",
  "institution.reminders.fieldLabel": "Etiqueta interna (opcional)",
  "institution.reminders.fieldLabelPh": "ex. Lembrete D+3",
  "institution.reminders.ruleKind.eduflow_not_started_days_after_enroll":
    "Formação: não iniciada X dias após a inscrição (ficha do participante)",
  "institution.reminders.ruleKind.eduflow_incomplete_days_after_deadline":
    "Formação: não concluída X dias após o prazo do percurso",
  "institution.reminders.ruleKind.path_incomplete_days_after_assign":
    "Percurso: não concluído X dias após a atribuição ao participante",
  "institution.pages.brandingTitle": "Identidade visual",
  "institution.pages.webhooksTitle": "Webhooks",
  "institution.pages.landingTitle": "Página pública",
  },
  lb: {
    ...institutionRhCompetenciesStrings.lb,
    ...institutionBiStringsFr,
  "institution.tabs.home": "Accueil",
  "institution.tabs.flows": "Formations",
  "institution.tabs.supports": "Podcasts",
  "institution.tabs.categories": "Catégories",
  "institution.tabs.templates": "Modèles de blocs",
  "institution.tabs.scorm": "Import SCORM",
  "institution.tabs.designers": "Collaborateurs",
  "institution.tabs.learners": "Apprenants",
  "institution.tabs.learnerAnalytics": "Analyse apprenants",
  "institution.tabs.biStudio": "Tableaux BI",
  "institution.tabs.groups": "Groupes",
  "institution.tabs.services": "Services",
  "institution.tabs.sirh": "SIRH (API)",
  "institution.tabs.branding": "Personnalisation",
  "institution.tabs.landing": "Page publique",
  "institution.tabs.webhooks": "Webhooks",
  "institution.tabs.ssoOidc": "SSO (OpenID Connect & SAML)",
  "institution.tabs.xapi": "xAPI (LRS)",
  "institution.tabs.mcp": "MCP",
  "institution.tabs.billing": "Ofrechnung",
  "institution.nav.section.general": "Iwwersiicht",
  "institution.nav.section.content": "Inhalt & Formatounen",
  "institution.nav.section.people": "Equippen & Léierender",
  "institution.nav.section.portal": "Portal & Bild",
  "institution.nav.section.integrations": "Integratiounen",
  "institution.nav.section.subscription": "Abonnement",
  "institution.sidebar.subtitle": "Institutioun",
  "institution.sidebar.subtitleRh": "RH-Beräich",
  "institution.sidebar.subtitleAdmin": "Administratioun",
  "institution.sidebar.logout": "Ofmellen",
  "institution.sidebar.collapse": "Verklengeren",
  "institution.sidebar.expandAria": "Säitenleescht vergréisseren",
  "institution.sidebar.collapseAria": "Säitenleescht verklengeren",
  "institution.sidebar.language": "Langue",
  "institution.sidebar.languageAria": "Changer la langue",
  "institution.common.cancel": "Ofbriechen",
  "institution.common.save": "Späicheren",
  "institution.tabs.webinars": "Webinaren",
  "institution.tabs.webinarsPilotage": "Webinar-Steierung",
  "institution.webinars.pageTitle": "Webinar-Astellungen",
  "institution.webinars.settingsIntro":
    "Aktivéiert de Modul a setzt d’Standard-Warteraum-Noriicht. D’Webinarlëscht a berechtegt Moderatoren gëtt am Tab « {{tabName}} » geréiert.",
  "institution.webinars.enableForInstitution": "Webinaren fir d’Institutioun aktivéieren",
  "institution.webinars.enabledBadge": "Modul aktivéiert",
  "institution.webinars.disabledBadge": "Modul desaktivéiert",
  "institution.webinars.sectionModule": "Aktivatioun",
  "institution.webinars.sectionModuleHint":
    "Erlaabt Formateuren vun der Institutioun Live-Sessiounen ze erstellen an ze leeden.",
  "institution.webinars.sectionWaitingRoom": "Warteraum",
  "institution.webinars.waitingHtmlLabel": "Warteraum-HTML (Standard)",
  "institution.webinars.waitingHtmlPlaceholder": "<p>Är Begréissungsnoriicht…</p>",
  "institution.webinars.waitingHtmlHint": "Einfacht HTML virum Ufank vun der Sessioun. Faarwe follegen dësem Beräich.",
  "institution.webinars.openPilotage": "Webinar-Steierung opmaachen",
  "institution.webinars.waitingPreviewTitle": "Virschau — Warteraum-Noriicht",
  "institution.webinars.waitingPreviewHint": "Sou wéi Participante virdrun de Webinar gesinn.",
  "institution.webinars.loadError": "Webinar-Astellungen konnten net geluede ginn.",
  "institution.webinars.saveSuccess": "Webinar-Astellungen gespäichert.",
  "institution.webinars.saveError": "Späicheren feelgeschloen.",
  "institution.common.saving": "Gëtt gespäichert…",
  "institution.common.delete": "Supprimer",
  "institution.common.edit": "Modifier",
  "institution.common.create": "Créer",
  "institution.common.add": "Ajouter",
  "institution.common.retry": "Réessayer",
  "institution.common.refresh": "Actualiser",
  "institution.common.search": "Rechercher…",
  "institution.common.loading": "Chargement…",
  "institution.common.page": "Page",
  "institution.common.of": "sur",
  "institution.common.name": "Nom",
  "institution.common.description": "Description",
  "institution.common.email": "Email",
  "institution.common.member": "Membre",
  "institution.common.members": "Membres",
  "institution.common.back": "Retour",
  "institution.common.view": "Voir",
  "institution.common.duplicate": "Dupliquer",
  "institution.common.toggleStatus": "Activer/Désactiver",
  "institution.common.author": "Auteur",
  "institution.common.title": "Titre",
  "institution.common.status": "Statut",
  "institution.common.type": "Type",
  "institution.common.actions": "Actions",
  "institution.common.createdAt": "Créé le",
  "institution.common.assignedTo": "Assigné à",
  "institution.common.completion": "Complétion",
  "institution.common.learners": "Apprenants",
  "institution.common.empty": "—",
  "institution.status.draft": "Brouillon",
  "institution.status.published": "Publié",
  "institution.status.archived": "Archivé",
  "institution.status.allStatuses": "Tous les statuts",
  "institution.status.allTypes": "Tous les types",
  "institution.dashboard.loading": "Dashboard gëtt gelueden…",
  "institution.dashboard.loadError": "Den Dashboard konnt net geluede ginn.",
  "institution.dashboard.activity.completion": "Terminaison",
  "institution.dashboard.activity.enrollment": "Inscription",
  "institution.dashboard.activity.milestone": "Jalon",
  "institution.dashboard.activity.feedback": "Retour",
  "institution.dashboard.activity.start": "Démarrage",
  "institution.dashboard.activity.1": "Marie Dupont a terminé « UX Fundamentals »",
  "institution.dashboard.activity.2": "12 nouveaux apprenants inscrits à « Design Thinking »",
  "institution.dashboard.activity.3": "Le groupe « Cohorte T3 » a atteint 80 % de complétion",
  "institution.dashboard.activity.4": "L’enquête NPS a reçu 24 nouvelles réponses",
  "institution.dashboard.activity.5": "Jean Martin a démarré « Méthodes agiles »",
  "institution.dashboard.time.5m": "Il y a 5 min",
  "institution.dashboard.time.1h": "Il y a 1 h",
  "institution.dashboard.time.3h": "Il y a 3 h",
  "institution.dashboard.time.5h": "Il y a 5 h",
  "institution.dashboard.time.6h": "Il y a 6 h",
  "institution.dashboard.activity.flowCompleted": "{{name}} a terminé « {{flow}} »",
  "institution.dashboard.activity.participantJoined": "Apprenant enregistré : {{email}}",
  "institution.dashboard.activity.flowStarted": "{{name}} a démarré « {{flow}} »",
  "institution.dashboard.chartTopFlowsEmpty": "Pas encore assez de données. Publiez des formations et invitez des apprenants.",
  "institution.dashboard.activityEmpty": "Aucune activité récente.",
  "institution.groups.title": "Gruppeverwaltung",
  "institution.groups.countShown": "{{count}} groupe(s)",
  "institution.groups.subtitle": "{{count}} groupe(s) dans votre établissement",
  "institution.groups.create": "Créer un groupe",
  "institution.groups.statGroups": "Groupes",
  "institution.groups.statTotalMembers": "Membres total",
  "institution.groups.statEmpty": "Groupes vides",
  "institution.groups.loadError": "Impossible de charger les groupes.",
  "institution.groups.searchPh": "Rechercher un groupe…",
  "institution.groups.colGroup": "Groupe",
  "institution.groups.colCreated": "Créé le",
  "institution.groups.memberCount": "{{count}} membre(s)",
  "institution.groups.emptyNone": "Aucun groupe. Créez votre premier groupe.",
  "institution.groups.emptyFilter": "Aucun groupe ne correspond à la recherche.",
  "institution.groups.backList": "Retour aux groupes",
  "institution.groups.addLearner": "Ajouter un apprenant",
  "institution.groups.dateCreated": "Date de création",
  "institution.groups.colMember": "Membre",
  "institution.groups.colAdded": "Ajouté le",
  "institution.groups.noMembers": "Aucun membre dans ce groupe",
  "institution.groups.loadGroupError": "Impossible de charger le groupe",
  "institution.groups.panelTitle": "Ajouter des apprenants",
  "institution.groups.noLearnersAvailable": "Aucun apprenant disponible",
  "institution.groups.noResults": "Aucun résultat",
  "institution.groups.modalEdit": "Modifier le groupe",
  "institution.groups.modalCreate": "Créer un groupe",
  "institution.groups.groupName": "Nom du groupe",
  "institution.groups.removeFromGroup": "Retirer du groupe",
  "institution.services.title": "Services entreprise",
  "institution.services.subtitle":
    "Référentiel des services (RH, Finance, etc.). Les apprenants y sont affectés depuis la fiche apprenant.",
  "institution.services.create": "Nouveau service",
  "institution.services.loadError": "Impossible de charger les services.",
  "institution.services.empty": "Aucun service. Créez-en pour les proposer à l’affectation des apprenants.",
  "institution.services.modalCreate": "Créer un service",
  "institution.services.modalEdit": "Modifier le service",
  "institution.services.fieldName": "Nom du service",
  "institution.services.deleteConfirm": "Supprimer ce service ? Les comptes apprenants rattachés n’auront plus de service (l’affectation sera retirée).",
  "institution.services.listSubtitle": "{{count}} service(s) dans votre établissement",
  "institution.services.intro":
    "Référentiel des services (RH, Finance, etc.). Les apprenants y sont affectés depuis la fiche apprenant.",
  "institution.services.statTotal": "Services",
  "institution.services.statWithDesc": "Avec description",
  "institution.services.statNoDesc": "Sans description",
  "institution.services.searchPh": "Rechercher un service…",
  "institution.services.colService": "Service",
  "institution.services.colCreated": "Créé le",
  "institution.services.emptyNone": "Aucun service. Créez votre premier service.",
  "institution.services.emptyFilter": "Aucun service ne correspond à la recherche.",
  "institution.services.countShown": "{{count}} service(s)",
  "institution.flows.title": "Formations",
  "institution.flows.subtitle": "Gérez vos formations",
  "institution.flows.statTotal": "Total formations",
  "institution.flows.statPublished": "Publiés",
  "institution.flows.statLearners": "Total apprenants",
  "institution.flows.searchPh": "Rechercher une formation…",
  "institution.flows.colName": "Nom",
  "institution.flows.empty": "Aucune formation trouvée",
  "institution.flows.badgeEnterprise": "Besoin entreprise",
  "institution.flows.deleteEnterpriseTooltip": "Mettre en corbeille (besoin entreprise)",
  "institution.flows.deleteEnterpriseTitle": "Retirer la formation « besoin entreprise » ?",
  "institution.flows.deleteEnterpriseHint": "Le parcours sera mis en corbeille (suppression logique). Les formateurs ne peuvent pas effectuer cette action ; seuls l’administrateur d’établissement, le DRH ou la RH peuvent la restaurer ou la retirer depuis ce tableau.",
  "institution.flows.deleteEnterpriseConfirm": "Mettre en corbeille",
  "institution.flows.deleteEnterpriseSuccess": "Formation mise en corbeille.",
  "institution.flows.deleteEnterpriseError": "Action impossible.",
  "institution.learningPaths.sectionTitle": "Parcours de formation (learning paths)",
  "institution.learningPaths.sectionSubtitle": "Parcours dont le créateur appartient à votre établissement.",
  "institution.learningPaths.searchPh": "Rechercher un parcours…",
  "institution.learningPaths.colItems": "Contenus",
  "institution.learningPaths.colAssignments": "Assignations",
  "institution.learningPaths.transferOwner": "Réattribuer le propriétaire",
  "institution.learningPaths.transferModalTitle": "Changer le propriétaire du parcours",
  "institution.learningPaths.transferModalHint":
    "Le nouveau compte devient propriétaire ; les médias de médiathèque référencés (ex. couverture) suivent lorsque c’est traçable en base.",
  "institution.learningPaths.transferPickUser": "Nouveau propriétaire",
  "institution.learningPaths.transferSubmit": "Confirmer le transfert",
  "institution.learningPaths.transferLoadingUsers": "Chargement des comptes…",
  "institution.learningPaths.transferNoCandidates": "Aucun autre collaborateur disponible",
  "institution.learningPaths.transferError": "Transfert impossible",
  "institution.learningPaths.transferSuccess": "Propriétaire mis à jour",
  "institution.learningPaths.empty": "Aucun parcours trouvé",
  "institution.supports.title": "Podcasts",
  "institution.supports.subtitle": "Podcasts et contenus audio",
  "institution.supports.searchPh": "Rechercher un podcast…",
  "institution.supports.empty": "Aucun podcast trouvé",
  "institution.supports.typeDictation": "Dictée",
  "institution.supports.typeText": "Texte",
  "institution.supports.typeAi": "IA",
  "institution.supports.typePodcast": "Podcast",
  "institution.supports.allProductionStatuses": "Tous les statuts",
  "institution.supports.colKind": "Type",
  "institution.supports.colEpisodes": "Épisodes",
  "institution.supports.colProducer": "Producteur",
  "institution.supports.colCreator": "Créé par",
  "institution.supports.loadError": "Impossible de charger les podcasts.",
  "institution.supports.transferOwner": "Réattribuer le créateur du podcast",
  "institution.supports.transferModalTitle": "Changer le propriétaire du podcast",
  "institution.supports.transferModalHint":
    "Le nouveau compte devient créateur du podcast ; les épisodes et médias de médiathèque référencés suivent lorsque c’est traçable en base.",
  "institution.supports.transferPickUser": "Nouveau créateur",
  "institution.supports.transferSubmit": "Confirmer le transfert",
  "institution.supports.transferLoadingUsers": "Chargement des comptes…",
  "institution.supports.transferNoCandidates": "Aucun autre collaborateur disponible",
  "institution.supports.transferError": "Transfert impossible",
  "institution.supports.transferSuccess": "Créateur mis à jour",
  "institution.podcastProduction.shell": "Coquille",
  "institution.podcastProduction.assigned": "Assigné",
  "institution.podcastProduction.in_production": "En production",
  "institution.podcastProduction.ready": "Prêt",
  "institution.categories.title": "Catégories",
  "institution.categories.subtitle": "Organisez vos formations par thématique",
  "institution.categories.add": "Ajouter",
  "institution.categories.edit": "Modifier la catégorie",
  "institution.categories.new": "Nouvelle catégorie",
  "institution.categories.usage": "{{count}} formation(s)",
  "institution.categories.pageSubtitle": "Organisez vos contenus par catégorie",
  "institution.categories.namePlaceholder": "Nom de la catégorie",
  "institution.categories.color": "Couleur",
  "institution.categories.descShortPh": "Description courte",
  "institution.categories.usageTimes": "({{count}} utilisations)",
  "institution.templates.title": "Modèles de blocs",
  "institution.templates.subtitle": "Bibliothèque de modèles réutilisables",
  "institution.templates.statTotal": "Modèles",
  "institution.templates.statUsage": "Utilisations totales",
  "institution.templates.mostUsed": "Type le plus utilisé",
  "institution.templates.preview": "Aperçu",
  "institution.templates.searchPh": "Rechercher un modèle…",
  "institution.templates.copySuffix": " (copie)",
  "institution.templates.empty": "Aucun modèle trouvé",
  "institution.templates.loadFormatError": "Impossible de lire les modèles (réponse serveur invalide).",
  "institution.templates.usesShort": "{{count}} utilisations",
  "institution.templates.filterAll": "Tous les types",
  "institution.blockTypes.text": "Texte",
  "institution.blockTypes.quiz": "Quiz",
  "institution.blockTypes.video": "Vidéo",
  "institution.blockTypes.audio": "Audio",
  "institution.blockTypes.image": "Image",
  "institution.blockTypes.document": "Document",
  "institution.blockTypes.code": "Code",
  "institution.blockTypes.discussion": "Discussion",
  "institution.scorm.title": "Import SCORM",
  "institution.scorm.subtitle": "Importez des paquets SCORM 1.2 ou 2004",
  "institution.scorm.dropHere": "Glissez-déposez votre fichier SCORM (.zip) ici",
  "institution.scorm.browseHint": "ou cliquez pour parcourir",
  "institution.scorm.selectedFile": "Fichier sélectionné : {{name}}",
  "institution.scorm.startImport": "Lancer l'import",
  "institution.scorm.importingNamed": "Import en cours : {{name}}",
  "institution.scorm.analyzing": "Analyse des modules… {{pct}}%",
  "institution.scorm.historyTitle": "Historique des imports",
  "institution.scorm.colFile": "Fichier",
  "institution.scorm.colDate": "Date",
  "institution.scorm.colStatus": "Statut",
  "institution.scorm.colModules": "Modules",
  "institution.scorm.colVersion": "Version",
  "institution.scorm.colFlow": "Formation",
  "institution.scorm.empty": "Aucun import pour le moment. Déposez un fichier .zip SCORM ci-dessus.",
  "institution.scorm.openFlow": "Ouvrir",
  "institution.scorm.statusImporting": "Import en cours…",
  "institution.scorm.statusSuccess": "Succès",
  "institution.scorm.statusError": "Erreur",
  "institution.designers.title": "Collaborateurs",
  "institution.designers.subtitle": "Formateurs, DRH, RH et administrateurs de votre établissement (plus d’intitulé « enseignant »).",
  "institution.designers.invite": "Inviter",
  "institution.designers.statTotal": "Total collaborateurs",
  "institution.designers.statActiveMonth": "Actifs ce mois",
  "institution.designers.statFlows": "Formations créées (cumul)",
  "institution.designers.inviteTitle": "Inviter un collaborateur",
  "institution.designers.inviteHelp": "Choisissez le rôle : Formateur (contenus / formations), DRH, RH, ou Admin (administrateur de l’établissement sur Lyrra).",
  "institution.designers.emailPh": "adresse@email.com",
  "institution.designers.sendInvite": "Envoyer l'invitation",
  "institution.designers.loadError": "Impossible de charger les collaborateurs",
  "institution.designers.inviteFail": "Échec de l'invitation",
  "institution.designers.actionFail": "Action impossible",
  "institution.designers.searchPh": "Rechercher par nom ou email…",
  "institution.designers.colName": "Nom",
  "institution.designers.colEmail": "Email",
  "institution.designers.colRole": "Rôle",
  "institution.designers.colProjects": "Projets",
  "institution.designers.colLastActivity": "Dernière activité",
  "institution.designers.colStatus": "Statut",
  "institution.designers.colActions": "Actions",
  "institution.designers.empty": "Aucun collaborateur trouvé",
  "institution.designers.roleAdmin": "Admin",
  "institution.designers.roleTeacher": "Formateur",
  "institution.designers.roleTrainingLead": "Resp. formation",
  "institution.designers.roleCollaborator": "Collaborateur",
  "institution.designers.roleOptFormateur": "Formateur",
  "institution.designers.roleOptDrh": "DRH",
  "institution.designers.roleOptRh": "RH",
  "institution.designers.roleOptAdmin": "Admin",
  "institution.designers.statusActive": "Actif",
  "institution.designers.statusInvited": "Invité",
  "institution.designers.statusSuspended": "Suspendu",
  "institution.designers.menuView": "Voir le profil",
  "institution.designers.menuMakeAdmin": "Rendre admin",
  "institution.designers.menuSuspend": "Suspendre",
  "institution.designers.menuRemove": "Retirer",
  "institution.billing.title": "Ofrechnung",
  "institution.billing.subtitle": "Abonnement, consommation et factures",
  "institution.billing.planLabel": "Plan actuel",
  "institution.billing.planPro": "Pro",
  "institution.billing.priceExample": "299 €",
  "institution.billing.perMonth": "/ mois",
  "institution.billing.renewalMock": "Renouvellement le 1er février 2025",
  "institution.billing.featureCollaborators": "10 collaborateurs",
  "institution.billing.featureLearners": "500 apprenants",
  "institution.billing.featureStorage": "50 Go stockage",
  "institution.billing.featureSupport": "Support prioritaire",
  "institution.billing.featureApi": "API MCP",
  "institution.billing.changePlan": "Changer de plan",
  "institution.billing.usageCollaborators": "Collaborateurs",
  "institution.billing.usageLearners": "Apprenants",
  "institution.billing.usageStorage": "Stockage",
  "institution.billing.storageUnit": "Go",
  "institution.billing.cardMasked": "Carte Visa •••• 4242",
  "institution.billing.cardExpires": "Expire le {{date}}",
  "institution.billing.invoicesTitle": "Factures",
  "institution.billing.colRef": "Référence",
  "institution.billing.colDate": "Date",
  "institution.billing.colAmount": "Montant",
  "institution.billing.colStatus": "Statut",
  "institution.billing.colPdf": "PDF",
  "institution.billing.invPaid": "Payée",
  "institution.billing.invOpen": "En attente",
  "institution.billing.invDraft": "Brouillon",
  "institution.billing.invVoid": "Annulée",
  "institution.billing.invUncollectible": "Impayée",
  "institution.mcp.title": "MCP — Model Context Protocol",
  "institution.landing.designerTitle": "Designer de page",
  "institution.learners.title": "Léierenden",
  "institution.learners.searchPh": "Rechercher un apprenant…",
  "institution.learners.filterStatus": "Statut",
  "institution.learners.filterPlaceholder": "Filtrer",
  "institution.learners.selectedCount": "{{count}} sélectionné(s)",
  "institution.learners.exportSelection": "Exporter la sélection",
  "institution.learners.exportAll": "Exporter tout",
  "institution.learners.colLearner": "Apprenant",
  "institution.learners.colGroup": "Groupe",
  "institution.learners.colLastActive": "Dernière activité",
  "institution.learners.colStatus": "Statut",
  "institution.learners.empty": "Aucun apprenant trouvé",
  "institution.learners.countList": "{{count}} apprenant(s)",
  "institution.learners.subtitle": "{{count}} apprenant(s) inscrits dans votre établissement",
  "institution.learners.importCsv": "Import CSV",
  "institution.learners.add": "Ajouter",
  "institution.learners.statLearners": "Apprenants",
  "institution.learners.statActive30": "Actifs (30j)",
  "institution.learners.statEnrollments": "Inscriptions",
  "institution.learners.statCompleted": "Formations terminées",
  "institution.learners.statusAll": "Tous les statuts",
  "institution.learners.statusActive": "Actif",
  "institution.learners.statusInactive": "Inactif",
  "institution.learners.statusCompleted": "Terminé",
  "institution.learners.sheetTitle": "Fiche apprenant",
  "institution.learners.openProfileDetail": "Detail vum Profil",
  "institution.learners.groupsCatalogTitle": "Groupes paramétrés",
  "institution.learners.groupsCatalogSubtitle": "Liste définie dans l’onglet « Groupes » de votre établissement.",
  "institution.learners.replacePhoto": "Remplacer",
  "institution.learners.addPhoto": "Ajouter une photo",
  "institution.learners.removePhoto": "Supprimer",
  "institution.learners.firstName": "Prénom",
  "institution.learners.lastName": "Nom",
  "institution.learners.save": "Enregistrer",
  "institution.learners.deactivate": "Désactiver",
  "institution.learners.reactivate": "Réactiver",
  "institution.learners.lastActivity": "Dernière activité :",
  "institution.learners.paths": "Parcours ({{count}})",
  "institution.learners.noPaths": "Aucun parcours assigné",
  "institution.learners.noFlowsEnrolled": "Aucune formation inscrite",
  "institution.learners.done": "Terminé",
  "institution.learners.inProgress": "En cours",
  "institution.learners.itemsProgress": "{{done}}/{{total}} contenus",
  "institution.learners.flows": "Formations",
  "institution.learners.completedF": "Terminées",
  "institution.learners.totalTime": "Temps total",
  "institution.learners.progress": "Progression",
  "institution.learners.flowDone": "Terminée",
  "institution.learners.blocks": "{{visited}}/{{total}} blocs",
  "institution.learners.score": "Score : {{score}}%",
  "institution.learners.sessions": "{{count}} sessions",
  "institution.learners.started": "Début :",
  "institution.learners.ended": "Fin :",
  "institution.learners.lastAccess": "Dernier accès :",
  "institution.learners.podcasts": "Podcasts",
  "institution.learners.noPodcastListen": "Aucune écoute enregistrée",
  "institution.learners.deleteTitle": "Supprimer cet apprenant ?",
  "institution.learners.deleteDesc": "Êtes-vous sûr de vouloir supprimer définitivement {{name}} ({{email}}) ? Cette action est irréversible et supprimera toutes ses données associées.",
  "institution.learners.deactivateTitle": "Désactiver cet apprenant ?",
  "institution.learners.reactivateTitle": "Réactiver cet apprenant ?",
  "institution.learners.deactivateDesc": "{{name}} ne pourra plus accéder aux formations tant qu’il sera désactivé.",
  "institution.learners.reactivateDesc": "{{name}} retrouvera l’accès à ses formations.",
  "institution.learners.deleteLearner": "Supprimer cet apprenant",
  "institution.learners.photoUploadError": "Erreur lors de l’upload de la photo",
  "institution.learners.photoRemoveError": "Erreur lors de la suppression",
  "institution.learners.service": "Service",
  "institution.learners.serviceHint":
    "Choisissez une entrée du référentiel (onglet Services). Tapez pour filtrer la liste.",
  "institution.learners.serviceSearch": "Rechercher un service…",
  "institution.learners.serviceNone": "Aucun service",
  "institution.learners.exportSheetLearners": "Apprenants",
  "institution.learners.exportSheetDetails": "Détails formations",
  "institution.learners.export.firstName": "Prénom",
  "institution.learners.export.lastName": "Nom",
  "institution.learners.export.groupCol": "Groupe",
  "institution.learners.export.enrollments": "Formations inscrites",
  "institution.learners.export.completed": "Formations terminées",
  "institution.learners.export.progressPct": "Progression (%)",
  "institution.learners.export.totalMin": "Temps total (min)",
  "institution.learners.export.lastAct": "Dernière activité",
  "institution.learners.export.statusCol": "Statut",
  "institution.learners.export.learnerCol": "Apprenant",
  "institution.learners.export.typeCol": "Type",
  "institution.learners.export.titleCol": "Titre",
  "institution.learners.export.blocks": "Blocs visités / Total",
  "institution.learners.export.sessionsDone": "Sessions terminées",
  "institution.learners.export.avgScore": "Score moyen (%)",
  "institution.learners.export.timeMin": "Temps passé (min)",
  "institution.learners.export.dateStart": "Date début",
  "institution.learners.export.dateEnd": "Date fin",
  "institution.learners.export.lastAcc": "Dernier accès",
  "institution.learners.export.typeCourse": "Formation",
  "institution.learners.export.typePath": "Parcours",
  "institution.reminders.openPanel": "Rappels e-mail",
  "institution.reminders.panelTitle": "Rappels",
  "institution.reminders.panelSubtitle":
    "Alertes automatiques envoyées aux apprenants concernés. Vérification planifiée chaque heure (heure UTC choisie). Un même rappel n’est envoyé qu’une fois par apprenant et par règle.",
  "institution.reminders.sectionRules": "Règles",
  "institution.reminders.sectionLogs": "Journal d’envoi",
  "institution.reminders.addRule": "Ajouter une alerte",
  "institution.reminders.removeRule": "Supprimer cette alerte",
  "institution.reminders.save": "Enregistrer les règles",
  "institution.reminders.loadError": "Impossible de charger les rappels.",
  "institution.reminders.saveError": "Enregistrement impossible.",
  "institution.reminders.rulesEmpty": "Aucune alerte. Ajoutez une règle, ou enregistrez une liste vide pour désactiver tous les rappels sur ce contenu.",
  "institution.reminders.logsEmpty": "Aucun envoi enregistré pour l’instant.",
  "institution.reminders.utcHint":
    "Choisissez l’heure UTC à laquelle le serveur évalue cette règle (0–23). Ex. 8 UTC ≈ 9h hiver Paris.",
  "institution.reminders.fieldKind": "Type d’alerte",
  "institution.reminders.fieldDays": "Jours après l’événement",
  "institution.reminders.fieldHourUtc": "Heure de contrôle (UTC)",
  "institution.reminders.fieldEnabled": "Activer cette alerte",
  "institution.reminders.fieldLabel": "Libellé interne (optionnel)",
  "institution.reminders.fieldLabelPh": "ex. Relance J+3",
  "institution.reminders.ruleKind.eduflow_not_started_days_after_enroll":
    "Formation : pas commencée X jours après inscription (création participant)",
  "institution.reminders.ruleKind.eduflow_incomplete_days_after_deadline":
    "Formation : non terminée X jours après la date limite du parcours (deadline)",
  "institution.reminders.ruleKind.path_incomplete_days_after_assign":
    "Parcours : non terminé X jours après assignation à l’apprenant",
  "institution.pages.brandingTitle": "Identité visuelle",
  "institution.pages.webhooksTitle": "Webhooks",
  "institution.pages.landingTitle": "Page publique",
  },
  uk: {
    ...institutionRhCompetenciesStrings.uk,
    ...institutionBiStringsEn,
  "institution.tabs.home": "Головна",
  "institution.tabs.flows": "Навчальні курси",
  "institution.tabs.supports": "Podcasts",
  "institution.tabs.categories": "Категорії",
  "institution.tabs.templates": "Шаблони блоків",
  "institution.tabs.scorm": "Імпорт SCORM",
  "institution.tabs.designers": "Співробітники",
  "institution.tabs.learners": "Учні",
  "institution.tabs.learnerAnalytics": "Аналітика учнів",
  "institution.tabs.biStudio": "BI-панелі",
  "institution.tabs.groups": "Групи",
  "institution.tabs.services": "Служби",
  "institution.tabs.branding": "Брендинг",
  "institution.tabs.landing": "Публічна сторінка",
  "institution.tabs.webhooks": "Webhooks",
  "institution.tabs.ssoOidc": "SSO (OpenID Connect & SAML)",
  "institution.tabs.xapi": "xAPI (LRS)",
  "institution.tabs.mcp": "MCP",
  "institution.tabs.billing": "Білінг",
  "institution.nav.section.general": "Огляд",
  "institution.nav.section.content": "Контент і навчання",
  "institution.nav.section.people": "Команди та учні",
  "institution.nav.section.portal": "Портал і бренд",
  "institution.nav.section.integrations": "Інтеграції",
  "institution.nav.section.subscription": "Підписка",
  "institution.sidebar.subtitle": "Заклад",
  "institution.sidebar.subtitleRh": "HR-простір",
  "institution.sidebar.subtitleAdmin": "Адміністрування",
  "institution.sidebar.logout": "Вийти",
  "institution.sidebar.collapse": "Згорнути",
  "institution.sidebar.expandAria": "Розгорнути бічну панель",
  "institution.sidebar.collapseAria": "Згорнути бічну панель",
  "institution.sidebar.language": "Language",
  "institution.sidebar.languageAria": "Change language",
  "institution.common.cancel": "Скасувати",
  "institution.common.save": "Зберегти",
  "institution.tabs.webinars": "Вебінари",
  "institution.tabs.webinarsPilotage": "Керування вебінарами",
  "institution.webinars.pageTitle": "Налаштування вебінарів",
  "institution.webinars.settingsIntro":
    "Увімкніть модуль і задайте повідомлення кімнати очікування за замовчуванням. Список вебінарів і ведучих керується на вкладці « {{tabName}} ».",
  "institution.webinars.enableForInstitution": "Увімкнути вебінари для закладу",
  "institution.webinars.enabledBadge": "Модуль увімкнено",
  "institution.webinars.disabledBadge": "Модуль вимкнено",
  "institution.webinars.sectionModule": "Активація",
  "institution.webinars.sectionModuleHint": "Дозволяє тренерам закладу створювати та проводити прямі сесії.",
  "institution.webinars.sectionWaitingRoom": "Кімната очікування",
  "institution.webinars.waitingHtmlLabel": "HTML кімнати очікування (за замовчуванням)",
  "institution.webinars.waitingHtmlPlaceholder": "<p>Ваше привітання…</p>",
  "institution.webinars.waitingHtmlHint": "Простий HTML для учасників до початку. Кольори відповідають темі цього простору.",
  "institution.webinars.openPilotage": "Відкрити керування вебінарами",
  "institution.webinars.waitingPreviewTitle": "Попередній перегляд — повідомлення очікування",
  "institution.webinars.waitingPreviewHint": "Як бачать учасники перед початком вебінару.",
  "institution.webinars.loadError": "Не вдалося завантажити налаштування вебінарів.",
  "institution.webinars.saveSuccess": "Налаштування вебінарів збережено.",
  "institution.webinars.saveError": "Не вдалося зберегти.",
  "institution.common.saving": "Збереження…",
  "institution.common.delete": "Delete",
  "institution.common.edit": "Edit",
  "institution.common.create": "Create",
  "institution.common.add": "Add",
  "institution.common.retry": "Retry",
  "institution.common.refresh": "Refresh",
  "institution.common.search": "Search…",
  "institution.common.loading": "Loading…",
  "institution.common.page": "Сторінка",
  "institution.common.of": "з",
  "institution.common.name": "Name",
  "institution.common.description": "Description",
  "institution.common.email": "Email",
  "institution.common.member": "Member",
  "institution.common.members": "Members",
  "institution.common.back": "Back",
  "institution.common.view": "View",
  "institution.common.duplicate": "Duplicate",
  "institution.common.toggleStatus": "Enable / disable",
  "institution.common.author": "Author",
  "institution.common.title": "Title",
  "institution.common.status": "Status",
  "institution.common.type": "Type",
  "institution.common.actions": "Actions",
  "institution.common.createdAt": "Created",
  "institution.common.assignedTo": "Assigned to",
  "institution.common.completion": "Completion",
  "institution.common.learners": "Learners",
  "institution.common.empty": "—",
  "institution.status.draft": "Чернетка",
  "institution.status.published": "Опубліковано",
  "institution.status.archived": "Archived",
  "institution.status.allStatuses": "All statuses",
  "institution.status.allTypes": "All types",
  "institution.dashboard.loading": "Завантаження панелі…",
  "institution.dashboard.loadError": "Не вдалося завантажити панель.",
  "institution.dashboard.activity.completion": "Completion",
  "institution.dashboard.activity.enrollment": "Enrollment",
  "institution.dashboard.activity.milestone": "Milestone",
  "institution.dashboard.activity.feedback": "Feedback",
  "institution.dashboard.activity.start": "Start",
  "institution.dashboard.activity.1": "Marie Dupont completed “UX Fundamentals”",
  "institution.dashboard.activity.2": "12 new learners enrolled in “Design Thinking”",
  "institution.dashboard.activity.3": "Group “Cohort Q3” reached 80% completion",
  "institution.dashboard.activity.4": "NPS survey received 24 new responses",
  "institution.dashboard.activity.5": "Jean Martin started “Agile methods”",
  "institution.dashboard.time.5m": "5 min ago",
  "institution.dashboard.time.1h": "1h ago",
  "institution.dashboard.time.3h": "3h ago",
  "institution.dashboard.time.5h": "5h ago",
  "institution.dashboard.time.6h": "6h ago",
  "institution.dashboard.activity.flowCompleted": "{{name}} completed “{{flow}}”",
  "institution.dashboard.activity.participantJoined": "Learner added: {{email}}",
  "institution.dashboard.activity.flowStarted": "{{name}} started “{{flow}}”",
  "institution.dashboard.chartTopFlowsEmpty": "Not enough data yet. Publish courses and invite learners.",
  "institution.dashboard.activityEmpty": "No recent activity.",
  "institution.groups.title": "Керування групами",
  "institution.groups.countShown": "{{count}} group(s)",
  "institution.groups.subtitle": "{{count}} group(s) in your institution",
  "institution.groups.create": "Create group",
  "institution.groups.statGroups": "Groups",
  "institution.groups.statTotalMembers": "Total members",
  "institution.groups.statEmpty": "Empty groups",
  "institution.groups.loadError": "Unable to load groups.",
  "institution.groups.searchPh": "Search a group…",
  "institution.groups.colGroup": "Group",
  "institution.groups.colCreated": "Created",
  "institution.groups.memberCount": "{{count}} member(s)",
  "institution.groups.emptyNone": "No groups yet. Create your first group.",
  "institution.groups.emptyFilter": "No groups match your search.",
  "institution.groups.backList": "Back to groups",
  "institution.groups.addLearner": "Add learner",
  "institution.groups.dateCreated": "Created on",
  "institution.groups.colMember": "Member",
  "institution.groups.colAdded": "Added on",
  "institution.groups.noMembers": "No members in this group",
  "institution.groups.loadGroupError": "Unable to load the group",
  "institution.groups.panelTitle": "Add learners",
  "institution.groups.noLearnersAvailable": "No learners available",
  "institution.groups.noResults": "No results",
  "institution.groups.modalEdit": "Edit group",
  "institution.groups.modalCreate": "Create group",
  "institution.groups.groupName": "Group name",
  "institution.groups.removeFromGroup": "Remove from group",
  "institution.services.title": "Корпоративні служби",
  "institution.services.subtitle":
    "Довідник підрозділів (HR, фінанси тощо). Призначайте здобувачів у їх профілі.",
  "institution.services.create": "Нова служба",
  "institution.services.loadError": "Не вдалося завантажити служби.",
  "institution.services.empty": "Служб ще немає. Створіть запис, щоб призначати здобувачів.",
  "institution.services.modalCreate": "Створити службу",
  "institution.services.modalEdit": "Редагувати службу",
  "institution.services.fieldName": "Назва служби",
  "institution.services.deleteConfirm":
    "Видалити цю службу? Прив’язані здобувачі втратять призначений підрозділ.",
  "institution.services.listSubtitle": "{{count}} служб(и) у вашій установі",
  "institution.services.intro":
    "Довідник підрозділів (HR, фінанси тощо). Призначайте здобувачів у їх профілі.",
  "institution.services.statTotal": "Служби",
  "institution.services.statWithDesc": "З описом",
  "institution.services.statNoDesc": "Без опису",
  "institution.services.searchPh": "Пошук служби…",
  "institution.services.colService": "Служба",
  "institution.services.colCreated": "Створено",
  "institution.services.emptyNone": "Служб ще немає. Створіть першу.",
  "institution.services.emptyFilter": "Жодна служба не відповідає пошуку.",
  "institution.services.countShown": "{{count}} служб(и)",
  "institution.flows.title": "Курси",
  "institution.flows.subtitle": "Manage your courses",
  "institution.flows.statTotal": "Total courses",
  "institution.flows.statPublished": "Published",
  "institution.flows.statLearners": "Total learners",
  "institution.flows.searchPh": "Search a course…",
  "institution.flows.colName": "Name",
  "institution.flows.empty": "No course found",
  "institution.flows.badgeEnterprise": "Enterprise training need",
  "institution.flows.deleteEnterpriseTooltip": "Move to trash (enterprise need)",
  "institution.flows.deleteEnterpriseTitle": "Remove this enterprise-linked course?",
  "institution.flows.deleteEnterpriseHint": "The course will be soft-deleted. Trainers cannot do this; only institution admin, DRH or HR can restore or remove it from this dashboard.",
  "institution.flows.deleteEnterpriseConfirm": "Move to trash",
  "institution.flows.deleteEnterpriseSuccess": "Course moved to trash.",
  "institution.flows.deleteEnterpriseError": "Action failed.",
  "institution.learningPaths.sectionTitle": "Learning paths",
  "institution.learningPaths.sectionSubtitle": "Paths owned by a member of your institution.",
  "institution.learningPaths.searchPh": "Search a path…",
  "institution.learningPaths.colItems": "Items",
  "institution.learningPaths.colAssignments": "Assignments",
  "institution.learningPaths.transferOwner": "Reassign owner",
  "institution.learningPaths.transferModalTitle": "Change path owner",
  "institution.learningPaths.transferModalHint":
    "The selected account becomes the owner; referenced library media (e.g. cover) moves when traceable in the database.",
  "institution.learningPaths.transferPickUser": "New owner",
  "institution.learningPaths.transferSubmit": "Confirm transfer",
  "institution.learningPaths.transferLoadingUsers": "Loading accounts…",
  "institution.learningPaths.transferNoCandidates": "No other collaborator available",
  "institution.learningPaths.transferError": "Transfer failed",
  "institution.learningPaths.transferSuccess": "Owner updated",
  "institution.learningPaths.empty": "No path found",
  "institution.supports.title": "Podcasts",
  "institution.supports.subtitle": "Podcasts and audio content",
  "institution.supports.searchPh": "Search a podcast…",
  "institution.supports.empty": "No podcast found",
  "institution.supports.typeDictation": "Dictation",
  "institution.supports.typeText": "Text",
  "institution.supports.typeAi": "AI",
  "institution.supports.transferOwner": "Reassign podcast creator",
  "institution.supports.transferModalTitle": "Change podcast owner",
  "institution.supports.transferModalHint":
    "The selected account becomes the podcast creator; episodes and referenced library media move when traceable in the database.",
  "institution.supports.transferPickUser": "New creator",
  "institution.supports.transferSubmit": "Confirm transfer",
  "institution.supports.transferLoadingUsers": "Loading accounts…",
  "institution.supports.transferNoCandidates": "No other collaborator available",
  "institution.supports.transferError": "Transfer failed",
  "institution.supports.transferSuccess": "Creator updated",
  "institution.categories.title": "Категорії",
  "institution.categories.subtitle": "Organize your courses by topic",
  "institution.categories.add": "Add",
  "institution.categories.edit": "Edit category",
  "institution.categories.new": "New category",
  "institution.categories.usage": "{{count}} course(s)",
  "institution.categories.pageSubtitle": "Organize your content by category",
  "institution.categories.namePlaceholder": "Category name",
  "institution.categories.color": "Color",
  "institution.categories.descShortPh": "Short description",
  "institution.categories.usageTimes": "({{count}} uses)",
  "institution.templates.title": "Шаблони блоків",
  "institution.templates.subtitle": "Reusable template library",
  "institution.templates.statTotal": "Templates",
  "institution.templates.statUsage": "Total uses",
  "institution.templates.mostUsed": "Most used type",
  "institution.templates.preview": "Preview",
  "institution.templates.searchPh": "Search a template…",
  "institution.templates.copySuffix": " (copy)",
  "institution.templates.empty": "No templates found",
  "institution.templates.loadFormatError": "Could not load templates (invalid server response).",
  "institution.templates.usesShort": "{{count}} uses",
  "institution.templates.filterAll": "All types",
  "institution.blockTypes.text": "Text",
  "institution.blockTypes.quiz": "Quiz",
  "institution.blockTypes.video": "Video",
  "institution.blockTypes.audio": "Audio",
  "institution.blockTypes.image": "Image",
  "institution.blockTypes.document": "Document",
  "institution.blockTypes.code": "Code",
  "institution.blockTypes.discussion": "Discussion",
  "institution.scorm.title": "Імпорт SCORM",
  "institution.scorm.subtitle": "Import SCORM 1.2 or 2004 packages",
  "institution.scorm.dropHere": "Drag and drop your SCORM (.zip) file here",
  "institution.scorm.browseHint": "or click to browse",
  "institution.scorm.selectedFile": "Selected file: {{name}}",
  "institution.scorm.startImport": "Start import",
  "institution.scorm.importingNamed": "Import in progress: {{name}}",
  "institution.scorm.analyzing": "Analyzing modules… {{pct}}%",
  "institution.scorm.historyTitle": "Import history",
  "institution.scorm.colFile": "File",
  "institution.scorm.colDate": "Date",
  "institution.scorm.colStatus": "Status",
  "institution.scorm.colModules": "Modules",
  "institution.scorm.colVersion": "Version",
  "institution.scorm.colFlow": "Course",
  "institution.scorm.empty": "No imports yet. Drop a SCORM .zip file above.",
  "institution.scorm.openFlow": "Open",
  "institution.scorm.statusImporting": "Importing…",
  "institution.scorm.statusSuccess": "Success",
  "institution.scorm.statusError": "Error",
  "institution.designers.title": "Співробітники",
  "institution.designers.subtitle": "Trainers, HR leads, HR staff and administrators for your institution (no more “teacher” wording).",
  "institution.designers.invite": "Invite",
  "institution.designers.statTotal": "Total collaborators",
  "institution.designers.statActiveMonth": "Active this month",
  "institution.designers.statFlows": "Courses created (total)",
  "institution.designers.inviteTitle": "Invite a collaborator",
  "institution.designers.inviteHelp": "Choose a role: Trainer (content / courses), HR lead, HR staff, or Admin (institution administrator on Lyrra).",
  "institution.designers.emailPh": "email@example.com",
  "institution.designers.sendInvite": "Send invitation",
  "institution.designers.loadError": "Unable to load collaborators",
  "institution.designers.inviteFail": "Invitation failed",
  "institution.designers.actionFail": "Action failed",
  "institution.designers.searchPh": "Search by name or email…",
  "institution.designers.colName": "Name",
  "institution.designers.colEmail": "Email",
  "institution.designers.colRole": "Role",
  "institution.designers.colProjects": "Projects",
  "institution.designers.colLastActivity": "Last activity",
  "institution.designers.colStatus": "Status",
  "institution.designers.colActions": "Actions",
  "institution.designers.empty": "No collaborator found",
  "institution.designers.roleAdmin": "Admin",
  "institution.designers.roleTeacher": "Trainer",
  "institution.designers.roleTrainingLead": "Training lead",
  "institution.designers.roleCollaborator": "Collaborator",
  "institution.designers.roleOptFormateur": "Trainer",
  "institution.designers.roleOptDrh": "HR lead",
  "institution.designers.roleOptRh": "HR",
  "institution.designers.roleOptAdmin": "Admin",
  "institution.designers.statusActive": "Active",
  "institution.designers.statusInvited": "Invited",
  "institution.designers.statusSuspended": "Suspended",
  "institution.designers.menuView": "View profile",
  "institution.designers.menuMakeAdmin": "Make admin",
  "institution.designers.menuSuspend": "Suspend",
  "institution.designers.menuRemove": "Remove",
  "institution.billing.title": "Білінг",
  "institution.billing.subtitle": "Subscription, usage and invoices",
  "institution.billing.planLabel": "Current plan",
  "institution.billing.planPro": "Pro",
  "institution.billing.priceExample": "€299",
  "institution.billing.perMonth": "/ month",
  "institution.billing.renewalMock": "Renews on February 1, 2025",
  "institution.billing.featureCollaborators": "10 collaborators",
  "institution.billing.featureLearners": "500 learners",
  "institution.billing.featureStorage": "50 GB storage",
  "institution.billing.featureSupport": "Priority support",
  "institution.billing.featureApi": "MCP API",
  "institution.billing.changePlan": "Change plan",
  "institution.billing.usageCollaborators": "Collaborators",
  "institution.billing.usageLearners": "Learners",
  "institution.billing.usageStorage": "Storage",
  "institution.billing.storageUnit": "GB",
  "institution.billing.cardMasked": "Visa •••• 4242",
  "institution.billing.cardExpires": "Expires {{date}}",
  "institution.billing.invoicesTitle": "Invoices",
  "institution.billing.colRef": "Reference",
  "institution.billing.colDate": "Date",
  "institution.billing.colAmount": "Amount",
  "institution.billing.colStatus": "Status",
  "institution.billing.colPdf": "PDF",
  "institution.billing.invPaid": "Paid",
  "institution.billing.invOpen": "Pending",
  "institution.billing.invDraft": "Draft",
  "institution.billing.invVoid": "Void",
  "institution.billing.invUncollectible": "Uncollectible",
  "institution.mcp.title": "MCP — Model Context Protocol",
  "institution.landing.designerTitle": "Page designer",
  "institution.learners.title": "Учні",
  "institution.learners.searchPh": "Search a learner…",
  "institution.learners.filterStatus": "Status",
  "institution.learners.filterPlaceholder": "Filter",
  "institution.learners.selectedCount": "{{count}} selected",
  "institution.learners.exportSelection": "Export selection",
  "institution.learners.exportAll": "Export all",
  "institution.learners.colLearner": "Learner",
  "institution.learners.colGroup": "Group",
  "institution.learners.colLastActive": "Last activity",
  "institution.learners.colStatus": "Status",
  "institution.learners.empty": "No learner found",
  "institution.learners.countList": "{{count}} learner(s)",
  "institution.learners.subtitle": "{{count}} learner(s) enrolled in your institution",
  "institution.learners.importCsv": "Import CSV",
  "institution.learners.add": "Add",
  "institution.learners.statLearners": "Learners",
  "institution.learners.statActive30": "Active (30d)",
  "institution.learners.statEnrollments": "Enrollments",
  "institution.learners.statCompleted": "Completed courses",
  "institution.learners.statusAll": "All statuses",
  "institution.learners.statusActive": "Active",
  "institution.learners.statusInactive": "Inactive",
  "institution.learners.statusCompleted": "Completed",
  "institution.learners.sheetTitle": "Learner profile",
  "institution.learners.openProfileDetail": "Деталі профілю",
  "institution.learners.groupsCatalogTitle": "Налаштовані групи",
  "institution.learners.groupsCatalogSubtitle": "Список з вкладки « Групи » вашого закладу.",
  "institution.learners.replacePhoto": "Replace",
  "institution.learners.addPhoto": "Add photo",
  "institution.learners.removePhoto": "Remove",
  "institution.learners.firstName": "First name",
  "institution.learners.lastName": "Last name",
  "institution.learners.save": "Save",
  "institution.learners.deactivate": "Deactivate",
  "institution.learners.reactivate": "Reactivate",
  "institution.learners.lastActivity": "Last activity:",
  "institution.learners.paths": "Paths ({{count}})",
  "institution.learners.noPaths": "No assigned path",
  "institution.learners.noFlowsEnrolled": "No enrolled course",
  "institution.learners.done": "Done",
  "institution.learners.inProgress": "In progress",
  "institution.learners.itemsProgress": "{{done}}/{{total}} items",
  "institution.learners.flows": "Courses",
  "institution.learners.completedF": "Completed",
  "institution.learners.totalTime": "Total time",
  "institution.learners.progress": "Progress",
  "institution.learners.flowDone": "Completed",
  "institution.learners.blocks": "{{visited}}/{{total}} blocks",
  "institution.learners.score": "Score: {{score}}%",
  "institution.learners.sessions": "{{count}} sessions",
  "institution.learners.started": "Started:",
  "institution.learners.ended": "Ended:",
  "institution.learners.lastAccess": "Last access:",
  "institution.learners.podcasts": "Podcasts",
  "institution.learners.noPodcastListen": "No listening recorded",
  "institution.learners.deleteTitle": "Delete this learner?",
  "institution.learners.deleteDesc": "Are you sure you want to permanently delete {{name}} ({{email}})? This cannot be undone and will remove all related data.",
  "institution.learners.deactivateTitle": "Deactivate this learner?",
  "institution.learners.reactivateTitle": "Reactivate this learner?",
  "institution.learners.deactivateDesc": "{{name}} will not be able to access courses while deactivated.",
  "institution.learners.reactivateDesc": "{{name}} will regain access to their courses.",
  "institution.learners.deleteLearner": "Delete this learner",
  "institution.learners.photoUploadError": "Error uploading photo",
  "institution.learners.photoRemoveError": "Error removing photo",
  "institution.learners.service": "Служба",
  "institution.learners.serviceHint":
    "Оберіть запис у довіднику (вкладка «Служби»). Введіть текст, щоб відфільтрувати список.",
  "institution.learners.serviceSearch": "Пошук служби…",
  "institution.learners.serviceNone": "Без служби",
  "institution.learners.exportSheetLearners": "Learners",
  "institution.learners.exportSheetDetails": "Course details",
  "institution.learners.export.firstName": "First name",
  "institution.learners.export.lastName": "Last name",
  "institution.learners.export.groupCol": "Group",
  "institution.learners.export.enrollments": "Enrolled courses",
  "institution.learners.export.completed": "Completed courses",
  "institution.learners.export.progressPct": "Progress (%)",
  "institution.learners.export.totalMin": "Total time (min)",
  "institution.learners.export.lastAct": "Last activity",
  "institution.learners.export.statusCol": "Status",
  "institution.learners.export.learnerCol": "Learner",
  "institution.learners.export.typeCol": "Type",
  "institution.learners.export.titleCol": "Title",
  "institution.learners.export.blocks": "Blocks visited / Total",
  "institution.learners.export.sessionsDone": "Sessions completed",
  "institution.learners.export.avgScore": "Average score (%)",
  "institution.learners.export.timeMin": "Time spent (min)",
  "institution.learners.export.dateStart": "Start date",
  "institution.learners.export.dateEnd": "End date",
  "institution.learners.export.lastAcc": "Last access",
  "institution.learners.export.typeCourse": "Course",
  "institution.learners.export.typePath": "Path",
  "institution.reminders.openPanel": "Нагадування електронною поштою",
  "institution.reminders.panelTitle": "Нагадування",
  "institution.reminders.panelSubtitle":
    "Автоматичні сповіщення електронною поштою для відповідних учнів. Перевірка щогодини в обрану годину UTC. Кожне правило спрацьовує для учня не більше одного разу.",
  "institution.reminders.sectionRules": "Правила",
  "institution.reminders.sectionLogs": "Журнал надсилань",
  "institution.reminders.addRule": "Додати сповіщення",
  "institution.reminders.removeRule": "Видалити це сповіщення",
  "institution.reminders.save": "Зберегти правила",
  "institution.reminders.loadError": "Не вдалося завантажити нагадування.",
  "institution.reminders.saveError": "Не вдалося зберегти.",
  "institution.reminders.rulesEmpty":
    "Немає сповіщень. Додайте правило або збережіть порожній список, щоб вимкнути всі нагадування для цього контенту.",
  "institution.reminders.logsEmpty": "Поки що немає записів про надсилання.",
  "institution.reminders.utcHint":
    "Оберіть годину UTC (0–23), коли сервер перевіряє це правило. Напр. 8 UTC ≈ зимовий час у Парижі +1 год.",
  "institution.reminders.fieldKind": "Тип сповіщення",
  "institution.reminders.fieldDays": "Днів після базової події",
  "institution.reminders.fieldHourUtc": "Година перевірки (UTC)",
  "institution.reminders.fieldEnabled": "Увімкнути це сповіщення",
  "institution.reminders.fieldLabel": "Внутрішня мітка (необов'язково)",
  "institution.reminders.fieldLabelPh": "напр. нагадування Д+3",
  "institution.reminders.ruleKind.eduflow_not_started_days_after_enroll":
    "Курс: не розпочато X днів після запису (картка учасника)",
  "institution.reminders.ruleKind.eduflow_incomplete_days_after_deadline":
    "Курс: не завершено X днів після дедлайну потоку",
  "institution.reminders.ruleKind.path_incomplete_days_after_assign":
    "Траєкторія: не завершено X днів після призначення учню",
  "institution.pages.brandingTitle": "Візуальна ідентичність",
  "institution.pages.webhooksTitle": "Webhooks",
  "institution.pages.landingTitle": "Публічна сторінка",
  },
  ru: {
    ...institutionRhCompetenciesStrings.ru,
    ...institutionBiStringsEn,
  "institution.tabs.home": "Главная",
  "institution.tabs.flows": "Курсы",
  "institution.tabs.supports": "Podcasts",
  "institution.tabs.categories": "Категории",
  "institution.tabs.templates": "Шаблоны блоков",
  "institution.tabs.scorm": "Импорт SCORM",
  "institution.tabs.designers": "Сотрудники",
  "institution.tabs.learners": "Учащиеся",
  "institution.tabs.learnerAnalytics": "Аналитика обучающихся",
  "institution.tabs.biStudio": "BI-дашборды",
  "institution.tabs.groups": "Группы",
  "institution.tabs.services": "Службы",
  "institution.tabs.branding": "Оформление",
  "institution.tabs.landing": "Публичная страница",
  "institution.tabs.webhooks": "Webhooks",
  "institution.tabs.ssoOidc": "SSO (OpenID Connect & SAML)",
  "institution.tabs.xapi": "xAPI (LRS)",
  "institution.tabs.mcp": "MCP",
  "institution.tabs.billing": "Оплата",
  "institution.nav.section.general": "Обзор",
  "institution.nav.section.content": "Контент и обучение",
  "institution.nav.section.people": "Команды и учащиеся",
  "institution.nav.section.portal": "Портал и образ",
  "institution.nav.section.integrations": "Интеграции",
  "institution.nav.section.subscription": "Подписка",
  "institution.sidebar.subtitle": "Организация",
  "institution.sidebar.subtitleRh": "HR-пространство",
  "institution.sidebar.subtitleAdmin": "Администрирование",
  "institution.sidebar.logout": "Выйти",
  "institution.sidebar.collapse": "Свернуть",
  "institution.sidebar.expandAria": "Развернуть боковую панель",
  "institution.sidebar.collapseAria": "Свернуть боковую панель",
  "institution.sidebar.language": "Language",
  "institution.sidebar.languageAria": "Change language",
  "institution.common.cancel": "Отмена",
  "institution.common.save": "Сохранить",
  "institution.tabs.webinars": "Вебинары",
  "institution.tabs.webinarsPilotage": "Управление вебинарами",
  "institution.webinars.pageTitle": "Настройки вебинаров",
  "institution.webinars.settingsIntro":
    "Включите модуль и задайте сообщение комнаты ожидания по умолчанию. Список вебинаров и ведущих — на вкладке « {{tabName}} ».",
  "institution.webinars.enableForInstitution": "Включить вебинары для учреждения",
  "institution.webinars.enabledBadge": "Модуль включён",
  "institution.webinars.disabledBadge": "Модуль выключен",
  "institution.webinars.sectionModule": "Активация",
  "institution.webinars.sectionModuleHint": "Позволяет тренерам учреждения создавать и проводить прямые сессии.",
  "institution.webinars.sectionWaitingRoom": "Комната ожидания",
  "institution.webinars.waitingHtmlLabel": "HTML комнаты ожидания (по умолчанию)",
  "institution.webinars.waitingHtmlPlaceholder": "<p>Ваше приветствие…</p>",
  "institution.webinars.waitingHtmlHint": "Простой HTML для участников до начала. Цвета соответствуют теме пространства.",
  "institution.webinars.openPilotage": "Открыть управление вебинарами",
  "institution.webinars.waitingPreviewTitle": "Предпросмотр — сообщение ожидания",
  "institution.webinars.waitingPreviewHint": "Как видят участники перед началом вебинара.",
  "institution.webinars.loadError": "Не удалось загрузить настройки вебинаров.",
  "institution.webinars.saveSuccess": "Настройки вебинаров сохранены.",
  "institution.webinars.saveError": "Не удалось сохранить.",
  "institution.common.saving": "Сохранение…",
  "institution.common.delete": "Delete",
  "institution.common.edit": "Edit",
  "institution.common.create": "Create",
  "institution.common.add": "Add",
  "institution.common.retry": "Retry",
  "institution.common.refresh": "Refresh",
  "institution.common.search": "Search…",
  "institution.common.loading": "Loading…",
  "institution.common.page": "Страница",
  "institution.common.of": "из",
  "institution.common.name": "Name",
  "institution.common.description": "Description",
  "institution.common.email": "Email",
  "institution.common.member": "Member",
  "institution.common.members": "Members",
  "institution.common.back": "Back",
  "institution.common.view": "View",
  "institution.common.duplicate": "Duplicate",
  "institution.common.toggleStatus": "Enable / disable",
  "institution.common.author": "Author",
  "institution.common.title": "Title",
  "institution.common.status": "Status",
  "institution.common.type": "Type",
  "institution.common.actions": "Actions",
  "institution.common.createdAt": "Created",
  "institution.common.assignedTo": "Assigned to",
  "institution.common.completion": "Completion",
  "institution.common.learners": "Learners",
  "institution.common.empty": "—",
  "institution.status.draft": "Черновик",
  "institution.status.published": "Опубликовано",
  "institution.status.archived": "Archived",
  "institution.status.allStatuses": "All statuses",
  "institution.status.allTypes": "All types",
  "institution.dashboard.loading": "Загрузка панели…",
  "institution.dashboard.loadError": "Не удалось загрузить панель.",
  "institution.dashboard.activity.completion": "Completion",
  "institution.dashboard.activity.enrollment": "Enrollment",
  "institution.dashboard.activity.milestone": "Milestone",
  "institution.dashboard.activity.feedback": "Feedback",
  "institution.dashboard.activity.start": "Start",
  "institution.dashboard.activity.1": "Marie Dupont completed “UX Fundamentals”",
  "institution.dashboard.activity.2": "12 new learners enrolled in “Design Thinking”",
  "institution.dashboard.activity.3": "Group “Cohort Q3” reached 80% completion",
  "institution.dashboard.activity.4": "NPS survey received 24 new responses",
  "institution.dashboard.activity.5": "Jean Martin started “Agile methods”",
  "institution.dashboard.time.5m": "5 min ago",
  "institution.dashboard.time.1h": "1h ago",
  "institution.dashboard.time.3h": "3h ago",
  "institution.dashboard.time.5h": "5h ago",
  "institution.dashboard.time.6h": "6h ago",
  "institution.dashboard.activity.flowCompleted": "{{name}} completed “{{flow}}”",
  "institution.dashboard.activity.participantJoined": "Learner added: {{email}}",
  "institution.dashboard.activity.flowStarted": "{{name}} started “{{flow}}”",
  "institution.dashboard.chartTopFlowsEmpty": "Not enough data yet. Publish courses and invite learners.",
  "institution.dashboard.activityEmpty": "No recent activity.",
  "institution.groups.title": "Управление группами",
  "institution.groups.countShown": "{{count}} group(s)",
  "institution.groups.subtitle": "{{count}} group(s) in your institution",
  "institution.groups.create": "Create group",
  "institution.groups.statGroups": "Groups",
  "institution.groups.statTotalMembers": "Total members",
  "institution.groups.statEmpty": "Empty groups",
  "institution.groups.loadError": "Unable to load groups.",
  "institution.groups.searchPh": "Search a group…",
  "institution.groups.colGroup": "Group",
  "institution.groups.colCreated": "Created",
  "institution.groups.memberCount": "{{count}} member(s)",
  "institution.groups.emptyNone": "No groups yet. Create your first group.",
  "institution.groups.emptyFilter": "No groups match your search.",
  "institution.groups.backList": "Back to groups",
  "institution.groups.addLearner": "Add learner",
  "institution.groups.dateCreated": "Created on",
  "institution.groups.colMember": "Member",
  "institution.groups.colAdded": "Added on",
  "institution.groups.noMembers": "No members in this group",
  "institution.groups.loadGroupError": "Unable to load the group",
  "institution.groups.panelTitle": "Add learners",
  "institution.groups.noLearnersAvailable": "No learners available",
  "institution.groups.noResults": "No results",
  "institution.groups.modalEdit": "Edit group",
  "institution.groups.modalCreate": "Create group",
  "institution.groups.groupName": "Group name",
  "institution.groups.removeFromGroup": "Remove from group",
  "institution.services.title": "Корпоративные службы",
  "institution.services.subtitle":
    "Справочник подразделений (HR, финансы и др.). Назначайте обучающихся в их карточке.",
  "institution.services.create": "Новая служба",
  "institution.services.loadError": "Не удалось загрузить службы.",
  "institution.services.empty": "Служб пока нет. Создайте запись, чтобы назначать обучающихся.",
  "institution.services.modalCreate": "Создать службу",
  "institution.services.modalEdit": "Изменить службу",
  "institution.services.fieldName": "Название службы",
  "institution.services.deleteConfirm":
    "Удалить эту службу? Связь у обучающихся будет снята.",
  "institution.services.listSubtitle": "{{count}} служб(ы) в вашей организации",
  "institution.services.intro":
    "Справочник подразделений (HR, финансы и др.). Назначайте обучающихся в их карточке.",
  "institution.services.statTotal": "Службы",
  "institution.services.statWithDesc": "С описанием",
  "institution.services.statNoDesc": "Без описания",
  "institution.services.searchPh": "Найти службу…",
  "institution.services.colService": "Служба",
  "institution.services.colCreated": "Создано",
  "institution.services.emptyNone": "Служб пока нет. Создайте первую.",
  "institution.services.emptyFilter": "Нет служб по запросу.",
  "institution.services.countShown": "{{count}} служб(ы)",
  "institution.flows.title": "Курсы",
  "institution.flows.subtitle": "Manage your courses",
  "institution.flows.statTotal": "Total courses",
  "institution.flows.statPublished": "Published",
  "institution.flows.statLearners": "Total learners",
  "institution.flows.searchPh": "Search a course…",
  "institution.flows.colName": "Name",
  "institution.flows.empty": "No course found",
  "institution.flows.badgeEnterprise": "Enterprise training need",
  "institution.flows.deleteEnterpriseTooltip": "Move to trash (enterprise need)",
  "institution.flows.deleteEnterpriseTitle": "Remove this enterprise-linked course?",
  "institution.flows.deleteEnterpriseHint": "The course will be soft-deleted. Trainers cannot do this; only institution admin, DRH or HR can restore or remove it from this dashboard.",
  "institution.flows.deleteEnterpriseConfirm": "Move to trash",
  "institution.flows.deleteEnterpriseSuccess": "Course moved to trash.",
  "institution.flows.deleteEnterpriseError": "Action failed.",
  "institution.learningPaths.sectionTitle": "Learning paths",
  "institution.learningPaths.sectionSubtitle": "Paths owned by a member of your institution.",
  "institution.learningPaths.searchPh": "Search a path…",
  "institution.learningPaths.colItems": "Items",
  "institution.learningPaths.colAssignments": "Assignments",
  "institution.learningPaths.transferOwner": "Reassign owner",
  "institution.learningPaths.transferModalTitle": "Change path owner",
  "institution.learningPaths.transferModalHint":
    "The selected account becomes the owner; referenced library media (e.g. cover) moves when traceable in the database.",
  "institution.learningPaths.transferPickUser": "New owner",
  "institution.learningPaths.transferSubmit": "Confirm transfer",
  "institution.learningPaths.transferLoadingUsers": "Loading accounts…",
  "institution.learningPaths.transferNoCandidates": "No other collaborator available",
  "institution.learningPaths.transferError": "Transfer failed",
  "institution.learningPaths.transferSuccess": "Owner updated",
  "institution.learningPaths.empty": "No path found",
  "institution.supports.title": "Podcasts",
  "institution.supports.subtitle": "Podcasts and audio content",
  "institution.supports.searchPh": "Search a podcast…",
  "institution.supports.empty": "No podcast found",
  "institution.supports.typeDictation": "Dictation",
  "institution.supports.typeText": "Text",
  "institution.supports.typeAi": "AI",
  "institution.supports.transferOwner": "Reassign podcast creator",
  "institution.supports.transferModalTitle": "Change podcast owner",
  "institution.supports.transferModalHint":
    "The selected account becomes the podcast creator; episodes and referenced library media move when traceable in the database.",
  "institution.supports.transferPickUser": "New creator",
  "institution.supports.transferSubmit": "Confirm transfer",
  "institution.supports.transferLoadingUsers": "Loading accounts…",
  "institution.supports.transferNoCandidates": "No other collaborator available",
  "institution.supports.transferError": "Transfer failed",
  "institution.supports.transferSuccess": "Creator updated",
  "institution.categories.title": "Категории",
  "institution.categories.subtitle": "Organize your courses by topic",
  "institution.categories.add": "Add",
  "institution.categories.edit": "Edit category",
  "institution.categories.new": "New category",
  "institution.categories.usage": "{{count}} course(s)",
  "institution.categories.pageSubtitle": "Organize your content by category",
  "institution.categories.namePlaceholder": "Category name",
  "institution.categories.color": "Color",
  "institution.categories.descShortPh": "Short description",
  "institution.categories.usageTimes": "({{count}} uses)",
  "institution.templates.title": "Шаблоны блоков",
  "institution.templates.subtitle": "Reusable template library",
  "institution.templates.statTotal": "Templates",
  "institution.templates.statUsage": "Total uses",
  "institution.templates.mostUsed": "Most used type",
  "institution.templates.preview": "Preview",
  "institution.templates.searchPh": "Search a template…",
  "institution.templates.copySuffix": " (copy)",
  "institution.templates.empty": "No templates found",
  "institution.templates.loadFormatError": "Could not load templates (invalid server response).",
  "institution.templates.usesShort": "{{count}} uses",
  "institution.templates.filterAll": "All types",
  "institution.blockTypes.text": "Text",
  "institution.blockTypes.quiz": "Quiz",
  "institution.blockTypes.video": "Video",
  "institution.blockTypes.audio": "Audio",
  "institution.blockTypes.image": "Image",
  "institution.blockTypes.document": "Document",
  "institution.blockTypes.code": "Code",
  "institution.blockTypes.discussion": "Discussion",
  "institution.scorm.title": "Импорт SCORM",
  "institution.scorm.subtitle": "Import SCORM 1.2 or 2004 packages",
  "institution.scorm.dropHere": "Drag and drop your SCORM (.zip) file here",
  "institution.scorm.browseHint": "or click to browse",
  "institution.scorm.selectedFile": "Selected file: {{name}}",
  "institution.scorm.startImport": "Start import",
  "institution.scorm.importingNamed": "Import in progress: {{name}}",
  "institution.scorm.analyzing": "Analyzing modules… {{pct}}%",
  "institution.scorm.historyTitle": "Import history",
  "institution.scorm.colFile": "File",
  "institution.scorm.colDate": "Date",
  "institution.scorm.colStatus": "Status",
  "institution.scorm.colModules": "Modules",
  "institution.scorm.colVersion": "Version",
  "institution.scorm.colFlow": "Course",
  "institution.scorm.empty": "No imports yet. Drop a SCORM .zip file above.",
  "institution.scorm.openFlow": "Open",
  "institution.scorm.statusImporting": "Importing…",
  "institution.scorm.statusSuccess": "Success",
  "institution.scorm.statusError": "Error",
  "institution.designers.title": "Сотрудники",
  "institution.designers.subtitle": "Trainers, HR leads, HR staff and administrators for your institution (no more “teacher” wording).",
  "institution.designers.invite": "Invite",
  "institution.designers.statTotal": "Total collaborators",
  "institution.designers.statActiveMonth": "Active this month",
  "institution.designers.statFlows": "Courses created (total)",
  "institution.designers.inviteTitle": "Invite a collaborator",
  "institution.designers.inviteHelp": "Choose a role: Trainer (content / courses), HR lead, HR staff, or Admin (institution administrator on Lyrra).",
  "institution.designers.emailPh": "email@example.com",
  "institution.designers.sendInvite": "Send invitation",
  "institution.designers.loadError": "Unable to load collaborators",
  "institution.designers.inviteFail": "Invitation failed",
  "institution.designers.actionFail": "Action failed",
  "institution.designers.searchPh": "Search by name or email…",
  "institution.designers.colName": "Name",
  "institution.designers.colEmail": "Email",
  "institution.designers.colRole": "Role",
  "institution.designers.colProjects": "Projects",
  "institution.designers.colLastActivity": "Last activity",
  "institution.designers.colStatus": "Status",
  "institution.designers.colActions": "Actions",
  "institution.designers.empty": "No collaborator found",
  "institution.designers.roleAdmin": "Admin",
  "institution.designers.roleTeacher": "Trainer",
  "institution.designers.roleTrainingLead": "Training lead",
  "institution.designers.roleCollaborator": "Collaborator",
  "institution.designers.roleOptFormateur": "Trainer",
  "institution.designers.roleOptDrh": "HR lead",
  "institution.designers.roleOptRh": "HR",
  "institution.designers.roleOptAdmin": "Admin",
  "institution.designers.statusActive": "Active",
  "institution.designers.statusInvited": "Invited",
  "institution.designers.statusSuspended": "Suspended",
  "institution.designers.menuView": "View profile",
  "institution.designers.menuMakeAdmin": "Make admin",
  "institution.designers.menuSuspend": "Suspend",
  "institution.designers.menuRemove": "Remove",
  "institution.billing.title": "Оплата",
  "institution.billing.subtitle": "Subscription, usage and invoices",
  "institution.billing.planLabel": "Current plan",
  "institution.billing.planPro": "Pro",
  "institution.billing.priceExample": "€299",
  "institution.billing.perMonth": "/ month",
  "institution.billing.renewalMock": "Renews on February 1, 2025",
  "institution.billing.featureCollaborators": "10 collaborators",
  "institution.billing.featureLearners": "500 learners",
  "institution.billing.featureStorage": "50 GB storage",
  "institution.billing.featureSupport": "Priority support",
  "institution.billing.featureApi": "MCP API",
  "institution.billing.changePlan": "Change plan",
  "institution.billing.usageCollaborators": "Collaborators",
  "institution.billing.usageLearners": "Learners",
  "institution.billing.usageStorage": "Storage",
  "institution.billing.storageUnit": "GB",
  "institution.billing.cardMasked": "Visa •••• 4242",
  "institution.billing.cardExpires": "Expires {{date}}",
  "institution.billing.invoicesTitle": "Invoices",
  "institution.billing.colRef": "Reference",
  "institution.billing.colDate": "Date",
  "institution.billing.colAmount": "Amount",
  "institution.billing.colStatus": "Status",
  "institution.billing.colPdf": "PDF",
  "institution.billing.invPaid": "Paid",
  "institution.billing.invOpen": "Pending",
  "institution.billing.invDraft": "Draft",
  "institution.billing.invVoid": "Void",
  "institution.billing.invUncollectible": "Uncollectible",
  "institution.mcp.title": "MCP — Model Context Protocol",
  "institution.landing.designerTitle": "Page designer",
  "institution.learners.title": "Учащиеся",
  "institution.learners.searchPh": "Search a learner…",
  "institution.learners.filterStatus": "Status",
  "institution.learners.filterPlaceholder": "Filter",
  "institution.learners.selectedCount": "{{count}} selected",
  "institution.learners.exportSelection": "Export selection",
  "institution.learners.exportAll": "Export all",
  "institution.learners.colLearner": "Learner",
  "institution.learners.colGroup": "Group",
  "institution.learners.colLastActive": "Last activity",
  "institution.learners.colStatus": "Status",
  "institution.learners.empty": "No learner found",
  "institution.learners.countList": "{{count}} learner(s)",
  "institution.learners.subtitle": "{{count}} learner(s) enrolled in your institution",
  "institution.learners.importCsv": "Import CSV",
  "institution.learners.add": "Add",
  "institution.learners.statLearners": "Learners",
  "institution.learners.statActive30": "Active (30d)",
  "institution.learners.statEnrollments": "Enrollments",
  "institution.learners.statCompleted": "Completed courses",
  "institution.learners.statusAll": "All statuses",
  "institution.learners.statusActive": "Active",
  "institution.learners.statusInactive": "Inactive",
  "institution.learners.statusCompleted": "Completed",
  "institution.learners.sheetTitle": "Learner profile",
  "institution.learners.openProfileDetail": "Подробности профиля",
  "institution.learners.groupsCatalogTitle": "Настроенные группы",
  "institution.learners.groupsCatalogSubtitle": "Список из вкладки « Группы » вашей организации.",
  "institution.learners.replacePhoto": "Replace",
  "institution.learners.addPhoto": "Add photo",
  "institution.learners.removePhoto": "Remove",
  "institution.learners.firstName": "First name",
  "institution.learners.lastName": "Last name",
  "institution.learners.save": "Save",
  "institution.learners.deactivate": "Deactivate",
  "institution.learners.reactivate": "Reactivate",
  "institution.learners.lastActivity": "Last activity:",
  "institution.learners.paths": "Paths ({{count}})",
  "institution.learners.noPaths": "No assigned path",
  "institution.learners.noFlowsEnrolled": "No enrolled course",
  "institution.learners.done": "Done",
  "institution.learners.inProgress": "In progress",
  "institution.learners.itemsProgress": "{{done}}/{{total}} items",
  "institution.learners.flows": "Courses",
  "institution.learners.completedF": "Completed",
  "institution.learners.totalTime": "Total time",
  "institution.learners.progress": "Progress",
  "institution.learners.flowDone": "Completed",
  "institution.learners.blocks": "{{visited}}/{{total}} blocks",
  "institution.learners.score": "Score: {{score}}%",
  "institution.learners.sessions": "{{count}} sessions",
  "institution.learners.started": "Started:",
  "institution.learners.ended": "Ended:",
  "institution.learners.lastAccess": "Last access:",
  "institution.learners.podcasts": "Podcasts",
  "institution.learners.noPodcastListen": "No listening recorded",
  "institution.learners.deleteTitle": "Delete this learner?",
  "institution.learners.deleteDesc": "Are you sure you want to permanently delete {{name}} ({{email}})? This cannot be undone and will remove all related data.",
  "institution.learners.deactivateTitle": "Deactivate this learner?",
  "institution.learners.reactivateTitle": "Reactivate this learner?",
  "institution.learners.deactivateDesc": "{{name}} will not be able to access courses while deactivated.",
  "institution.learners.reactivateDesc": "{{name}} will regain access to their courses.",
  "institution.learners.deleteLearner": "Delete this learner",
  "institution.learners.photoUploadError": "Error uploading photo",
  "institution.learners.photoRemoveError": "Error removing photo",
  "institution.learners.service": "Подразделение",
  "institution.learners.serviceHint":
    "Выберите запись из справочника (вкладка «Службы»). Введите текст для фильтрации списка.",
  "institution.learners.serviceSearch": "Поиск службы…",
  "institution.learners.serviceNone": "Без службы",
  "institution.learners.exportSheetLearners": "Learners",
  "institution.learners.exportSheetDetails": "Course details",
  "institution.learners.export.firstName": "First name",
  "institution.learners.export.lastName": "Last name",
  "institution.learners.export.groupCol": "Group",
  "institution.learners.export.enrollments": "Enrolled courses",
  "institution.learners.export.completed": "Completed courses",
  "institution.learners.export.progressPct": "Progress (%)",
  "institution.learners.export.totalMin": "Total time (min)",
  "institution.learners.export.lastAct": "Last activity",
  "institution.learners.export.statusCol": "Status",
  "institution.learners.export.learnerCol": "Learner",
  "institution.learners.export.typeCol": "Type",
  "institution.learners.export.titleCol": "Title",
  "institution.learners.export.blocks": "Blocks visited / Total",
  "institution.learners.export.sessionsDone": "Sessions completed",
  "institution.learners.export.avgScore": "Average score (%)",
  "institution.learners.export.timeMin": "Time spent (min)",
  "institution.learners.export.dateStart": "Start date",
  "institution.learners.export.dateEnd": "End date",
  "institution.learners.export.lastAcc": "Last access",
  "institution.learners.export.typeCourse": "Course",
  "institution.learners.export.typePath": "Path",
  "institution.reminders.openPanel": "Напоминания по электронной почте",
  "institution.reminders.panelTitle": "Напоминания",
  "institution.reminders.panelSubtitle":
    "Автоматические уведомления по электронной почте для затронутых учащихся. Проверка каждый час в выбранный момент UTC. Каждое правило не чаще одного раза на учащегося.",
  "institution.reminders.sectionRules": "Правила",
  "institution.reminders.sectionLogs": "Журнал отправок",
  "institution.reminders.addRule": "Добавить оповещение",
  "institution.reminders.removeRule": "Удалить это оповещение",
  "institution.reminders.save": "Сохранить правила",
  "institution.reminders.loadError": "Не удалось загрузить напоминания.",
  "institution.reminders.saveError": "Не удалось сохранить.",
  "institution.reminders.rulesEmpty":
    "Нет оповещений. Добавьте правило или сохраните пустой список, чтобы отключить все напоминания для этого контента.",
  "institution.reminders.logsEmpty": "Пока нет записей об отправках.",
  "institution.reminders.utcHint":
    "Выберите час UTC (0–23), когда сервер проверяет это правило. Напр. 8 UTC ≈ 9:00 зимой в Париже.",
  "institution.reminders.fieldKind": "Тип оповещения",
  "institution.reminders.fieldDays": "Дней после опорного события",
  "institution.reminders.fieldHourUtc": "Час проверки (UTC)",
  "institution.reminders.fieldEnabled": "Включить это оповещение",
  "institution.reminders.fieldLabel": "Внутренняя метка (необязательно)",
  "institution.reminders.fieldLabelPh": "напр. напоминание Д+3",
  "institution.reminders.ruleKind.eduflow_not_started_days_after_enroll":
    "Курс: не начат X дней после записи (карточка участника)",
  "institution.reminders.ruleKind.eduflow_incomplete_days_after_deadline":
    "Курс: не завершён X дней после дедлайна потока",
  "institution.reminders.ruleKind.path_incomplete_days_after_assign":
    "Траектория: не завершена X дней после назначения учащемуся",
  "institution.pages.brandingTitle": "Визуальная идентичность",
  "institution.pages.webhooksTitle": "Webhooks",
  "institution.pages.landingTitle": "Публичная страница",
  },
  ar: {
    ...institutionRhCompetenciesStrings.ar,
    "institution.tabs.home": "الرئيسية",
    "institution.tabs.groups": "المجموعات",
    "institution.tabs.services": "الخدمات",
    "institution.services.title": "خدمات المؤسسة",
    "institution.services.subtitle":
      "دليل خدمات أو وحدات المؤسسة (الموارد البشرية، المالية، وغيرها). عيِّن المتعلّمين من ملفّهم الشخصي.",
    "institution.services.create": "خدمة جديدة",
    "institution.services.loadError": "تعذّر تحميل الخدمات.",
    "institution.services.empty":
      "لا توجد خدمات بعد. أنشِئ خدمة لربط المتعلّمين بها عند الإسناد.",
    "institution.services.modalCreate": "إنشاء خدمة",
    "institution.services.modalEdit": "تعديل الخدمة",
    "institution.services.fieldName": "اسم الخدمة",
    "institution.services.deleteConfirm":
      "حذف هذه الخدمة؟ سيُزال الارتباط عن المتعلّمين المعنيّين.",
    "institution.services.listSubtitle": "{{count}} خدمة في مؤسستك",
    "institution.services.intro":
      "دليل خدمات أو وحدات المؤسسة (الموارد البشرية، المالية، وغيرها). عيِّن المتعلّمين من ملفّهم الشخصي.",
    "institution.services.statTotal": "الخدمات",
    "institution.services.statWithDesc": "مع وصف",
    "institution.services.statNoDesc": "بدون وصف",
    "institution.services.searchPh": "البحث عن خدمة…",
    "institution.services.colService": "الخدمة",
    "institution.services.colCreated": "تاريخ الإنشاء",
    "institution.services.emptyNone": "لا توجد خدمات بعد. أنشئ الخدمة الأولى.",
    "institution.services.emptyFilter": "لا توجد خدمات مطابقة للبحث.",
    "institution.services.countShown": "{{count}} خدمة",
    "institution.learners.service": "الخدمة",
    "institution.learners.serviceHint":
      "اختر سجلًا من الدليل (تبويب «الخدمات»). اكتب لتصفية القائمة.",
    "institution.learners.serviceSearch": "البحث عن خدمة…",
    "institution.learners.serviceNone": "بلا خدمة",
    "institution.learners.openProfileDetail": "تفاصيل الملف الشخصي",
    "institution.learners.groupsCatalogTitle": "المجموعات المُعرّفة",
    "institution.learners.groupsCatalogSubtitle": "القائمة المعرّفة في تبويب « المجموعات » لمؤسستك.",
    "institution.reminders.openPanel": "تذكيرات البريد الإلكتروني",
    "institution.reminders.panelTitle": "التذكيرات",
    "institution.reminders.panelSubtitle":
      "إشعارات تلقائية بالبريد الإلكتروني إلى المتعلّمين المعنيّين. تُجرى عملية تحقّق كلّ ساعة في الساعة المختارة بتوقيت UTC. كل قاعدة تُطبَّق مرّة واحدة كحدّ أقصى لكل متعلّم.",
    "institution.reminders.sectionRules": "القواعد",
    "institution.reminders.sectionLogs": "سجل الإرسال",
    "institution.reminders.addRule": "إضافة تنبيه",
    "institution.reminders.removeRule": "حذف هذا التنبيه",
    "institution.reminders.save": "حفظ القواعد",
    "institution.reminders.loadError": "تعذّر تحميل التذكيرات.",
    "institution.reminders.saveError": "تعذّر الحفظ.",
    "institution.reminders.rulesEmpty":
      "لا توجد تنبيهات. أضِف قاعدة أو احفظ قائمة فارغة لتعطيل كل التذكيرات لهذا المحتوى.",
    "institution.reminders.logsEmpty": "لا توجد عمليات إرسال مسجّلة بعد.",
    "institution.reminders.utcHint":
      "اختَر الساعة بتوقيت UTC (٠–٢٣) التي يتحقّق فيها الخادم من هذه القاعدة. مثال: ٨ UTC ≈ التاسعة صباحًا شتاءً في باريس تقريبًا.",
    "institution.reminders.fieldKind": "نوع التنبيه",
    "institution.reminders.fieldDays": "أيّام بعد الحدث المرجعي",
    "institution.reminders.fieldHourUtc": "ساعة التحقّق (UTC)",
    "institution.reminders.fieldEnabled": "تفعيل هذا التنبيه",
    "institution.reminders.fieldLabel": "تسمية داخلية (اختياري)",
    "institution.reminders.fieldLabelPh": "مثال: تذكير اليوم +٣",
    "institution.reminders.ruleKind.eduflow_not_started_days_after_enroll":
      "تدريب: لم يبدأ بعد X أيام من التسجيل (إنشاء سجل المشارك)",
    "institution.reminders.ruleKind.eduflow_incomplete_days_after_deadline":
      "تدريب: غير مكتمل بعد X أيام من الموعد النهائي للمسار",
    "institution.reminders.ruleKind.path_incomplete_days_after_assign":
      "مسار تعليمي: غير مكتمل بعد X أيام من الإسناد للمتعلّم",
  "institution.tabs.webinars": "الندوات عبر الإنترنت",
  "institution.tabs.webinarsPilotage": "إدارة الندوات",
  "institution.webinars.pageTitle": "إعدادات الندوات",
  "institution.webinars.settingsIntro":
    "فعّل الوحدة وحدّد رسالة غرفة الانتظار الافتراضية. تُدار قائمة الندوات والمقدّمون المصرّح لهم من تبويب « {{tabName}} ».",
  "institution.webinars.enableForInstitution": "تفعيل الندوات للمؤسسة",
  "institution.webinars.enabledBadge": "الوحدة مفعّلة",
  "institution.webinars.disabledBadge": "الوحدة معطّلة",
  "institution.webinars.sectionModule": "التفعيل",
  "institution.webinars.sectionModuleHint": "يسمح لمدرّبي المؤسسة بإنشاء جلسات مباشرة وإدارتها.",
  "institution.webinars.sectionWaitingRoom": "غرفة الانتظار",
  "institution.webinars.waitingHtmlLabel": "HTML غرفة الانتظار (افتراضي)",
  "institution.webinars.waitingHtmlPlaceholder": "<p>رسالة الترحيب…</p>",
  "institution.webinars.waitingHtmlHint": "HTML بسيط يُعرض للمشاركين قبل البدء. الألوان تتبع هوية هذا الفضاء.",
  "institution.webinars.openPilotage": "فتح إدارة الندوات",
  "institution.webinars.waitingPreviewTitle": "معاينة — رسالة الانتظار",
  "institution.webinars.waitingPreviewHint": "كما يراها المشاركون قبل بدء الندوة.",
  "institution.webinars.loadError": "تعذّر تحميل إعدادات الندوات.",
  "institution.webinars.saveSuccess": "تم حفظ إعدادات الندوات.",
  "institution.webinars.saveError": "تعذّر الحفظ.",
  "institution.common.saving": "جارٍ الحفظ…",
  },
  tr: {
    ...institutionRhCompetenciesStrings.tr,
  "institution.tabs.webinars": "Webinarlar",
  "institution.tabs.webinarsPilotage": "Webinar yönetimi",
  "institution.webinars.pageTitle": "Webinar ayarları",
  "institution.webinars.settingsIntro":
    "Modülü etkinleştirin ve varsayılan bekleme odası mesajını tanımlayın. Webinar listesi ve yetkili sunucular « {{tabName}} » sekmesinden yönetilir.",
  "institution.webinars.enableForInstitution": "Kurum için webinarları etkinleştir",
  "institution.webinars.enabledBadge": "Modül etkin",
  "institution.webinars.disabledBadge": "Modül kapalı",
  "institution.webinars.sectionModule": "Etkinleştirme",
  "institution.webinars.sectionModuleHint": "Kurum eğitmenlerinin canlı oturum oluşturup yönetmesine izin verir.",
  "institution.webinars.sectionWaitingRoom": "Bekleme odası",
  "institution.webinars.waitingHtmlLabel": "Bekleme odası HTML (varsayılan)",
  "institution.webinars.waitingHtmlPlaceholder": "<p>Karşılama mesajınız…</p>",
  "institution.webinars.waitingHtmlHint":
    "Oturum başlamadan önce katılımcılara gösterilen basit HTML. Renkler bu alanın temasını izler.",
  "institution.webinars.openPilotage": "Webinar yönetimini aç",
  "institution.webinars.waitingPreviewTitle": "Önizleme — bekleme mesajı",
  "institution.webinars.waitingPreviewHint": "Katılımcıların webinar başlamadan önce gördüğü görünüm.",
  "institution.webinars.loadError": "Webinar ayarları yüklenemedi.",
  "institution.webinars.saveSuccess": "Webinar ayarları kaydedildi.",
  "institution.webinars.saveError": "Kaydedilemedi.",
  "institution.common.saving": "Kaydediliyor…",
  },
};